PJQ.collections.invoicing = {};

PJQ.models.invoicing = {};

PJQ.views.invoicing = {};

PJQ.modules.invoicing = {
    routes: [
        {
            route: 'projects/:projectId/invoicing',
            name: 'invoicing',
            callback: function (projectId) {
                PJQ.modules.projectWall.initProjectNavigator(parseInt(projectId), "invoicing");
            }
        },
        {
            route: 'projects/:projectId/invoicing/payable',
            name: 'payableinvoices',
            callback: function (projectId) {
                PJQ.modules.projectWall.initProjectNavigator(parseInt(projectId), "invoicing", {
                    view: 'payable'
                });
            }
        },
        {
            route: 'projects/:projectId/invoicing/payable/:invoiceId',
            name: 'commitment',
            callback: function (projectId, invoiceId) {
                PJQ.modules.projectWall.initProjectNavigator(parseInt(projectId), "invoicing", {
                    invoiceId: parseInt(invoiceId),
                    view: 'payable'
                });
            }
        },
        {
            route: 'projects/:projectId/invoicing/payable/payments/:paymentId',
            name: 'commitment',
            callback: function (projectId, paymentId) {
                PJQ.modules.projectWall.initProjectNavigator(parseInt(projectId), "invoicing", {
                    paymentId: parseInt(paymentId),
                    view: 'payable'
                });
            }
        },
        {
            route: 'projects/:projectId/invoicing/receivable',
            name: 'receivable',
            callback: function (projectId) {
                PJQ.modules.projectWall.initProjectNavigator(parseInt(projectId), "invoicing", {
                    view: 'receivable'
                });
            }
        },
        {
            route: 'projects/:projectId/invoicing/receivable/:invoiceId',
            name: 'commitment',
            callback: function (projectId, invoiceId) {
                PJQ.modules.projectWall.initProjectNavigator(parseInt(projectId), "invoicing", {
                    invoiceId: parseInt(invoiceId),
                    view: 'receivable'
                });
            }
        },
        {
            route: 'projects/:projectId/invoicing/receivable/payments/:paymentId',
            name: 'commitment',
            callback: function (projectId, paymentId) {
                PJQ.modules.projectWall.initProjectNavigator(parseInt(projectId), "invoicing", {
                    paymentId: parseInt(paymentId),
                    view: 'receivable'
                });
            }
        },
        {
            route: 'projects/:projectId/invoicing/billingperiods',
            name: 'invoicing',
            callback: function (projectId) {
                PJQ.modules.projectWall.initProjectNavigator(parseInt(projectId), "invoicing", {
                    view: 'billingperiods'
                });
            }
        }
    ]
};

PJQ.app.addRoutes(PJQ.modules.invoicing.routes);

//Models
PJQ.models.invoicing.BillingPeriodSettings = PJQ.models.BaseModel.extend({
    defaults: {
        isAPIv2: true
    },
    idAttribute: 'id',
    endpoint: function () {
        return PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'projects',
                value: this.options.projectId
            },
            {
                endpoint: 'billingperiods'
            },
            {
                endpoint: 'settings'
            }
        ]);
    },
    parse: function (model) {
        if (!model)
            return model;

        this.billingPeriods = new PJQ.collections.budget.BillingPeriods(model.billingPeriods);

        return model;
    },
});

PJQ.models.invoicing.BillingPeriod = PJQ.models.BaseModel.extend({
    defaults: {
        isAPIv2: true
    },
    idAttribute: 'id',
    endpoint: function () {
        return PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'projects',
                value: this.options.projectId
            },
            {
                endpoint: 'billingperiods',
                value: this.id
            }
        ]);
    },
});

//Collections
PJQ.collections.invoicing.BillingPeriods = PJQ.collections.BaseCollection.extend({
    defaults: {
        isAPIv2: true
    },
    model: PJQ.models.invoicing.BillingPeriod
});
PJQ.views.invoicing.BillingPeriodSettingsModal = PJQ.views.BaseModal.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.INVOICING, 'modal-billing-period-settings'),
        minWidth: '600px',
        isEditPeriod: false
    },
    events: {
        'click .btn-save': 'save',
        'click .btn-close': 'close',
        'click .btn-automated': 'toggleAutomated'
    },
    beforeModalCreated: function () {
        this.isFetched = false;
        PJQ.app.session.project.fetchBillingPeriodSettings(_.bind(function (settings) {
            this.settings = settings;
            this.isFetched = true;
            this.render();
        }, this));
    },
    renderData: function () {
        return {
            settings: this.settings
        }
    },
    afterRender: function () {
        if (!this.isFetched)
            return;

        new PJQ.Binder(this.$el, this.settings, {
            watchElements: [
                'input'
            ]
        });

        PJQ.helpers.inputHelpers.inputMaskInteger(this.$('.end-day-offset'));
        PJQ.helpers.inputHelpers.inputMaskInteger(this.$('.due-day-offset'));

        new PJQ.inputs.Selectpicker({
            el: this.$('.select-frequency'),
            defaultValue: this.settings.get('frequency'),
            isMultiple: false,
            isIntChoices: true,
            onChange: _.bind(function (value) {
                this.settings.set({
                    frequency: value,
                    startDay: null,
                    endDay: null,
                    dueDay: null,
                })
                this.render();
            }, this)
        });

        this.startDayPicker = new PJQ.inputs.Selectpicker({
            el: this.$('.select-start-date'),
            defaultValue: this.settings.get('startDay'),
            isMultiple: false,
            isIntChoices: true,
            choices: this.getStartEndDateChoices(),
            onChange: _.bind(function (value) {
                this.settings.set('startDay', value);
            }, this)
        });

        this.endDayPicker = new PJQ.inputs.Selectpicker({
            el: this.$('.select-end-date'),
            defaultValue: this.settings.get('endDay'),
            isMultiple: false,
            isIntChoices: true,
            choices: this.getStartEndDateChoices(),
            onChange: _.bind(function (value) {
                this.settings.set('endDay', value);
            }, this)
        });

        this.dueDayPicker = new PJQ.inputs.Selectpicker({
            el: this.$('.select-due-date'),
            defaultValue: this.settings.get('dueDay'),
            isMultiple: false,
            isIntChoices: true,
            choices: this.getStartEndDateChoices(true),
            onChange: _.bind(function (value) {
                this.settings.set('dueDay', value);
            }, this)
        });
    },
    // toggleAutomated: function() {
    //     this.settings.set('automated', !this.settings.get('automated'));
    //     if(!this.settings.get('automated')){
    //         this.settings.save(null, {
    //             success: _.bind(function () {
    //                 this.render();
    //             }, this)
    //         })
    //     }
    //     else {
    //         this.render();
    //     }
    // },
    save: function () {
        if (!this.validate())
            return;

        this.settings.save(null, {
            success: _.bind(function (res) {
                PJQ.notifications.notify.successNotify({
                    message: 'Billing Period Settings saved successfully'
                });

                if (typeof this.options.onSave === 'function') {
                    this.options.onSave();
                }
                this.removeModal();
            }, this)
        });
    },
    getStartEndDateChoices: function () {
        let choices = [];
        if (this.settings.get('frequency') === 0) {
            // Monthly
            let date = new Date();
            let daysInMonth = 30;
            for (let i = 0; i < daysInMonth; i++) {
                choices.push({
                    id: i + 1,
                    name: PJQ.helpers.formatHelpers.getOrdinalSuffix(i + 1)
                });
            }

            choices.push({
                id: 31,
                name: 'Last Day'
            });
        } else {
            // Weekly
            for (let i = 0; i < 7; i++) {
                choices.push({
                    id: i,
                    name: PJQ.helpers.dateHelpers.getDayName(i)
                });
            }
        }
        return choices;
    },
    validate: function () {
        let isValid = true;

        if (this.settings.get('startDay') == null) {
            this.startDayPicker.showError('Start Day is Required');
            isValid = false;
        }

        if (this.settings.get('endDay') == null) {
            this.endDayPicker.showError('End Day is Required');
            isValid = false;
        }

        if (this.settings.get('dueDay') == null) {
            this.dueDayPicker.showError('Due Day is Required');
            isValid = false;
        }

        return isValid
    },
    close: function () {
        if (typeof this.options.onClose === 'function') {
            this.options.onClose();
        }
        this.removeModal();
    }
});

PJQ.views.invoicing.EditBillingPeriodModal = PJQ.views.BaseModal.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.INVOICING, 'modal-edit-billing-period'),
        minWidth: '600px',
        isEditPeriod: false
    },
    events: {
        'click .btn-save': 'save'
    },
    beforeModalCreated: function () {
        this.isFetched = false;
        if (this.model == null) {
            this.model = new PJQ.models.budget.BillingPeriod(null, {
                projectId: PJQ.app.session.project.id
            });
        }
        PJQ.app.session.project.fetchBillingPeriodSettings(_.bind(function (settings) {
            this.settings = settings;
            this.isFetched = true;
            this.render();
        }, this));
    },
    renderData: function () {
        return {
            model: this.model,
            settings: this.settings
        }
    },
    afterRender: function () {
        if (!this.isFetched)
            return

        new PJQ.Binder(this.$el, this.settings, {
            watchElements: [
                'input'
            ]
        });

        new PJQ.inputs.Datepicker({
            el: this.$('.period-start'),
            datepickerOptions: {
                format: PJQ.helpers.dateHelpers.dateFormats.datePicker.DATE,
                defaultDate: PJQ.helpers.dateHelpers.parseDateString(this.model.get('startDate'), false)
            },
            onChange: _.bind(function (newDate) {
                this.model.set('startDate', newDate);
            }, this)
        });

        new PJQ.inputs.Datepicker({
            el: this.$('.period-end'),
            datepickerOptions: {
                format: PJQ.helpers.dateHelpers.dateFormats.datePicker.DATE,
                defaultDate: PJQ.helpers.dateHelpers.parseDateString(this.model.get('endDate'), false)
            },
            onChange: _.bind(function (newDate) {
                this.model.set('endDate', newDate);
            }, this)
        });

        new PJQ.inputs.Datepicker({
            el: this.$('.due-date'),
            datepickerOptions: {
                format: PJQ.helpers.dateHelpers.dateFormats.datePicker.DATE,
                defaultDate: PJQ.helpers.dateHelpers.parseDateString(this.model.get('dueDate'), false)
            },
            onChange: _.bind(function (newDate) {
                this.model.set('dueDate', newDate);
            }, this)
        });
    },
    save: function () {
        let isNew = this.model.isNew();
        this.model.save(null, {
            success: _.bind(function () {
                this.removeModal();
                if (typeof this.options.onSave === 'function') {
                    this.options.onSave(isNew ? this.model : null);
                }
                PJQ.notifications.notify.successNotify({
                    message: 'Billing Period successfully saved'
                });
            }, this)
        })
    }
});

PJQ.views.invoicing.BillingPeriodsList = PJQ.views.BaseView.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.INVOICING, 'billing-periods-list')
    },
    events: {
        'click .edit-period': 'editBillingPeriodClicked',
        'click .delete-period': 'deleteBillingPeriodClicked',
        'click .btn-billing-period-settings': 'billingPeriodSettings',
        'click .btn-add-billing-period': 'addBillingPeriod',
        'click .toggle-automated': 'toggleAutomated'
    },
    beforeFirstRender: function () {
        this.options.isEdit = false;
    },
    renderData: function () {
        return {
            isEdit: this.options.isEdit
        }
    },
    afterRender: function () {
        if (this.model.billingPeriods) {
            this.dataTable = new PJQ.views.dataTables.DataTable({
                el: this.$(".billing-periods-table"),
                data: this.model.billingPeriods.models,
                rowId: "cid",
                subTemplates: {
                    header: new PJQ.templating.Template(PJQ.constants.modules.INVOICING, 'data-table-header-billing-periods')
                },
                headerData: {
                    settings: this.model
                },
                afterHeaderRender: _.bind(function (view, $header) {

                }, this),
                order: [1, 'desc'],
                language: {
                    zeroRecords: 'No Billing Periods currently exist'
                },
                pageLength: 25,
                onRowDoubleClick: _.bind(function (row) {
                    this.editBillingPeriod(row.data());
                }, this),
                contextMenuOptions: {
                    actions: [
                        {
                            name: 'Edit',
                            onClick: (row) => {
                                this.editBillingPeriod(row.data());
                            },
                            isShown: (row) => {
                                return !row.data().get('automated');
                            }
                        },
                        // {
                        //     name: 'Open Period',
                        //     onClick: _.bind(function (row) {
                        //         this.openBillingPeriod(row.data());
                        //     }, this),
                        //     isShown: _.bind(function (row) {
                        //         return !row.data().get('automated') && !row.data().get('isOpen');
                        //     }, this)
                        // },
                        // {
                        //     name: 'Close Period',
                        //     onClick: _.bind(function (row) {
                        //         this.closeBillingPeriod(row.data());
                        //     }, this),
                        //     isShown: _.bind(function (row) {
                        //         return !row.data().get('automated') && row.data().get('isOpen');
                        //     }, this)
                        // },
                        {
                            name: 'Delete',
                            isDanger: true,
                            onClick: (row) => {
                                this.deleteBillingPeriod(row.data());
                            }
                        }
                    ]
                },
                columns: [
                    {
                        "title": "",
                        "data": "attributes.isCurrent",
                        "width": "3%",
                        "orderable": true,
                        "render": (data, type, row) => {
                            if (type === 'sort' || type === 'type') {
                                return data;
                            }

                            let icons = [];
                            if (data) {
                                icons.push("<i class='fal fa-check text-success fs-18 mr-2' title='Active Billing Period'></i>");
                            }
                            return '<div class="d-flex justify-content-center">' + icons.join('') + '</div>';
                        }
                    },
                    {
                        "title": "Start Date",
                        "data": "attributes.startDate",
                        "orderable": true,
                        "render": (data, type, row) => {
                            if (type === 'sort' || type === 'type') {
                                return new Date(data);
                            }

                            return PJQ.helpers.dateHelpers.getDateString(new Date(data), PJQ.helpers.dateHelpers.dateFormats.DATE, true);
                        }
                    },
                    {

                        "title": 'End Date',
                        "data": "attributes.endDate",
                        "render": (data, type, row) => {
                            if (type === 'sort' || type === 'type') {
                                return new Date(data);
                            }

                            return PJQ.helpers.dateHelpers.getDateString(new Date(data), PJQ.helpers.dateHelpers.dateFormats.DATE, true);
                        }
                    },
                    {
                        "title": 'Due Date',
                        "data": "attributes.dueDate",
                        "render": (data, type, row) => {
                            if (type === 'sort' || type === 'type') {
                                return new Date(data);
                            }
                            return PJQ.helpers.dateHelpers.getDateString(new Date(data), PJQ.helpers.dateHelpers.dateFormats.DATE, true);
                        }
                    },
                    {
                        "data": "",
                        "title": "",
                        "orderable": false,
                        "searchable": false,
                        resizable: false,
                        "width": "120px",
                        "render": (data, type, row) => {
                            let html = '<div class="text-align-right show-on-row-hover" style="min-width:120px;">'
                            if (!row.get('automated')) {
                                html += '<button type="button" class="btn btn-info edit-period ht-30p wd-35p ml-1 fs-14"><span class="fal fa-pencil"></span></button>'

                                if(!row.get('isCurrent')){
                                    html += '<button type="button" class="btn btn-success open-period ht-30p wd-35p ml-1 fs-14" title="Set as Current"><span class="fal fa-check-circle"></span></button>'
                                }
                            }
                            html += '<button type="button" class="btn btn-danger delete-period ht-30p wd-35p ml-1 fs-14"><span class="fal fa-trash"></span></button>'
                            return html + '</div>'
                        }
                    }
                ]
            });
        }
    },
    // openBillingPeriod: function (billingPeriod) {
    //     if(billingPeriod.get('isOpen'))
    //         return;
    //
    //     let fnCallback = () => {
    //         _.each(this.model.billingPeriods.models, (period) => {
    //             if(period.get('isOpen')){
    //                 period.set('isOpen', false);
    //             }
    //         });
    //
    //         billingPeriod.set('isOpen', true);
    //         this.dataTable.refresh();
    //     }
    //
    //
    //     new PJQ.views.modals.YesNo({
    //         header: "Send Contact Updater",
    //         body: "Opening this period will close any other open periods. Are you sure you want to open this period?",
    //         onYes: _.bind(function () {
    //             billingPeriod.openPeriod(fnCallback);
    //         }, this)
    //     });
    // },
    // closeBillingPeriod: function (billingPeriod) {
    //     if(!billingPeriod.get('isOpen'))
    //         return;
    //
    //     let fnCallback = () => {
    //         billingPeriod.set('isOpen', false);
    //         this.dataTable.refresh();
    //     }
    //
    //     new PJQ.views.modals.YesNo({
    //         header: "Send Contact Updater",
    //         body: "Closing this period will leave no open periods. Are you sure you want to close this period?",
    //         onYes: _.bind(function () {
    //             billingPeriod.closePeriod(fnCallback);
    //         }, this)
    //     });
    // },
    billingPeriodSettings: function () {
        new PJQ.views.invoicing.BillingPeriodSettingsModal({
            settings: this.model,
            onSave: _.bind(function () {
                this.render();
            }, this)
        });
    },
    addBillingPeriod: function () {
        new PJQ.views.invoicing.EditBillingPeriodModal({
            onSave: _.bind(function (billingPeriod) {
                if (billingPeriod != null) {
                    this.model.billingPeriods.add(billingPeriod);
                    this.dataTable.addRow(billingPeriod);
                }
                this.dataTable.refresh();
            }, this)
        });
    },
    editBillingPeriodClicked: function (e) {
        let target = $(e.currentTarget),
            row = this.dataTable.getRow(target.closest('tr'));
        this.editBillingPeriod(row.data());
    },
    editBillingPeriod: function (period) {
        if (!period.get('automated')) {
            new PJQ.views.invoicing.EditBillingPeriodModal({
                model: period,
                onSave: _.bind(function () {
                    this.dataTable.refresh();
                }, this)
            });
        }
    },
    toggleAutomated: function () {
        if (this.model.get('automated')) {
            this.model.set('automated', false);
            this.model.save(null, {
                success: _.bind(function () {
                    PJQ.notifications.notify.successNotify({
                        message: 'Automated Billing Periods Disabled'
                    });
                    this.render();
                }, this)
            });
        } else {
            this.model.set('automated', true);
            new PJQ.views.invoicing.BillingPeriodSettingsModal({
                settings: this.model,
                onSave: (billingPeriod) => {
                    PJQ.notifications.notify.successNotify({
                        message: 'Automated Billing Periods Enabled'
                    });

                    this.render();
                },
                onClose: () => {
                    this.model.set('automated', false);
                    this.$('.toggle-automated').prop('checked', false);
                }
            });
        }
    },
    deleteBillingPeriodClicked: function (e) {
        let target = $(e.currentTarget),
            row = this.dataTable.getRow(target.closest('tr'));
        this.deleteBillingPeriod(row.data());
    },
    deleteBillingPeriod: function (period) {
        let row = this.dataTable.getRow(period.cid);
        new PJQ.views.modals.DeleteCancel({
            header: "Delete Billing Period",
            body: "Are you sure you want to delete this Billing Period?",
            onDelete: _.bind(function () {
                period.destroy({
                    success: _.bind(function () {
                        this.dataTable.removeRow(row);
                    }, this)
                });
            }, this)
        });
    }
});
PJQ.models.invoicing.Invoice = PJQ.models.BaseModel.extend({
    defaults: {
        isAPIv2: true
    },
    idAttribute: 'id',
    getSummary: function(callback){
        this.beforeSave();
        new PJQ.ajax.Request({
            endpoint: this.endpoint() + '/summary',
            isAPIv2: true,
            data: this.toJSON()
        }).post().done(_.bind(function (response) {
            if(typeof callback === 'function'){
                callback(response);
            }
        }, this)).fail(_.bind(function (response) {

        }, this));
    },
    beforeSave: function () {
        this.set({
            lineItems: this.lineItems.toJSON(),
            attachments: this.attachments.getChangedModels()
        });
    },
    fetchPossibleLineItems: function (callback) {
        let fnCallback = _.bind(function(){
            if(typeof callback === 'function'){
                callback(this.possibleLineItems);
            }
        }, this)
        if(this.possibleLineItems != null){
            fnCallback();
        }
        else{
            new PJQ.ajax.Request({
                endpoint: this.endpoint() + '/lineitemoptions',
                isAPIv2: true
            }).get().done(_.bind(function (response) {
                let coll;
                if(this instanceof PJQ.models.invoicing.PayableInvoice){
                    coll = PJQ.collections.invoicing.PayableInvoiceLineItems;
                }
                else{
                    coll = PJQ.collections.invoicing.ReceivableInvoiceLineItems;
                }
                this.possibleLineItems  = new coll(response);
                fnCallback();
            }, this)).fail(_.bind(function () {
                fnCallback();
            }, this));
        }
    },
    getSubTotal: function () {
        return this.get('amount');
    },
    getRetainage: function () {
        return this.get('workRetainage') + this.get('materialRetainage');
    },
    getRetainageReleased: function () {
        return this.get('workRetainageReleased') + this.get('materialRetainageReleased');
    },
    getGrandTotal: function () {
        return this.getSubTotal() + this.get('taxAmount');
    }
});

PJQ.models.invoicing.InvoiceLineItem = PJQ.models.BaseModel.extend({
    defaults: {
        isAPIv2: true
    },
    idAttribute: 'id',
    parse: function(model) {
        if(!model)
            return model;

        if (model && model.group) {
            this.group = new PJQ.models.groups.Group(model.group);
        }
        else
            this.group = null;

        return model;
    },
    getWorkRetainageRemaining: function(invoice){
        let wRetain = (this.get('workRetainageTotal') - this.get('workRetainageReleasedTotal'));
        if(invoice == null || (invoice.get('statusId') !== PJQ.constants.invoicing.payableInvoiceStatus.APPROVED && invoice.get('statusId') !== PJQ.constants.invoicing.payableInvoiceStatus.COMPLETE)){
            wRetain += this.get('workRetainage') - this.get('workRetainageReleased');
        }
        return wRetain;
    },
    getMaterialRetainageRemaining: function(invoice){
        let mRetain = (this.get('materialRetainageTotal') - this.get('materialRetainageReleasedTotal'));
        if(invoice == null || (invoice.get('statusId') !== PJQ.constants.invoicing.payableInvoiceStatus.APPROVED && invoice.get('statusId') !== PJQ.constants.invoicing.payableInvoiceStatus.COMPLETE)){
            mRetain += this.get('materialRetainage') - this.get('materialRetainageReleased');
        }
        return mRetain;
    },
    getWorkRetainageTotal: function(invoice){
        let wRetain = (this.get('workRetainageTotal') - this.get('workRetainageReleasedTotal'));
        if(invoice == null || (invoice.get('statusId') !== PJQ.constants.invoicing.payableInvoiceStatus.APPROVED && invoice.get('statusId') !== PJQ.constants.invoicing.payableInvoiceStatus.COMPLETE)){
            wRetain += this.get('workRetainage');
        }
        return wRetain;
    },
    getMaterialRetainageTotal: function(invoice){
        let mRetain = (this.get('materialRetainageTotal') - this.get('materialRetainageReleasedTotal'));
        if(invoice == null || (invoice.get('statusId') !== PJQ.constants.invoicing.payableInvoiceStatus.APPROVED && invoice.get('statusId') !== PJQ.constants.invoicing.payableInvoiceStatus.COMPLETE)){
            mRetain += this.get('materialRetainage');
        }
        return mRetain;
    },
    getProgressAmountTotal: function(invoice){
        let progressAmount = this.get('progressAmountTotal');
        if(invoice == null || (invoice.get('statusId') !== PJQ.constants.invoicing.payableInvoiceStatus.APPROVED && invoice.get('statusId') !== PJQ.constants.invoicing.payableInvoiceStatus.COMPLETE)){
            progressAmount += this.get('progressAmount');
        }
        return progressAmount
    },
    getTotalCompleteAndStored: function(invoice){
        return this.getProgressAmountTotal(invoice) + this.getMaterialsStored(invoice);
    },
    getBalanceToFinish: function(invoice){
        return this.get('committedAmount') - this.getTotalCompleteAndStored(invoice);
    },
    getMaterialsStored: function(invoice){
        let matStored = this.get('materialsStoredTotal')
        if(invoice == null || (invoice.get('statusId') !== PJQ.constants.invoicing.payableInvoiceStatus.APPROVED && invoice.get('statusId') !== PJQ.constants.invoicing.payableInvoiceStatus.COMPLETE)){
            matStored += this.get('materialsNew');
        }
        return matStored;
    },
    getTaxAmount: function () {
        if(this.get('progressPercent') === 100){
            let taxTotal = this.get('progressTaxAmountTotal'),
                committedTax = this.get('committedTaxAmount');
            return committedTax - taxTotal;
        }

        let taxRate = this.get('taxRate'),
            taxable = this.get('progressAmount') + this.get('materialsNew');
        return Math.round(taxable * (taxRate / 10000));
    },
    getUnRoundedTaxAmount: function () {
        let taxRate = this.get('taxRate'),
            taxable = this.get('progressAmount') + this.get('materialsNew') - this.getRetainage() + this.getRetainageReleased();
        return taxable * (taxRate / 10000);
    },
    getSubTotal: function () {
        return this.get('progressAmount') + this.get('materialsNew');
    },
    getRetainage: function () {
        return this.get('workRetainage') + this.get('materialRetainage');
    },
    getRetainageReleased: function () {
        return this.get('workRetainageReleased') + this.get('materialRetainageReleased');
    },
    getGrandTotal: function () {
        return this.getSubTotal() + this.get('taxAmount') - this.getRetainage() + this.getRetainageReleased();
    },
});

PJQ.collections.invoicing.Invoices = PJQ.collections.BaseCollection.extend({
    defaults: {
        isAPIv2: true
    },
    model: PJQ.models.invoicing.Invoice
});

PJQ.collections.invoicing.InvoiceLineItems = PJQ.collections.BaseCollection.extend({
    defaults: {
        isAPIv2: true
    },
    model: PJQ.models.invoicing.InvoiceLineItem
});
PJQ.views.invoicing.InvoicePaymentModal = PJQ.views.BaseModal.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.INVOICING, 'modal-invoice-payment-edit'),
        maxWidth: 800,
        model: null,
        isShowCloseButton: true,
        onSave: _.noop(),
        onDelete: _.noop(),
        isPayable: false
    },
    events: {
        'click .btn-view-invoice': 'viewInvoice',
        'click .btn-delete': 'delete',
        'click .btn-close': 'close',
        'click .btn-sync-erp': 'syncERP',
        'click .btn-unlink-erp': 'unlinkERP',
        'click .btn-save': 'savePayment',
        'click .btn-export': 'exportPayment'
    },
    beforeModalCreated: function () {
        if(this.options.isPayable) {
            this.options.canViewInvoices = PJQ.app.session.project.hasPermission('payableInvoices.canView');
            this.options.canViewCommitments = PJQ.app.session.project.hasPermission('commitments.canView');
            this.options.isAdmin = PJQ.app.session.project.hasPermission('payableInvoices.isAdmin');
        }
        else{
            this.options.canViewInvoices = PJQ.app.session.project.hasPermission('receivableInvoices.canView');
            this.options.canViewPrimeContracts = PJQ.app.session.project.hasPermission('primeContracts.canView');
            this.options.isAdmin = PJQ.app.session.project.hasPermission('receivableInvoices.isAdmin');
        }

        this.options.canEdit = this.options.isAdmin;
        this.options.canDelete = this.options.isAdmin;

        this.isFetched = false;
        PJQ.app.session.fetchERPIntegration(_.bind(function (erp) {
            this.erpIntegration = erp;

            if (this.model == null) {
                if(this.options.isPayable) {
                    this.model = new PJQ.models.invoicing.PayableInvoicePayment({
                        notes: '',
                        number: '',
                        invoiceId: this.options.invoice.id,
                        invoiceNumber: this.options.invoice.get('number'),
                        projectId: this.options.invoice.get('projectId'),
                        companyId: this.options.invoice.get('companyId'),
                        contractedContact: this.options.invoice.contractedContact,
                        contractedContactId: this.options.invoice.contractedContact ? this.options.invoice.contractedContact.id : null
                    });
                }
                else {
                    this.model = new PJQ.models.invoicing.ReceivableInvoicePayment({
                        notes: '',
                        number: '',
                        invoiceId: this.options.invoice.id,
                        invoiceNumber: this.options.invoice.get('number'),
                        projectId: this.options.invoice.get('projectId'),
                        companyId: this.options.invoice.get('companyId'),
                        client: this.options.invoice.client,
                        clientId: this.options.invoice.client ? this.options.invoice.client.id : null
                    });
                }
            }

            let fnRender = _.bind(function () {
                this.isFetched = true;
                this.render();
            }, this)
            if (!this.model.isNew()) {
                this.model.fetch({
                    success: fnRender
                });
            } else {
                fnRender();
            }
        }, this));
    },
    beforeRender: function () {
        if (this.model != null && !this.model.isNew()) {
            if (this.model.isERPSynced()) {
                this.options.canEdit = false;
                this.options.canDelete = false;
            } else {
                this.options.canEdit = this.options.isAdmin;
                this.options.canDelete = this.options.isAdmin;
            }
        }
    },
    renderData: function () {
        return {
            model: this.model,
            erpIntegration: this.erpIntegration,
            canEdit: this.options.canEdit,
            canDelete: this.options.canDelete,
            isAdmin: this.options.isAdmin,
            canViewInvoices: this.options.canViewInvoices,
            isPayable: this.options.isPayable,
            canViewCommitments: this.options.canViewCommitments,
            canViewPrimeContracts: this.options.canViewPrimeContracts,
            isFetched: this.isFetched
        }
    },
    afterRender: function () {
        if (!this.isFetched)
            return;

        PJQ.helpers.inputHelpers.inputMaskCurrency(this.$('.input-dollars-full'), 2, true);

        new PJQ.Binder(this.$el, this.model, {
            canEdit: !this.options.canEdit ? false : null,
            watchElements: [
                'input',
                'textarea'
            ]
        });

        new PJQ.views.contacts.ContactsSelectInput({
            el: this.$('.payment-client'),
            selectedContact: this.options.isPayable ? this.model.contractedContact : this.model.client,
            canEdit: false,
            displayContactsBlock: true,
        });

        new PJQ.inputs.Selectpicker({
            el: this.$('.select-payment-method'),
            defaultValue: this.model.get('paymentMethod'),
            canEdit: this.options.canEdit,
            onChange: _.bind(function (value) {
                this.model.set('paymentMethod', value);
            }, this)
        });

        this.dateReceivedPicker = new PJQ.inputs.Datepicker({
            el: this.$('.input-date-received'),
            canEdit: this.options.canEdit,
            datepickerOptions: {
                format: PJQ.helpers.dateHelpers.dateFormats.datePicker.DATE,
                defaultDate: this.model.get('dateReceived') != null ? PJQ.helpers.dateHelpers.parseDateString(this.model.get('dateReceived'), false) : null
            },
            onChange: _.bind(function (newDate) {
                this.model.set('dateReceived', newDate);
            }, this)
        });

        this.fileUploader = new PJQ.views.files.FileUploaderGrid({
            el: this.$('.payment-file-uploader'),
            collection: this.model.attachments,
            canUpload: this.options.canEdit,
            useApiV2: true,
            canDelete: this.options.canEdit && this.options.isAdmin,
            previewImageDimension: 150,
            onSuccess: _.bind(function (file) {
                this.model.isDirty = true;
            }, this),
            onDelete: _.bind(function (attachment, callback) {
                if (attachment.id > 0) {
                    attachment.set('isDeleted', true);
                } else {
                    attachment.destroy();
                }

                this.model.isDirty = true;
                callback();
            }, this)
        });
    },
    viewInvoice: function () {
        this.removeModal();
        if(this.options.isPayable){
            new PJQ.views.invoicing.EditPayableInvoiceModal({
                model: new PJQ.models.invoicing.PayableInvoice({
                    id: this.model.get('invoiceId')
                })
            });
        }
        else {
            new PJQ.views.invoicing.EditReceivableInvoiceModal({
                model: new PJQ.models.invoicing.ReceivableInvoice({
                    id: this.model.get('invoiceId')
                })
            });
        }
    },
    viewPrimeContract: function () {
        this.removeModal();
        new PJQ.views.primeContracts.PrimeContractEditModal({
            model: new PJQ.models.primeContracts.PrimeContract({
                id: this.model.get('primeContractId')
            })
        });
    },
    viewCommitment: function () {
        this.removeModal();
        new PJQ.views.commitments.CommitmentEditModal({
            model: new PJQ.models.commitments.Commitment({
                id: this.model.get('commitmentId')
            })
        });
    },
    syncERP: function () {
        if (this.erpIntegration != null) {
            let loader = new PJQ.Loader(this.$('.modal-content'));
            this.model.syncERP(_.bind(function () {
                if (this.model.isERPSynced()) {
                    this.render();
                } else {
                    loader.remove();
                }
            }, this));
        }
    },
    unlinkERP: function () {
        if (this.erpIntegration != null) {
            let loader = new PJQ.Loader(this.$('.modal-content'));
            this.model.unlinkERP(_.bind(function (success, error) {
                if (success) {
                    this.render();
                } else {
                    let errMsg;
                    if (error === 'LINKED_OBJECT_EXISTS') {
                        errMsg = 'You cannot unlink this payment until it is deleted from your ERP system';
                    } else {
                        errMsg = 'An error occurred when attempting to unlink this payment.  Please contact customer service.';
                    }
                    PJQ.notifications.notify.errorNotify({
                        title: 'Payment Still Exists!',
                        message: errMsg
                    });
                    loader.remove();
                }
            }, this));
        }
    },
    exportPayment: function () {
        let callback = _.bind(function () {
            PJQ.files.downloadFile(PJQ.helpers.urlHelpers.generateEndpoint([
                {
                    endpoint: this.options.isPayable ? 'payableinvoicepayments' : 'receivableinvoicepayments',
                    value: this.model.get('id')
                },
                {
                    endpoint: 'export',
                }
            ]), {isAPIv2: true});
        }, this);

        this.save(callback, true);
    },
    delete: function () {
        new PJQ.views.modals.DeleteCancel({
            header: "Delete Invoice",
            body: "Are you sure you want to delete this Payment?",
            onDelete: _.bind(function () {
                if (typeof this.options.onDelete === 'function') {
                    this.options.onDelete(this.model);
                }
                this.model.destroy({
                    success: _.bind(function () {
                        PJQ.notifications.notify.successNotify({
                            message: 'Payment successfully deleted'
                        });
                        this.removeModal();
                    }, this)
                });
            }, this)
        });
    },
    savePayment: function () {
        let isNew = this.model.isNew();
        this.model.save(null, {
            success: _.bind(function () {
                if (isNew) {
                    this.model.dirtyAttributes = {};
                    PJQ.notifications.notify.successNotify({
                        message: 'Payment created successfully'
                    });

                    if (typeof this.options.onSave === 'function')
                        this.options.onSave(this.model, isNew);

                    this.render();
                } else {
                    PJQ.notifications.notify.successNotify({
                        message: 'Payment saved successfully'
                    });

                    if (typeof this.options.onSave === 'function')
                        this.options.onSave(this.model, isNew);

                    this.removeModal();
                }
            }, this)
        });
    },
    validate: function () {
        return true;
    },
    email: function () {
        let projectName = this.options.project?.get('projectName')?.trim();
        let subject = `A Payment has been shared with you ${projectName && _.size(projectName) > 0 ? `for ${projectName}` : ''}`;
        new PJQ.views.email.ComposeEmailModal({
            header: "Email Payment",
            project: PJQ.app.session.project,
            subject: subject,
            onSave: _.bind(function (data) {
                this.model.share(data, _.bind(function () {
                    PJQ.notifications.notify.successNotify({
                        message: 'Payment email sent'
                    });
                }, this));
            }, this)
        });
    },
    close: function () {
        if (this.model.hasChanged() && this.options.canEdit) {
            new PJQ.views.modals.SaveDontSave({
                header: "Unsaved Changes",
                body: "Do you want to save changes?",
                onSave: _.bind(function () {
                    this.savePayment();
                    this.removeModal();
                }, this),
                onDontSave: _.bind(function () {
                    this.removeModal();
                }, this)
            });
        } else {
            this.removeModal();
        }
    }
});
PJQ.views.invoicing.InvoiceSummary = PJQ.views.BaseView.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.INVOICING, 'invoice-summary')
    },
    events: {
        'click .btn-export-summary': 'export'
    },
    beforeFirstRender: function () {
        this.summary = {}
        this.model.getSummary(_.bind(function (summary) {
            if (summary != null) {
                this.summary = summary;
                this.render();
            } else {
                this.render();
            }
        }, this))
    },
    renderData: function () {
        return {
            summary: this.summary,
            project: PJQ.app.session.project,
            model: this.model
        }
    },
    export: function () {
        if (typeof this.options.export === 'function') {
            this.options.export(this.model);
        }
    }
});
PJQ.views.invoicing.InvoicingManagement = PJQ.views.BaseView.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.INVOICING, 'invoicing-management'),
        subTemplates: {
            totals: new PJQ.templating.Template(PJQ.constants.modules.INVOICING, 'invoicing-management-totals')
        }
    },
    events: {
        'shown.bs.tab .nav-tabs': 'tabActivated',
    },
    beforeFirstRender: function () {
        this.options.isAdmin = PJQ.app.session.project.hasPermission('payableInvoices.isAdmin') || PJQ.app.session.project.hasPermission('receivableInvoices.isAdmin');
        this.options.canViewPayableInvoices = PJQ.app.session.project.hasPermission('payableInvoices.canView');
        this.options.canViewReceivableInvoices = PJQ.app.session.project.hasPermission('receivableInvoices.canView');
    },
    renderData: function () {
        return {
            isAdmin: this.options.isAdmin,
            payableInvoices: this.payableInvoices
        }
    },
    afterRender: function () {
        if (this.options.view != null) {
            this.activateTab(this.options.view);
        } else if (this.options.canViewPayableInvoices) {
            this.renderPayableInvoicesView();
        } else if (this.options.canViewReceivableInvoices) {
            this.renderReceivableInvoicesView();
        } else if (this.options.isAdmin) {
            this.renderBillingPeriodsView();
        }
    },
    activateTab: function (tab) {
        switch (tab ? tab.toLowerCase() : null) {
            case 'billingperiods':
                tab = 'BP_List';
                this.renderBillingPeriodsView();
                break;
            case 'receivable':
                tab = 'RI_List';
                this.renderReceivableInvoicesView();
                break;
            default:
                tab = 'PI_List';
                this.renderPayableInvoicesView();
                break;
        }
        this.activeTab = '#' + tab;

        this.isActivating = true;
        this.$('.nav-link[href="#' + tab + '"]').tab('show');
        this.isActivating = false;
    },
    tabActivated: function (e) {
        if(this.isActivating){
            return;
        }

        let tab = $(e.target).attr('href');
        if(this.activeTab !== tab) {
            this.activeTab = tab;
            switch (this.activeTab) {
                case '#PI_List':
                    this.renderPayableInvoicesView();
                    break;
                case '#RI_List':
                    this.renderReceivableInvoicesView();
                    break;
                case '#BP_List':
                    this.renderBillingPeriodsView();
                    break;
            }
        }
    },
    renderPayableInvoicesView: function () {
        PJQ.app.router.navigate('projects/' + this.options.project.id.toString() + '/invoicing', {
            trigger: false
        });
        this.activeView = 'payable';
        if (this.payableView == null && this.options.canViewPayableInvoices) {
            let fnRender = _.bind(function () {
                this.payableView = new PJQ.views.invoicing.PayableInvoicesList({
                    el: this.$('.payable-pane'),
                    project: PJQ.app.session.project,
                    collection: this.payableInvoices,
                    invoiceId: this.options.invoiceId,
                    paymentId: this.options.paymentId,
                    onChange: _.bind(function(invoice) {
                        let currentInvoice = this.payableInvoices.get(invoice.id);
                        currentInvoice.set(invoice.attributes);
                        this.renderStats();
                    }, this)
                });
                this.renderStats();
            }, this);
            if (this.payableInvoices == null) {
                this.payableInvoices = new PJQ.collections.invoicing.PayableInvoices(null, {
                    project: this.options.project
                });
                this.payableInvoices.fetch({
                    success: _.bind(function () {
                        fnRender();
                    }, this)
                })
            } else {
                fnRender();
            }
        } else {
            this.renderStats();
        }
    },
    renderReceivableInvoicesView: function () {
        PJQ.app.router.navigate('projects/' + this.options.project.id.toString() + '/invoicing/receivable', {
            trigger: false
        });
        this.activeView = 'receivable';
        if (this.receivableView == null && this.options.canViewPayableInvoices) {
            let fnRender = _.bind(function () {
                this.receivableView = new PJQ.views.invoicing.ReceivableInvoicesList({
                    el: this.$('.receivable-pane'),
                    project: PJQ.app.session.project,
                    collection: this.receivableInvoices,
                    invoiceId: this.options.invoiceId,
                    paymentId: this.options.paymentId,
                    onChange: _.bind(function(invoice) {
                        let currentInvoice = this.receivableInvoices.get(invoice.id);
                        currentInvoice.set(invoice.attributes);
                        this.renderStats();
                    }, this)
                });
                this.renderStats();
            }, this);
            if (this.receivableInvoices == null) {
                this.receivableInvoices = new PJQ.collections.invoicing.ReceivableInvoices(null, {
                    project: this.options.project
                });
                this.receivableInvoices.fetch({
                    success: _.bind(function () {
                        fnRender();
                    }, this)
                })
            } else {
                fnRender();
            }
        } else {
            this.renderStats();
        }
    },
    renderBillingPeriodsView: function () {
        PJQ.app.router.navigate('projects/' + this.options.project.id.toString() + '/invoicing/billingperiods', {
            trigger: false
        });
        this.activeView = 'billing_periods';
        if (this.billingPeriodsView == null && this.options.canViewPayableInvoices) {
            let fnRender = _.bind(function () {
                this.billingPeriodsView = new PJQ.views.invoicing.BillingPeriodsList({
                    el: this.$('.billing-period-pane'),
                    project: PJQ.app.session.project,
                    model: this.billingPeriodSettings
                });
            }, this);
            if (this.billingPeriodSettings == null) {
                PJQ.app.session.project.fetchBillingPeriodSettings(_.bind(function (bst) {
                    this.billingPeriodSettings = bst;
                    fnRender();
                }, this));
            } else {
                fnRender();
            }
        } else {
            this.renderStats();
        }
    },
    renderStats: function () {
        let totals = null,
            data = null,
            $totals = this.$('.totals-outer');
        if (this.activeView === 'receivable') {
            totals = this.receivableInvoices.getTotalAmountsByStatus();
            data = {
                draft: totals[PJQ.constants.invoicing.receivableInvoiceStatus.DRAFT],
                reviewing: totals[PJQ.constants.invoicing.receivableInvoiceStatus.REVIEWING],
                approved: totals[PJQ.constants.invoicing.receivableInvoiceStatus.APPROVED],
                complete: totals[PJQ.constants.invoicing.receivableInvoiceStatus.COMPLETE],
                revise: totals[PJQ.constants.invoicing.receivableInvoiceStatus.REVISE]
            };
        } else if (this.activeView === 'payable') {
            totals = this.payableInvoices.getTotalAmountsByStatus();
            data = {
                draft: totals[PJQ.constants.invoicing.payableInvoiceStatus.DRAFT],
                reviewing: totals[PJQ.constants.invoicing.payableInvoiceStatus.REVIEWING],
                approved: totals[PJQ.constants.invoicing.payableInvoiceStatus.APPROVED],
                complete: totals[PJQ.constants.invoicing.payableInvoiceStatus.COMPLETE],
                revise: totals[PJQ.constants.invoicing.payableInvoiceStatus.REVISE]
            };
        }
        if (data != null) {
            this.renderSubTemplate(false, this.options.subTemplates.totals, $totals, data);
        } else {
            $totals.empty();
        }
    }
});
PJQ.views.invoicing.PayableInvoiceDataTable = PJQ.views.dataTables.DataTable.extend({
    defaults: {
        language: {
            emptyTable: 'No Payable Invoices have been created yet',
            zeroRecords: "No Payable Invoices matched the search criteria"
        },
        subTemplates: {
            header: new PJQ.templating.Template(PJQ.constants.modules.INVOICING, 'data-table-header-payable-invoices')
        },
        toggleRowClass: '.change-order-toggle-row',
        onViewInvoice: null
    },
    events: {
        'click .btn-view-invoice': 'viewInvoiceClicked',
        'click .view-commitment': 'viewCommitmentClicked'
    },
    beforeDataTableRender: function () {
        this.options.pageLength = this.options.settings ? this.options.settings.rowsPerPage : 10;
    },
    getDefaultFilter: function () {
        return _.size(this.options.statusIds) > 0 ? this.options.statusIds : this.options.userSettings.get('defaultStatusFilter');
    },
    afterHeaderRender: function () {
        new PJQ.inputs.Selectpicker({
            el: this.$('.payable-invoice-status-filter'),
            defaultValue: this.getDefaultFilter(),
            isIntChoices: true,
            isMultiple: true,
            noneSelectedText: 'No Filters',
            onChange: _.bind(function (value) {
                this.setFilter(PJQ.constants.invoicing.filterType.STATUS_FILTER, value);
            }, this)
        });
        this.setFilter(PJQ.constants.invoicing.filterType.STATUS_FILTER, this.getDefaultFilter());

        // let currentBillingPeriod = _.find(this.options.billingPeriodSettings.billingPeriods.models, function (period) {
        //         return period.get('isCurrent');
        //     }),
        //     bpId = currentBillingPeriod && !this.options.showAllBillingPeriods ? currentBillingPeriod.id : null;
        // this.setFilter('billingPeriodId', bpId);
        new PJQ.inputs.Selectpicker({
            el: this.$('.select-billing-period'),
            defaultValue: null,
            isMultiple: false,
            isIntChoices: true,
            onChange: _.bind(function (value) {
                this.setFilter('billingPeriodId', value);
            }, this)
        });
    },
    getFilterData: function () {
        let statusFilter = this.getFilter(PJQ.constants.invoicing.filterType.STATUS_FILTER),
            billingPeriodFilter = this.getFilter('billingPeriodId'),
            data = this.options.data;
        if (_.size(statusFilter) === 0 && billingPeriodFilter == null) {
            return data;
        }

        if (billingPeriodFilter != null) {
            let fnBPFilter = _.bind(function (data) {
                let billingPeriod = this.options.billingPeriodSettings.billingPeriods.get(billingPeriodFilter),
                    startA = billingPeriod.get('startDate'),
                    endA = billingPeriod.get('endDate');
                return _.filter(data, function (row) {
                    let startB = row.get('startDate'),
                        endB = row.get('endDate');
                    return billingPeriodFilter === row.get('billingPeriodId') || PJQ.helpers.dateHelpers.checkDateRangesOverlap(startA, endA, startB, endB);
                });
            }, this);
            return fnBPFilter(_.filter(data, function (row) {
                return _.size(statusFilter) === 0 || _.contains(statusFilter, row.get('statusId'));
            }));
        } else {
            return _.filter(data, function (row) {
                return _.contains(statusFilter, row.get('statusId'));
            });
        }
    },
    getColumns: function (includeAllColumns = false) {
        this.options.canViewCommitments = PJQ.app.session.project.hasPermission('commitments.canView');

        let columns = [],
            includeColumns = ['number', 'commitment', 'contractedContact.companyName', 'billingDate', 'startDate', 'endDate', 'status', 'amount', 'taxAmount', 'grandTotal', 'paymentAmount', 'retainage', 'retainageReleased', 'paid'];

        if (this.options.customFields) {
            _.each(this.options.customFields.models, _.bind(function (customField) {
                includeColumns.push('fieldValue' + customField.get('fieldNumber'));
            }, this));
        }

        if (!includeAllColumns) {
            if (this.options.settings && _.size(this.options.settings.columns) > 0)
                includeColumns = this.options.settings.columns;
            else
                includeColumns = this.options.settings && this.options.settings.columnsDefault ? this.options.settings.columnsDefault : includeColumns;

            columns.push({
                "columnData": "",
                "data": null,
                "title": "",
                "width": "20px",
                "orderable": false,
                "searchable": false,
                "defaultContent": '',
                "render": (data, type, row) => {
                    if (!this.options.isAdmin) {
                        return "";
                    }

                    let exObj = row.get('externalObject');
                    if (exObj == null) {
                        return '';
                    }

                    return PJQ.helpers.erp.getERPBadge(exObj.status, exObj);
                }
            });
        }

        _.each(includeColumns, _.bind(function (columnName) {
            switch (columnName) {
                case 'status':
                    columns.push({
                        "columnData": "status",
                        "data": "attributes.statusId",
                        "title": "Status",
                        "width": "100px",
                        "render": _.bind(function (data, type, row) {
                            return PJQ.constants.invoicing.payableInvoiceStatusNames[row.get('statusId')]
                        }, this)
                    });
                    break;
                case 'number':
                    columns.push({
                        "columnData": "number",
                        "data": "attributes.number",
                        "title": "Number",
                        "render": _.bind(function (data, type, row) {
                            if (type === 'sort' || type === 'type') {
                                return row.get('number');
                            }

                            return '<a class="btn-view-invoice" href="javascript:void(0)" data-id="' + row.id + '">' + row.get('number') + '</a>';
                        }, this)
                    });
                    break;
                case 'commitment':
                    columns.push({
                        "columnData": "commitment",
                        "title": "Commitment",
                        "data": "attributes.commitmentNumber",
                        "orderable": true,
                        "render": _.bind(function (data, type, row) {
                            if (type === 'sort' || type === 'type') {
                                return row.get('commitmentNumber');
                            }

                            if (this.options.canViewCommitments) {
                                return '<a class="view-commitment" href="javascript:void(0)" data-id="' + row.get('commitmentId') + '">' + row.get('commitmentNumber') + '</a>';
                            }
                            return data;
                        }, this)
                    },);
                    break;
                case 'notes':
                    columns.push({
                        "columnData": "notes",
                        "data": "attributes.notes",
                        "title": "Notes"
                    });
                    break;
                case 'billingDate':
                    columns.push({
                        "columnData": "billingDate",
                        "data": "attributes.billingDate",
                        "title": 'Due Date',
                        "width": '90px',
                        "render": _.bind(function (data, type, row) {
                            if (_.size(data) === 0) {
                                return '';
                            } else if (type === 'sort' || type === 'type') {
                                return data ? new Date(data) : null;
                            }
                            return PJQ.helpers.dateHelpers.getDateString(new Date(data), PJQ.helpers.dateHelpers.dateFormats.DATE, true);
                        }, this)
                    });
                    break;
                case 'startDate':
                    columns.push({
                        "columnData": "startDate",
                        "data": "attributes.startDate",
                        "title": 'Start Date',
                        "width": '90px',
                        "render": _.bind(function (data, type, row) {
                            if (_.size(data) === 0) {
                                return '';
                            } else if (type === 'sort' || type === 'type') {
                                return data ? new Date(data) : null;
                            }
                            return PJQ.helpers.dateHelpers.getDateString(new Date(data), PJQ.helpers.dateHelpers.dateFormats.DATE, true);
                        }, this)
                    });
                    break;
                case 'endDate':
                    columns.push({
                        "columnData": "endDate",
                        "data": "attributes.endDate",
                        "title": 'End Date',
                        "width": '90px',
                        "render": _.bind(function (data, type, row) {
                            if (_.size(data) === 0) {
                                return '';
                            } else if (type === 'sort' || type === 'type') {
                                return data ? new Date(data) : null;
                            }
                            return PJQ.helpers.dateHelpers.getDateString(new Date(data), PJQ.helpers.dateHelpers.dateFormats.DATE, true);
                        }, this)
                    });
                    break;
                case 'createdOn':
                    columns.push({
                        "columnData": "createdOn",
                        "data": "attributes.createdOn",
                        "title": 'Created Date',
                        "width": '90px',
                        "render": _.bind(function (data, type, row) {
                            if (_.size(data) === 0) {
                                return '';
                            } else if (type === 'sort' || type === 'type') {
                                return data ? new Date(data) : null;
                            }
                            return PJQ.helpers.dateHelpers.getDateString(new Date(data), PJQ.helpers.dateHelpers.dateFormats.DATE_TIME);
                        }, this)
                    });
                    break;
                case 'contractedContact.companyName':
                    columns.push({
                        "columnData": "contractedContact.companyName",
                        "title": "Company",
                        "titleSettings": "Contracted Company",
                        "render": _.bind(function (data, type, row) {
                            return row.get('contractedContact') ? row.get('contractedContact').companyName : 'N/A';
                        }, this)
                    });
                    break;
                case 'amount':
                    columns.push({
                        "columnData": "amount",
                        "data": "attributes.amount",
                        "width": "10%",
                        "title": "Amount",
                        "className": "text-align-right",
                        "render": _.bind(function (data, type, row) {
                            return PJQ.helpers.formatHelpers.formatCurrency(row.get('amount'));
                        }, this)
                    });
                    break;
                case 'taxAmount':
                    columns.push({
                        "columnData": "taxAmount",
                        "data": "attributes.taxAmount",
                        "title": "Tax",
                        "width": "100px",
                        "render": _.bind(function (data, type, row) {
                            return PJQ.helpers.formatHelpers.formatCurrency(data);
                        }, this)
                    });
                    break;
                case 'retainageReleased':
                    columns.push({
                        "columnData": "retainageReleased",
                        "data": "attributes.retainageReleased",
                        "title": "Retainage Released",
                        "width": "100px",
                        "render": _.bind(function (data, type, row) {
                            return PJQ.helpers.formatHelpers.formatCurrency(row.getRetainageReleased());
                        }, this)
                    });
                    break;
                case 'retainage':
                    columns.push({
                        "columnData": "retainage",
                        "data": "attributes.retainage",
                        "title": "Retainage",
                        "width": "100px",
                        "render": _.bind(function (data, type, row) {
                            return PJQ.helpers.formatHelpers.formatCurrency(row.getRetainage());
                        }, this)
                    });
                    break;
                case 'grandTotal':
                    columns.push({
                        "columnData": "grandTotal",
                        "data": "attributes.amount",
                        "title": "Grand Total",
                        "width": "100px",
                        "render": _.bind(function (data, type, row) {
                            return PJQ.helpers.formatHelpers.formatCurrency(row.getGrandTotal());
                        }, this)
                    });
                    break;
                case 'paymentAmount':
                    columns.push({
                        "columnData": "paymentAmount",
                        "data": "attributes.paymentAmount",
                        "title": "Payments",
                        "width": "100px",
                        "render": _.bind(function (data, type, row) {
                            return PJQ.helpers.formatHelpers.formatCurrency(data);
                        }, this)
                    });
                    break;
                case 'paid':
                    columns.push({
                        "columnData": "paid",
                        "data": "attributes.paid",
                        "title": "Paid",
                        "width": "100px",
                        "render": _.bind(function (data, type, row) {
                            return data ? 'Yes' : 'No';
                        }, this)
                    });
                    break;
                default:
                    if (columnName.startsWith('fieldValue')) {
                        _.each(this.options.customFields.models, function (customField) {
                            if (columnName === 'fieldValue' + customField.get('fieldNumber')) {
                                columns.push({
                                    "columnData": 'fieldValue' + customField.get('fieldNumber'),
                                    "title": customField.get('name'),
                                    "render": function (data, type, row) {
                                        let fieldValue = row.getCustomFieldValue(customField.get('id'));
                                        fieldValue = (fieldValue !== null) ? fieldValue : '';
                                        switch (customField.get('fieldTypeId')) {
                                            case PJQ.constants.commitments.customFieldType.BOOLEAN:
                                                if (fieldValue != null)
                                                    fieldValue = fieldValue ? 'Yes' : 'No';
                                                break;
                                            case PJQ.constants.commitments.customFieldType.CHOICE:
                                                let choices = [];
                                                // convert single choice value into array so that the logic below can work for both types.
                                                if (typeof fieldValue === 'number')
                                                    fieldValue = [fieldValue];

                                                _.each(customField.choices.models, _.bind(function (choice) {
                                                    if (_.find(fieldValue, function (value) {
                                                        return value === choice.get('id');
                                                    }))
                                                        choices.push(choice.get('name'));
                                                }, this));

                                                fieldValue = choices.join((', '));
                                                break;
                                            case PJQ.constants.commitments.customFieldType.DATE:
                                                if (fieldValue) {
                                                    if (type !== 'sort' && type !== 'type')
                                                        fieldValue = PJQ.helpers.dateHelpers.getDateString(new Date(fieldValue), PJQ.helpers.dateHelpers.dateFormats.DATE, true);
                                                }
                                                if (fieldValue === undefined)
                                                    fieldValue = '';

                                                break;
                                            case PJQ.constants.commitments.customFieldType.DATETIME:
                                                if (fieldValue) {
                                                    if (type !== 'sort' && type !== 'type')
                                                        fieldValue = PJQ.helpers.dateHelpers.getDateString(new Date(fieldValue), PJQ.helpers.dateHelpers.dateFormats.DATE_TIME);
                                                }
                                                if (fieldValue === undefined)
                                                    fieldValue = '';

                                                break;
                                            case PJQ.constants.commitments.customFieldType.INTEGER:
                                                if (type !== 'sort' && type !== 'type' && fieldValue) {
                                                    fieldValue = parseInt(fieldValue).toLocaleString();
                                                }
                                                break;
                                            case PJQ.constants.commitments.customFieldType.MONEY:
                                                if (type === 'sort' || type === 'type') {
                                                    if (fieldValue && fieldValue !== '$')
                                                        fieldValue = parseFloat(PJQ.helpers.formatHelpers.numbersOnly(fieldValue, true));
                                                    else
                                                        fieldValue = 0;
                                                } else {
                                                    fieldValue = PJQ.helpers.formatHelpers.formatCurrency(parseInt(PJQ.helpers.formatHelpers.numbersOnly(fieldValue)));
                                                }
                                                break;
                                            case PJQ.constants.commitments.customFieldType.PERCENT:
                                                if (type === 'sort' || type === 'type') {
                                                    if (fieldValue && fieldValue !== '$')
                                                        fieldValue = parseFloat(PJQ.helpers.formatHelpers.numbersOnly(fieldValue, true)).toFixed(2);
                                                    else
                                                        fieldValue = 0;
                                                } else {
                                                    fieldValue = fieldValue ? fieldValue.toString() + '%' : '';
                                                }

                                                break;
                                        }

                                        return fieldValue;
                                    }
                                });
                            }
                        });
                    }
                    break;
            }
        }, this));

        if (!includeAllColumns) {
            columns.push({
                "title": '',
                "render": _.bind(function (data, type, row) {
                    return '<div class="show-on-row-hover"><button type="button" class="btn btn-info btn-view-invoice ml-1" title="View invoice"><i class="fal fa-arrow-alt-from-left"></i></button></div>';
                }, this),
                "orderable": false,
                "searchable": false,
                "width": "90px",
                "className": "text-center",
                "visible": true
            });
        }

        return columns;
    },
    getRowChildTable: function (childOpts) {
        childOpts.costTypes = this.options.costTypes;
        childOpts.unitsOfMeasure = this.options.unitsOfMeasure;
        childOpts.groups = this.options.groups;
        childOpts.parentDataTable = this;
        childOpts.dom = 't';
        return new PJQ.views.commitments.LineItemDataTable(childOpts);
    },
    getRowChildData: function (row) {
        return new PJQ.collections.commitments.ChangeOrderLineItems(null, {
            changeOrderId: row.data().id
        });
    },
    viewInvoiceClicked: function (e) {
        if (typeof (this.options.onViewInvoice) === 'function') {
            let row = this.getRow((e.currentTarget).closest('tr')),
                invoice = row.data();
            if (invoice != null) {
                this.options.onViewInvoice(invoice);
            }
        }
    },
    viewCommitmentClicked: function (e) {
        let row = this.getRow((e.currentTarget).closest('tr'));
        this.viewCommitment(row.data().get('commitmentId'));
    },
    viewCommitment: function (commitmentId) {
        new PJQ.views.commitments.CommitmentEditModal({
            model: new PJQ.models.commitments.Commitment({
                id: commitmentId
            })
        });
    }
});
PJQ.views.invoicing.EditPayableInvoiceModal = PJQ.views.BaseModal.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.INVOICING, 'modal-payable-invoice-edit'),
        width: '95%',
        maxWidth: 1500,
        model: null,
        isShowCloseButton: true,
        onSave: _.noop(),
        onDelete: _.noop()
    },
    events: {
        'click .btn-view-commitment': 'viewCommitment',
        'click .btn-view-payment': 'viewPaymentClicked',
        'click .btn-new-payment': 'newPayment',
        'change .input-coi-required': 'renderCOIApproval',
        'change .input-w9-required': 'renderW9Approval',
        'change .input-lien-waiver-required': 'renderLienWaiverApproval',
        'click .btn-add-line-item': 'addLineItem',
        'click .btn-delete': 'delete',
        'click .btn-close': 'close',
        'click .btn-submit': 'submitInvoice',
        'click .btn-save-email': 'saveEmail',
        'click .btn-save': 'saveInvoice',
        'click .btn-push-erp': 'pushERP',
        'click .btn-release-erp-retainage': 'releaseERPRetainage',
        'click .erp-sync-payments .btn-pull-erp': 'pullERPPayments',
        'click .btn-undo-push-erp': 'undoPushERP',
        'click .btn-unlink-erp': 'unlinkERP',
        'click .btn-export': 'exportInvoice',
        'click .btn-email': 'email',
        'click .nav-link': 'activeViewChanged',
        'click .btn-invite-to-bill': 'inviteToBill',
        'change .cb-paid': 'updatePaid',
        'click .btn-itb-respond': 'respondToInviteClicked',
        'click .btn-view-history': 'viewHistory'
    },
    beforeModalCreated: async function () {
        this.isFetched = false;

        this.options.project = this.options.project ? this.options.project : PJQ.app.session.project;
        this.coreFieldSettings = await this.options.project.fetchPayableInvoiceFieldSettings();
        this.settings = await this.options.project.fetchPayableInvoiceSettings();
        this.customFields = await this.options.project.fetchPayableInvoiceCustomFields();
        this.billingPeriodSettings = await this.options.project.fetchBillingPeriodSettings();
        this.costCodes = await this.options.project.fetchCostCodes();
        this.costTypes = await this.options.project.fetchCostTypes();
        this.unitsOfMeasure = await this.options.project.fetchUnitsOfMeasure();

        if (this.model == null) {
            let customFieldValues = [];
            _.each(this.customFields.models, function (model, index) {
                let value = model.get('defaultValue') ? model.get('defaultValue') : '';
                if (model.get('fieldType') === 'CHOICE') {
                    value = parseInt(value);
                }
                customFieldValues.push({
                    fieldNumber: model.get('fieldNumber'),
                    fieldTypeId: model.get('fieldTypeId'),
                    fieldType: model.get('fieldType'),
                    isMultiple: model.get('isMultiple'),
                    value: value,
                    id: model.get('id')
                })
            }, this);

            this.model = new PJQ.models.invoicing.PayableInvoice({
                notes: '',
                number: '',
                commitmentId: this.options.commitment.id,
                commitmentType: this.options.commitment.get('commitmentType'),
                commitmentNumber: this.options.commitment.get('number'),
                projectId: this.options.commitment.get('projectId'),
                companyId: this.options.commitment.get('companyId'),
                contractedContact: this.options.commitment.contractedContact,
                contractedContactId: this.options.commitment.get('contractedContactId'),
                invoiceContact: this.options.commitment.invoiceContact,
                invoiceContactId: this.options.commitment.get('invoiceContactId'),
                statusId: PJQ.constants.invoicing.payableInvoiceStatus.DRAFT,
                isCOIRequired: this.options.commitment.get('isCOIRequired'),
                isCOIApproved: this.options.commitment.get('isCOIApproved'),
                coiAttachments: this.options.commitment.coiAttachments.toJSON(),
                isW9Required: this.options.commitment.get('isW9Required'),
                isW9Approved: this.options.commitment.get('isW9Approved'),
                defaultWorkRetainagePercent: this.options.commitment.get('defaultWorkRetainagePercent'),
                defaultMaterialRetainagePercent: this.options.commitment.get('defaultMaterialRetainagePercent'),
                w9Attachments: this.options.commitment.w9Attachments.toJSON(),
                customFieldValues: customFieldValues
            });

            let billingPeriod = _.find(this.billingPeriodSettings.billingPeriods.models, function (billingPeriod) {
                return billingPeriod.get('isCurrent');
            })
            if (billingPeriod != null) {
                this.model.set({
                    billingPeriodId: billingPeriod.id,
                    startDate: PJQ.helpers.dateHelpers.parseDateString(billingPeriod.get('startDate'), false),
                    endDate: PJQ.helpers.dateHelpers.parseDateString(billingPeriod.get('endDate'), false),
                    billingDate: PJQ.helpers.dateHelpers.parseDateString(billingPeriod.get('dueDate'), false)
                });
            }
        }

        if (!this.model.isNew()) {
            await this.model.fetch();
        }

        this.erpIntegration = await PJQ.app.session.fetchERPIntegration();
        if (this.erpIntegration != null && this.erpIntegration.getSetting('syncProjects')) {
            await this.options.project.fetchERPObject();

            if (this.options.commitment == null) {
                this.options.commitment = new PJQ.models.commitments.Commitment({
                    id: this.model.get('commitmentId')
                });
                await this.options.commitment.fetch();
            }
        }

        this.isFetched = true;
        this.render();
    },
    beforeRender: function () {
        if (!this.isFetched) {
            return;
        }

        this.options.canEdit = this.options.project.hasPermission('payableInvoices.canEdit');
        this.options.canEditLineItems = this.options.canEdit;
        this.options.canEditBillingDates = this.options.project.hasPermission('payableInvoices.canEdit');
        this.options.isAdmin = this.options.project.hasPermission('payableInvoices.isAdmin');
        this.options.canViewCommitments = this.options.project.hasPermission('commitments.canView');
        this.options.canAddPayments = this.options.canEdit;
        this.options.canDelete = this.options.isAdmin;
        this.options.canEditStatus = this.options.isAdmin;
        this.options.canInviteToBill = this.options.isAdmin && new Date(this.model.get('billingDate')) > new Date() && this.model.get('statusId') === PJQ.constants.invoicing.payableInvoiceStatus.DRAFT;
        this.options.canRespondToInvite = this.model.get('invitedOnDate') != null && this.model.get('inviteStatus') == null && (PJQ.app.session.user?.get('userId') === this.model.contractedContact.get('userId') || PJQ.app.session.user?.get('userId') === this.model.invoiceContact?.get('userId'));

        let status = this.model.get('statusId');
        if (this.model.isNew() || status === PJQ.constants.invoicing.payableInvoiceStatus.DRAFT) {
            this.options.canEdit = true;
            this.options.canEditBillingDates = true;
            this.options.canEditLineItems = true;
            this.options.canDelete = !this.model.isNew();
        } else if (status === PJQ.constants.invoicing.payableInvoiceStatus.APPROVED || status === PJQ.constants.invoicing.payableInvoiceStatus.COMPLETE) {
            this.options.canEdit = PJQ.app.session.project.hasPermission('payableInvoices.canEdit');
            this.options.canEditBillingDates = false;
            this.options.canEditLineItems = false;
            this.options.canDelete = false;
        } else {
            this.options.canEdit = PJQ.app.session.project.hasPermission('payableInvoices.canEdit');
            this.options.canEditBillingDates = PJQ.app.session.project.hasPermission('payableInvoices.canEdit');
            this.options.canEditLineItems = true;
            this.options.canDelete = this.options.isAdmin;
        }

        if (PJQ.app.session.user != null &&
            ((this.model.get('contractedContact') && PJQ.app.session.user.id === this.model.get('contractedContact').userId)
                || (this.model.get('invoiceContact') && PJQ.app.session.user.id === this.model.get('invoiceContact').userId))) {
            this.options.canSubmit = true;
            this.options.isSubmitting = (status === PJQ.constants.invoicing.payableInvoiceStatus.DRAFT || status === PJQ.constants.invoicing.payableInvoiceStatus.REVISE);

            if (PJQ.helpers.dateHelpers.checkDateIsBeforeToday(PJQ.helpers.dateHelpers.parseDateString(this.model.get('billingDate'), false))) {
                new PJQ.Alert(this.$('.modal-body'), {
                    type: 'primary',
                    text: 'The billing date has passed. You can no longer edit this invoice.'
                });
                this.options.canEditBillingDates = false;
                this.options.canEdit = false;
                this.options.canEditLineItems = false;
                this.options.canDelete = false;
                this.options.isSubmitting = false;
            }
        }

        if (status !== PJQ.constants.invoicing.payableInvoiceStatus.APPROVED && status !== PJQ.constants.invoicing.payableInvoiceStatus.COMPLETE) {
            this.options.canAddPayments = false;
        }

        this.options.disabledStatuses = null;
        let fnGetGreaterStatuses = (statusId) => {
            return _.filter(PJQ.constants.invoicing.payableInvoiceStatus, (st) => {
                return st < statusId;
            });
        };

        let syncStatus = this.model.erpSyncStatus(),
            isERPSynced = syncStatus === PJQ.constants.integrations.erp.syncStatuses.REVIEWING
                || syncStatus === PJQ.constants.integrations.erp.syncStatuses.APPROVED
                || syncStatus === PJQ.constants.integrations.erp.syncStatuses.SYNCED;
        if ((status === PJQ.constants.invoicing.payableInvoiceStatus.APPROVED || status === PJQ.constants.invoicing.payableInvoiceStatus.COMPLETE)
            && (this.model.payments.models.length > 0 || this.model.get('isLatest') === false || isERPSynced)) {
            this.options.canEditLineItems = false;
            this.options.disabledStatuses = _.union(fnGetGreaterStatuses(PJQ.constants.invoicing.payableInvoiceStatus.APPROVED), [PJQ.constants.invoicing.payableInvoiceStatus.VOID]);
        }

        if (this.model.isNew()) {
            this.options.canEditStatus = false;
        }

        if (this.erpIntegration != null && isERPSynced) {
            this.options.canEditBillingDates = false;
            this.options.canEdit = false;
            this.options.canEditLineItems = false;
            this.options.canDelete = false;
            this.options.isSubmitting = false;
        }
    },
    renderData: function () {
        return {
            model: this.model,
            erpIntegration: this.erpIntegration,
            customFields: this.customFields,
            billingPeriods: this.billingPeriodSettings != null ? this.billingPeriodSettings.billingPeriods : null,
            canEdit: this.options.canEdit,
            canDelete: this.options.canDelete,
            isAdmin: this.options.isAdmin,
            canViewCommitments: this.options.canViewCommitments,
            canAddPayments: this.options.canAddPayments,
            isSubmitting: this.options.isSubmitting,
            isFetched: this.isFetched,
            canEditBillingDates: this.options.canEditBillingDates,
            settings: this.settings,
            invoiceSettings: this.invoiceSettings,
            activeView: this.options.activeView,
            views: this.views,
            canInviteToBill: this.options.canInviteToBill,
            checkFieldVisible: _.bind(this.checkFieldVisible, this),
            checkFieldRequired: _.bind(this.checkFieldRequired, this),
            canRespondToInvite: this.options.canRespondToInvite
        }
    },
    afterRender: function () {
        if (!this.isFetched) {
            return;
        }

        if (this.options.canSubmit && PJQ.helpers.dateHelpers.checkDateIsBeforeToday(PJQ.helpers.dateHelpers.parseDateString(this.model.get('billingDate'), false))) {
            new PJQ.Alert(this.$('.pi-tabs'), {
                type: 'primary',
                text: 'The billing date has passed. You can no longer edit this invoice.',
                isPrepend: true
            });
        }

        this.activateView(this.options.activeView);

        this.stopListening(this.model);
        this.listenTo(this.model, 'change:statusId', () => {
            this.renderERP();
        });
        this.stopListening(this.model.lineItems);
        this.listenTo(this.model.lineItems, 'update', () => {
            this.renderERP();
        });
        this.renderERP();

        this.renderGeneral();
        if (!this.model.isNew()) {
            this.renderLineItems();
            this.renderPayments();
        }
        this.updateCounts();

        if (this.options.inviteResponse != null && this.model.get('invitedOnDate') != null && this.model.get('inviteStatus') == null) {
            this.handleInviteResponse();
        }

        let checkRetainage = PJQ.app.session.erpIntegration?.checkAvailableAction(PJQ.constants.integrations.actions.CAN_RELEASE_PAYABLE_INVOICE_RETAINAGE, this.model, this.options.commitment);
        if (_.size(checkRetainage?.alert?.text) > 0) {
            new PJQ.Alert(this.$('.modal-body'), {
                type: checkRetainage.alert.type ?? 'warning',
                text: checkRetainage.alert.text,
                extraClasses: ['mt-2'],
                isPrepend: true
            });
        }
    },
    respondToInviteClicked: function (e) {
        let target = $(e.currentTarget),
            value = target.data('value');

        this.handleInviteResponse(value);
    },
    handleInviteResponse: function (responseValue) {
        let response = responseValue != null ? responseValue : this.options.inviteResponse,
            fnUpdateResponse = () => {
                this.model.updateInviteStatus(response, (updatedModel) => {
                    PJQ.notifications.notify.successNotify({
                        message: 'Invoice response updated successfully'
                    });
                    this.model.reset(updatedModel);

                    if (typeof this.options.onSave === 'function')
                        this.options.onSave(this.model, false);

                    this.render();
                });
            };

        if (response === 0) {
            new PJQ.views.modals.YesNo({
                header: "Decline Invitation",
                body: "Are you sure you want to decline to bill this period?",
                onYes: _.bind(function () {
                    fnUpdateResponse();
                }, this)
            });
        } else {
            fnUpdateResponse();
        }
    },
    updateCounts: function () {
        this.$('.count-line-items').text(_.size(this.model.lineItems.models));
        this.$('.count-payments').text(_.size(this.model.payments.models));
    },
    views: {
        GENERAL: 'PI_General',
        LINEITEMS: 'PI_LineItems',
        PAYMENTS: 'PI_Payments',
        SUMMARY: 'PI_Summary'
    },
    activeViewChanged: function (e) {
        let view = e.target.hash ? e.target.hash.replace('#', '') : null;
        this.activateView(view);
    },
    activateView: function (view) {
        switch (view) {
            case this.views.LINEITEMS:
            case this.views.PAYMENTS:
                // do nothing
                break;
            case this.views.SUMMARY:
                this.renderSummary();
                break;
            default:
                view = this.views.GENERAL;
                break;
        }

        this.$('.nav-link[href="#' + view + '"]').tab('show');
        this.options.activeView = view;
    },
    validateApproval: function () {
        let isValid = true;
        if (this.model.get('statusId') === PJQ.constants.invoicing.payableInvoiceStatus.APPROVED || this.model.get('statusId') === PJQ.constants.invoicing.payableInvoiceStatus.COMPLETE) {
            if (this.model.get('isCOIRequired')) {
                let $coi = this.$('.coi-alert');
                $coi.empty();
                if (!this.model.get('isCOIApproved')) {
                    new PJQ.Alert($coi, {
                        type: 'danger',
                        text: 'You must approve this item before approving the invoice'
                    });
                    isValid = false;
                }
            }

            if (this.model.get('isW9Required')) {
                let $w9 = this.$('.w9-alert');
                $w9.empty();
                if (!this.model.get('isW9Approved')) {
                    new PJQ.Alert($w9, {
                        type: 'danger',
                        text: 'You must approve this item before approving the invoice'
                    });
                    isValid = false;
                }
            }
        }
        return isValid;
    },
    renderGeneral: function () {
        new PJQ.Binder(this.$el, this.model, {
            canEdit: !this.options.canEdit ? false : null,
            useDecimalPercentFields: true,
            watchElements: [
                'input',
                'textarea'
            ]
        });

        new PJQ.views.contacts.ContactsSelectInput({
            el: this.$('.invoice-contracted-company'),
            selectedContact: this.model.contractedContact,
            canViewContacts: this.options.project.hasPermission('projectContacts.canView'),
            canEdit: false,
            displayContactsBlock: true,
        });

        new PJQ.views.contacts.ContactsSelectInput({
            el: this.$('.invoice-contact'),
            selectedContact: this.model.invoiceContact,
            canViewContacts: this.options.project.hasPermission('projectContacts.canView'),
            canEdit: false,
            displayContactsBlock: true,
        });

        this.statusPicker = new PJQ.inputs.Selectpicker({
            el: this.$('.select-status'),
            isIntChoices: true,
            defaultValue: this.model.get('statusId'),
            canEdit: this.options.canEditStatus,
            choices: _.map(PJQ.constants.invoicing.payableInvoiceStatus, (st) => {
                return {
                    id: st,
                    name: PJQ.constants.invoicing.payableInvoiceStatusNames[st],
                    disabled: this.options.disabledStatuses != null && this.options.disabledStatuses.indexOf(st) > -1
                }
            }),
            onChange: _.bind(function (newStatus) {
                let oldStatus = this.model.get('statusId');
                if (newStatus === oldStatus) {
                    return;
                }

                this.model.set('statusId', newStatus);
                if (!this.model.isNew()) {
                    this.save((success) => {
                        if (success) {
                            PJQ.notifications.notify.successNotify({
                                message: 'Invoice saved successfully'
                            });
                        } else {
                            this.model.set('statusId', oldStatus);
                            this.statusPicker.setValue(oldStatus);
                        }
                    });
                } else {
                    this.render();
                }
            }, this)
        });

        new PJQ.inputs.Selectpicker({
            el: this.$('.select-billing-period'),
            defaultValue: this.model.get('billingPeriodId'),
            isMultiple: false,
            isIntChoices: true,
            canEdit: this.options.canEdit,
            onChange: _.bind(function (value) {
                let billingPeriod = this.billingPeriodSettings != null && value != null ? this.billingPeriodSettings.billingPeriods.get(value) : null;
                this.model.set('billingPeriodId', value);
                this.$('.period-start').attr('disabled', billingPeriod != null);
                this.$('.period-end').attr('disabled', billingPeriod != null);
                if (billingPeriod != null) {
                    let startDate = PJQ.helpers.dateHelpers.parseDateString(billingPeriod.get('startDate'), false),
                        endDate = PJQ.helpers.dateHelpers.parseDateString(billingPeriod.get('endDate'), false),
                        dueDate = PJQ.helpers.dateHelpers.parseDateString(billingPeriod.get('dueDate'), false);
                    this.periodStartPicker.setValue(startDate);
                    this.model.set('startDate', startDate);

                    this.periodEndPicker.setValue(endDate);
                    this.model.set('endDate', endDate);

                    this.dueDatePicker.setValue(dueDate);
                    this.model.set('billingDate', dueDate);
                }
            }, this)
        });

        this.periodStartPicker = new PJQ.inputs.Datepicker({
            el: this.$('.period-start'),
            canEdit: this.options.canEdit && !(this.model.get('billingPeriodId') > 0),
            datepickerOptions: {
                format: PJQ.helpers.dateHelpers.dateFormats.datePicker.DATE,
                defaultDate: this.model.get('startDate') != null ? PJQ.helpers.dateHelpers.parseDateString(this.model.get('startDate'), false) : null
            },
            onChange: _.bind(function (newDate) {
                this.model.set('startDate', newDate);
            }, this)
        });

        this.periodEndPicker = new PJQ.inputs.Datepicker({
            el: this.$('.period-end'),
            canEdit: this.options.canEdit && !(this.model.get('billingPeriodId') > 0),
            datepickerOptions: {
                format: PJQ.helpers.dateHelpers.dateFormats.datePicker.DATE,
                defaultDate: this.model.get('endDate') != null ? PJQ.helpers.dateHelpers.parseDateString(this.model.get('endDate'), false) : null
            },
            onChange: _.bind(function (newDate) {
                this.model.set('endDate', newDate);
            }, this)
        });

        this.dueDatePicker = new PJQ.inputs.Datepicker({
            el: this.$('.due-date'),
            canEdit: this.options.canEdit,
            datepickerOptions: {
                format: PJQ.helpers.dateHelpers.dateFormats.datePicker.DATE,
                defaultDate: this.model.get('billingDate') != null ? PJQ.helpers.dateHelpers.parseDateString(this.model.get('billingDate'), false) : null
            },
            onChange: _.bind(function (newDate) {
                this.model.set('billingDate', newDate);
            }, this)
        });

        if (this.checkFieldVisible('attachments')) {
            this.fileUploader = new PJQ.views.files.FileUploaderGrid({
                el: this.$('.invoice-file-uploader'),
                collection: this.model.attachments,
                canUpload: this.options.canEdit,
                useApiV2: true,
                canView: false,
                useBlob: true,
                canDelete: this.options.canEdit && this.options.isAdmin,
                previewImageDimension: 150,
                onSuccess: _.bind(function (file) {
                    this.model.isDirty = true;
                }, this),
                onDelete: _.bind(function (attachment, callback) {
                    if (attachment.id > 0) {
                        attachment.set('delete', true);
                    } else {
                        attachment.destroy();
                    }

                    this.model.isDirty = true;
                    callback();
                }, this)
            });
        }

        if (this.checkFieldVisible('coiAttachments')) {
            this.coiUploader = new PJQ.views.files.FileUploaderGrid({
                el: this.$('.coi-file-uploader'),
                collection: this.model.coiAttachments,
                canUpload: this.options.canEdit,
                useApiV2: true,
                canView: false,
                useBlob: true,
                canDelete: this.options.isAdmin,
                previewImageDimension: 150,
                onSuccess: _.bind(function (file) {
                    this.model.isDirty = true;
                }, this),
                onDelete: _.bind(function (attachment, callback) {
                    if (attachment.get('id') > 0) {
                        attachment.set('delete', true);
                    } else {
                        attachment.destroy();
                    }

                    this.model.isDirty = true;
                    callback();
                }, this)
            });
            this.renderCOIApproval();
        }

        if (this.checkFieldVisible('w9Attachments')) {
            this.w9Uploader = new PJQ.views.files.FileUploaderGrid({
                el: this.$('.w9-file-uploader'),
                collection: this.model.w9Attachments,
                canUpload: this.options.canEdit,
                useApiV2: true,
                canView: false,
                useBlob: true,
                canDelete: this.options.isAdmin,
                previewImageDimension: 150,
                onSuccess: _.bind(function (file) {
                    this.model.isDirty = true;
                }, this),
                onDelete: _.bind(function (attachment, callback) {
                    if (attachment.get('id') > 0) {
                        attachment.set('delete', true);
                    } else {
                        attachment.destroy();
                    }

                    this.model.isDirty = true;
                    callback();
                }, this)
            });
            this.renderW9Approval();
        }

        if (this.checkFieldVisible('lienWaiverAttachments')) {
            this.lienWaiverUploader = new PJQ.views.files.FileUploaderGrid({
                el: this.$('.lien-waiver-file-uploader'),
                collection: this.model.lienWaiverAttachments,
                canUpload: this.options.canEdit,
                useApiV2: true,
                canView: false,
                useBlob: true,
                canDelete: this.options.isAdmin,
                previewImageDimension: 150,
                onSuccess: _.bind(function (file) {
                    this.model.isDirty = true;
                }, this),
                onDelete: _.bind(function (attachment, callback) {
                    if (attachment.get('id') > 0) {
                        attachment.set('delete', true);
                    } else {
                        attachment.destroy();
                    }

                    this.model.isDirty = true;
                    callback();
                }, this)
            });
            this.renderLienWaiverApproval();
        }

        if (this.customFields && _.size(this.customFields.models) > 0) {
            this.customFieldsForm = new PJQ.views.customFields.CustomFieldsForm({
                el: this.$('.payable-invoice-custom-fields'),
                collection: this.customFields,
                fieldValues: this.model.get('customFieldValues'),
                isEdit: this.options.canEdit,
                isAdmin: this.options.isAdmin,
            });
        }
    },
    renderCOIApproval: function () {
        if (this.coiApproval != null) {
            this.coiApproval.remove();
        }
        if (this.model.get('isCOIRequired')) {
            this.coiApproval = new PJQ.inputs.ButtonGroup({
                el: this.$('.coi-approval'),
                canEdit: this.options.canEdit && this.options.isAdmin,
                colorInactiveButtons: false,
                buttonClasses: 'wd-120p',
                buttons: [
                    {
                        label: "Not Reviewed",
                        value: null,
                        colorClass: "light"
                    },
                    {
                        label: "Rejected",
                        value: false,
                        colorClass: "danger"
                    },
                    {
                        label: "Approved",
                        value: true,
                        colorClass: "success"
                    }
                ],
                defaultValue: this.model.get('isCOIApproved'),
                onChange: _.bind(function (value) {
                    this.model.set('isCOIApproved', value);
                }, this)
            });
        }
    },
    renderW9Approval: function () {
        if (this.w9Approval != null) {
            this.w9Approval.remove();
        }
        if (this.model.get('isW9Required')) {
            this.w9Approval = new PJQ.inputs.ButtonGroup({
                el: this.$('.w9-approval'),
                canEdit: this.options.canEdit && this.options.isAdmin,
                colorInactiveButtons: false,
                buttonClasses: 'wd-120p',
                buttons: [
                    {
                        label: "Not Reviewed",
                        value: null,
                        colorClass: "light"
                    },
                    {
                        label: "Rejected",
                        value: false,
                        colorClass: "danger"
                    },
                    {
                        label: "Approved",
                        value: true,
                        colorClass: "success"
                    }
                ],
                defaultValue: this.model.get('isW9Approved'),
                onChange: _.bind(function (value) {
                    this.model.set('isW9Approved', value);
                }, this)
            });
        }
    },
    renderLienWaiverApproval: function () {
        if (this.lienWaiverApproval != null) {
            this.lienWaiverApproval.remove();
        }
        if (this.model.get('isLienWaiverRequired')) {
            this.lienWaiverApproval = new PJQ.inputs.ButtonGroup({
                el: this.$('.lien-waiver-approval'),
                canEdit: this.options.canEdit && this.options.isAdmin,
                colorInactiveButtons: false,
                buttonClasses: 'wd-120p',
                buttons: [
                    {
                        label: "Not Reviewed",
                        value: null,
                        colorClass: "light"
                    },
                    {
                        label: "Rejected",
                        value: false,
                        colorClass: "danger"
                    },
                    {
                        label: "Approved",
                        value: true,
                        colorClass: "success"
                    }
                ],
                defaultValue: this.model.get('isLienWaiverApproved'),
                onChange: _.bind(function (value) {
                    this.model.set('isLienWaiverApproved', value);
                }, this)
            });
        }
    },
    renderSummary: function () {
        this.summaryView = new PJQ.views.invoicing.InvoiceSummary({
            el: this.$('.invoice-summary'),
            model: this.model,
            export: () => {
                this.save(() => {
                    PJQ.files.downloadFile(PJQ.helpers.urlHelpers.generateEndpoint([
                        {
                            endpoint: 'payableinvoices',
                            value: this.model.get('id')
                        },
                        {
                            endpoint: 'summary'
                        },
                        {
                            endpoint: 'export',
                        }
                    ]), {isAPIv2: true});
                });
            }
        })
    },
    renderLineItems() {
        if (this.lineItemsView) {
            this.lineItemsView.remove();
        }

        this.lineItemsView = new PJQ.views.budget.LineItemsView({
            el: this.$('.invoice-line-items'),
            model: this.model,
            commitment: this.options.commitment,
            collection: this.model.lineItems,
            lineItemModel: PJQ.models.invoicing.PayableInvoiceLineItem,
            isSubmitting: this.options.isSubmitting,
            canEdit: this.options.isSubmitting || (this.options.canEdit && this.options.canEditLineItems),
            canDelete: this.options.isSubmitting || (this.options.canEdit && this.options.canEditLineItems),
            isAdmin: this.options.isAdmin,
            enableStoredMaterials: this.settings.get('enableStoredMaterials'),
            enableRetainage: this.settings.get('enableRetainage'),
            enableSelection: this.options.isSubmitting || (this.options.canEdit && this.options.canEditLineItems),
            enableTax: true,
            canImportBudget: false,
            showSubTotal: true,
            showGrandTotal: true,
            onLineItemChange: _.bind(function () {
                this.model.isDirty = true;
            }, this),
            onLineItemAdd: _.bind(function () {
                this.model.isDirty = true;
                this.updateCounts();
            }, this),
            onLineItemDelete: _.bind(function () {
                this.model.isDirty = true;
                this.updateCounts();
            }, this),
            onCommitmentView: _.bind(function () {
                this.removeModal();
            }, this),
            onChangeOrderView: _.bind(function () {
                this.removeModal();
            }, this),
        });
    },
    pullERPPayments: function () {
        if (this.model.isERPSynced() && this.erpIntegration.hasAvailableAction(PJQ.constants.integrations.actions.PULL_PAYABLE_PAYMENTS)) {
            this.erpIntegration.pullPayableInvoicePayments(this.model, (res) => {
                PJQ.notifications.notify.successNotify({
                    message: 'Payments successfully pulled from ERP'
                });

                this.model.payments.reset(res);
                this.renderPayments();
            });
        }
    },
    renderPayments: function () {
        if (this.model.isNew()) {
            return;
        }

        this.paymentsDataTable = new PJQ.views.dataTables.DataTable({
            el: this.$('.invoice-payments'),
            data: this.model.payments.models,
            isHideSearch: true,
            language: {
                emptyTable: 'No Payments have been created yet',
                zeroRecords: "No Payments matched the search criteria"
            },
            paging: false,
            order: [],
            columns: [{
                "columnData": "",
                "data": null,
                "title": "",
                "width": "20px",
                "orderable": false,
                "searchable": false,
                "defaultContent": '',
                "render": function (data, type, row) {
                    let exObj = row.get('externalObject');
                    if (exObj == null) {
                        return '';
                    }

                    return PJQ.helpers.erp.getERPBadge(exObj.status, exObj);
                }
            }, {
                "title": "#",
                "data": "attributes.number",
                "render": _.bind(function (data, type, row) {
                    return '<a href="javascript:void(0)" class="btn-view-payment">' + data + '</a>'
                }, this)
            },
                {
                    "title": 'Received',
                    "data": "",
                    "render": _.bind(function (data, type, row) {
                        let dateReceived = row.get('dateReceived');
                        if (_.size(dateReceived) === 0) {
                            return '';
                        }

                        return PJQ.helpers.dateHelpers.getDateString(new Date(dateReceived), PJQ.helpers.dateHelpers.dateFormats.DATE, true);
                    }, this)
                },
                {
                    "data": "attributes.amount",
                    "title": "Amount",
                    "render": _.bind(function (data, type, row) {
                        return PJQ.helpers.formatHelpers.formatCurrency(row.get('amount'));
                    }, this)
                },
                {
                    "data": "",
                    "title": "",
                    "orderable": false,
                    "searchable": false,
                    "width": "80px",
                    "render": _.bind(function (data, type, row) {
                        let html = '<div class="text-align-right show-on-row-hover">'
                        if (this.options.canViewInvoices) {
                            html += '<button type="button" class="btn btn-info btn-view-payment ht-30p wd-35p ml-1 fs-14"><span class="fal fa-pencil"></span></button>'
                        }
                        return html + '</div>';
                    }, this)
                }],
            dom: '<"top"<"clear">>rt<"bottom"p<"clear">>',
            contextMenuOptions: {
                actions: [
                    {
                        name: 'View',
                        onClick: _.bind(function (row) {
                            this.viewPayment(row.data());
                        }, this),
                        isShown: _.bind(function (row) {
                            return this.options.canViewInvoices;
                        }, this)
                    }
                ]
            },
            onRowDoubleClick: _.bind(function (row) {
                this.viewPayment(row.data());
            }, this)
        });
    },
    newPayment: function () {
        this.viewPayment();
    },
    viewPaymentClicked: function (e) {
        let target = $(e.currentTarget),
            row = this.paymentsDataTable.getRow(target.closest('tr'));
        this.viewPayment(row.data());
    },
    viewPayment: function (payment) {
        this.removeModal();
        new PJQ.views.invoicing.InvoicePaymentModal({
            model: payment,
            invoice: this.model,
            isPayable: true,
            onSave: _.bind(function (payment, isNew) {
                if (isNew) {
                    this.model.payments.add(payment);
                    this.paymentsDataTable.addRow(payment);
                }
                this.updateCounts();

                if (typeof this.options.onSave === 'function') {
                    this.options.onSave(this.model);
                }
            }, this),
            onDelete: _.bind(function () {
                this.updateCounts();

                if (typeof this.options.onSave === 'function') {
                    this.options.onSave(this.model);
                }
            }, this)
        });
    },
    viewCommitment: function () {
        this.removeModal();
        new PJQ.views.commitments.CommitmentEditModal({
            model: new PJQ.models.commitments.Commitment({
                id: this.model.get('commitmentId')
            }),
            onSave: () => {
                if (typeof this.options.onSave === 'function') {
                    this.options.onSave(this.model);
                }
            },
            onDelete: () => {
                if (typeof this.options.onSave === 'function') {
                    this.options.onSave(this.model);
                }
            }
        });
    },
    renderERP: function () {
        let $erp = this.$('.erp-sync');
        if (!this.options.isAdmin || this.erpIntegration == null || !this.options.project.isERPSynced() || this.model.isNew()) {
            $erp.remove();
            return;
        }

        this.$('.erp-badge').html(PJQ.helpers.erp.getERPBadge(this.model.erpSyncStatus(), this.model.get('externalObject')));

        let canPush = true,
            disablePushReason = "";

        if (_.size(this.model.lineItems) === 0
            || (this.model.get('statusId') !== PJQ.constants.invoicing.payableInvoiceStatus.APPROVED && this.model.get('statusId') !== PJQ.constants.invoicing.payableInvoiceStatus.COMPLETE)) {
            canPush = false;
            disablePushReason = "Invoice must be approved or complete and have line items";
        }

        if (!this.options.commitment.isERPSynced() && !this.erpIntegration.hasAvailableAction(PJQ.constants.integrations.actions.PUSH_PAYABLE_INVOICES_WO_SYNCED_COMMMITMENT)) {
            canPush = false;
            disablePushReason = "The commitment for this invoice is not synced";
        }

        let hasUnreleasedRetainage = (this.model.get('workRetainage') - this.model.get('workRetainageReleased')) > 0;
        PJQ.helpers.erp.renderERPButtons($erp, {
            pushSupported: this.erpIntegration.hasAvailableAction(PJQ.constants.integrations.actions.PUSH_PAYABLE_INVOICES),
            canPush: canPush,
            disablePushReason: disablePushReason,
            status: this.model.erpSyncStatus(),
            canReleaseRetainage: hasUnreleasedRetainage && this.erpIntegration.hasAvailableAction(PJQ.constants.integrations.actions.CAN_RELEASE_PAYABLE_INVOICE_RETAINAGE, this.model, this.options.commitment),
            unlinkSupported: this.erpIntegration.hasAvailableAction(PJQ.constants.integrations.actions.UNLINK_PAYABLE_INVOICES),
            canPushChanges: false
        });

        let $erpPayments = this.$('.erp-sync-payments');
        PJQ.helpers.erp.renderERPButtons($erpPayments, {
            pushSupported: false,
            pullSupported: this.erpIntegration.hasAvailableAction(PJQ.constants.integrations.actions.PULL_PAYABLE_PAYMENTS)
        });
    },
    releaseERPRetainage: function () {
        if (!this.erpIntegration.hasAvailableAction(PJQ.constants.integrations.actions.CAN_RELEASE_PAYABLE_INVOICE_RETAINAGE, this.model, this.options.commitment)) {
            return;
        }

        this.erpIntegration.releasePayableInvoiceRetainage(this.model, _.bind(function () {
            PJQ.notifications.notify.successNotify({
                message: 'Invoice Retainage Release pushed to ERP'
            });

            if (typeof this.options.onSave === 'function') {
                this.options.onSave(this.model);
            }

            if (typeof callback === 'function') {
                callback();
            } else {
                this.render();
            }
        }, this));
    },
    pushERP: function (callback) {
        if (!this.erpIntegration.hasAvailableAction(PJQ.constants.integrations.actions.PUSH_PAYABLE_INVOICES)) {
            return;
        }

        this.save((success) => {
            if (success) {
                this.erpIntegration.pushPayableInvoice(this.model, _.bind(function () {
                    PJQ.notifications.notify.successNotify({
                        message: 'Invoice pushed to ERP'
                    });

                    if (typeof this.options.onSave === 'function') {
                        this.options.onSave(this.model);
                    }

                    if (typeof callback === 'function') {
                        callback();
                    } else {
                        this.render();
                    }
                }, this));
            }
        });
    },
    undoPushERP: function () {
        if (this.model.erpSyncStatus() === PJQ.constants.integrations.erp.syncStatuses.REVIEWING) {
            this.erpIntegration.undoPush(this.model, _.bind(function () {
                PJQ.notifications.notify.successNotify({
                    message: 'Payable Invoice removed from ERP approval'
                });

                if (typeof this.options.onSave === 'function') {
                    this.options.onSave(this.model);
                }

                this.render();
            }, this));
        }
    },
    unlinkERP: function () {
        new PJQ.views.modals.YesNo({
            header: "Unlink from ERP",
            body: "Are you sure you want to unlink this Payable Invoice from your ERP system?",
            onYes: () => {
                let loader = new PJQ.Loader(this.$('.modal-content'));
                this.erpIntegration.unlinkPayableInvoice(this.model, (success) => {
                    if (success) {
                        loader.remove();
                        PJQ.notifications.notify.successNotify({
                            message: 'Payable Invoice unlinked from ERP'
                        });

                        if (typeof this.options.onSave === 'function') {
                            this.options.onSave(this.model);
                        }

                        this.render();
                    }
                });
            }
        });
    },
    checkFieldVisible: function (fieldName) {
        if (this.coreFieldSettings) {
            let fieldSettings = this.coreFieldSettings.findWhere({fieldName: fieldName});
            if (fieldSettings != null) {
                return fieldSettings.get('isVisible');
            }
        }
        return true;
    },
    checkFieldRequired: function (fieldName) {
        if (this.coreFieldSettings) {
            let fieldSettings = this.coreFieldSettings.findWhere({fieldName: fieldName});
            if (fieldSettings != null) {
                return fieldSettings.get('isRequired');
            }
        }
        return false;
    },
    viewHistory: async function () {
        let historyItems = [{
            date: this.model.get('createdOn'),
            person: this.model.get('createdBy'),
            action: 'Invoice Created'
        }];

        let history = new PJQ.collections.invoicing.PayableInvoiceHistory({}, {
            invoiceId: this.model.id
        });
        new PJQ.views.history.HistoryTimelineModal({
            collection: history,
            subTitle: 'Payable Invoice #' + this.model.get('number'),
            items: historyItems
        });
    },
    exportInvoice: function () {
        let callback = _.bind(function () {
            PJQ.files.downloadFile(PJQ.helpers.urlHelpers.generateEndpoint([
                {
                    endpoint: 'payableinvoices',
                    value: this.model.get('id')
                },
                {
                    endpoint: 'export',
                }
            ]), {isAPIv2: true});
        }, this);

        if (this.options.canEdit && this.model.hasChanged()) {
            this.save(callback);
        } else {
            callback();
        }
    },
    delete: function () {
        new PJQ.views.modals.DeleteCancel({
            header: "Delete Invoice",
            body: "Are you sure you want to delete this Invoice?",
            onDelete: _.bind(function () {
                if (typeof this.options.onDelete === 'function') {
                    this.options.onDelete(this.model);
                }
                this.model.destroy({
                    success: _.bind(function () {
                        PJQ.notifications.notify.successNotify({
                            message: 'Invoice successfully deleted'
                        });
                        this.removeModal();
                    }, this)
                });
            }, this)
        });
    },
    validate: function () {
        let isValid = true;
        this.periodStartPicker.hideError();
        this.periodEndPicker.hideError();
        this.dueDatePicker.hideError();

        if (this.model.get('startDate') == null) {
            isValid = false;
            this.periodStartPicker.showError();
        }
        if (this.model.get('endDate') == null) {
            isValid = false;
            this.periodEndPicker.showError();
        }
        if (this.model.get('billingDate') == null) {
            isValid = false;
            this.dueDatePicker.showError();
        }
        if (this.customFieldsForm != null && !this.customFieldsForm.validate()) {
            isValid = false;
        }

        if (!this.validateApproval()) {
            isValid = false;
        }

        if (this.checkFieldRequired('number')) {
            let $number = this.$('.invoice-number');
            PJQ.helpers.inputHelpers.setInputError($number, true);
            if (_.size(this.model.get('number')) === 0) {
                PJQ.helpers.inputHelpers.setInputError($number, false);
                isValid = false;
            }
        }

        if (this.checkFieldRequired('notes')) {
            let $notes = this.$('.invoice-notes');
            PJQ.helpers.inputHelpers.setInputError($notes, true);
            if (_.size(this.model.get('notes')) === 0) {
                PJQ.helpers.inputHelpers.setInputError($notes, false);
                isValid = false;
            }
        }

        if (this.checkFieldRequired('attachments')) {
            this.fileUploader.clearError();
            let hasValidAttachment = _.find(this.model.attachments.models, function (model) {
                return !model.get('delete')
            }, this) != null;

            if (!hasValidAttachment) {
                this.fileUploader.showError('Missing attachment', 100000);
                isValid = false;
            }
        }

        if (this.checkFieldRequired('coiAttachments')) {
            this.coiUploader.clearError();
            let hasValidAttachment = _.find(this.model.coiAttachments.models, function (model) {
                return !model.get('delete')
            }, this) != null;

            if (!hasValidAttachment) {
                this.coiUploader.showError('Missing attachment', 100000);
                isValid = false;
            }
        }

        if (this.checkFieldRequired('w9Attachments')) {
            this.w9Uploader.clearError();
            let hasValidAttachment = _.find(this.model.w9Attachments.models, function (model) {
                return !model.get('delete')
            }, this) != null;

            if (!hasValidAttachment) {
                this.w9Uploader.showError('Missing attachment', 100000);
                isValid = false;
            }
        }

        if (this.checkFieldRequired('lienWaiverAttachments')) {
            this.lienWaiverUploader.clearError();
            let hasValidAttachment = _.find(this.model.lienWaiverAttachments.models, function (model) {
                return !model.get('delete')
            }, this) != null;

            if (!hasValidAttachment) {
                this.lienWaiverUploader.showError('Missing attachment', 100000);
                isValid = false;
            }
        }

        if (!isValid && this.options.activeView !== 'general') {
            this.options.activeView = 'general';
            this.$('.nav-tabs a[href="#I_General"]').tab('show');
        }

        return isValid;
    },
    submitInvoice: function () {
        this.model.submit(null, _.bind(function (result) {
            if (result) {
                PJQ.notifications.notify.successNotify({
                    message: 'Invoice submitted successfully'
                });

                if (typeof this.options.onSave === 'function')
                    this.options.onSave(this.model);

                this.removeModal();
            }
        }, this));
    },
    saveEmail: function () {
        let isNew = this.model.isNew();
        this.save((success) => {
            if (success) {
                let notifyText = isNew ? 'Invoice created successfully' : 'Invoice saved successfully';
                PJQ.notifications.notify.successNotify({
                    message: notifyText
                });

                this.email();
            }
        });
    },
    saveInvoice: function () {
        let isNew = this.model.isNew();
        this.save((success) => {
            if (success) {
                let notifyText = isNew ? 'Invoice created successfully' : 'Invoice saved successfully';
                PJQ.notifications.notify.successNotify({
                    message: notifyText
                });

                if (!isNew) {
                    this.removeModal()
                }
            }
        });
    },
    save: function (callback) {
        if (!this.validate()) {
            this.$('.modal').prevObject.scrollTop(0);
            if (typeof callback === 'function') {
                callback(false);
            }
            return;
        }

        this.model.save({
            customFields: this.customFieldsForm != null ? this.customFieldsForm.getChanged() : null,
            lineItems: this.model.lineItems.toJSON()
        }, {
            success: () => {
                this.render();
                if (typeof this.options.onSave === 'function') {
                    this.options.onSave(this.model);
                }

                PJQ.app.session.project.trigger('payableInvoiceChanged', this.model);
                if (typeof callback === 'function') {
                    callback(true);
                }
            },
            error: () => {
                if (typeof callback === 'function') {
                    callback(false);
                }
                PJQ.notifications.notify.errorNotify({
                    message: "Encountered an error while saving this Invoice. Please contact customer service."
                });
            }
        });
    },
    email: function () {
        let projectName = this.options.project?.get('projectName')?.trim();
        let subject = `An invoice has been shared with you ${projectName && _.size(projectName) > 0 ? `for ${projectName}` : ''}`;
        new PJQ.views.email.ComposeEmailModal({
            header: "Email Invoice",
            project: PJQ.app.session.project,
            subject: subject,
            onSave: _.bind(function (data) {
                this.model.share(data, _.bind(function () {
                    PJQ.notifications.notify.successNotify({
                        message: 'Invoice email sent'
                    });
                }, this));
            }, this)
        });
    },
    inviteToBill: function () {
        this.save((success) => {
            if (success) {
                new PJQ.ajax.Request({
                    endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
                        {
                            endpoint: 'payableinvoices',
                            value: this.model.get('id')
                        },
                        {
                            endpoint: 'invitetobill',
                        }
                    ]),
                    isAPIv2: true
                }).post().done(() => {
                    PJQ.notifications.notify.successNotify({
                        message: 'Invitation to Bill sent'
                    });
                }).fail((xhr, err, result) => {

                });
            }
        });
    },
    updatePaid: function (e) {
        this.model.set('paid', $(e.currentTarget).prop('checked'));
        if (!this.options.canEdit && this.options.isAdmin) {
            this.save(() => {
                PJQ.notifications.notify.successNotify({
                    message: 'Invoice saved successfully'
                });
            });
        }
    },
    close: function () {
        if (this.model.hasChanged() && this.options.canEdit) {
            new PJQ.views.modals.SaveDontSave({
                header: "Unsaved Changes",
                body: "Do you want to save changes?",
                onSave: _.bind(function () {
                    this.saveInvoice();
                    this.removeModal();
                }, this),
                onDontSave: _.bind(function () {
                    this.removeModal();
                }, this)
            });
        } else {
            this.removeModal();
        }
    }
});
PJQ.views.invoicing.PayableInvoicesList = PJQ.views.BaseView.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.INVOICING, 'invoices-list'),
        invoiceId: null
    },
    events: {
        'click .btn-settings': 'editSettings',
        'click .btn-create-invoice': 'newInvoice',
        'click .btn-delete-invoice': 'deleteInvoiceClicked',
        'click .btn-export': 'exportList'
    },
    beforeFirstRender: async function () {
        this.options.project = this.options.project ? this.options.project : PJQ.app.session.project;

        if (this.collection == null) {
            this.collection = new PJQ.collections.invoicing.PayableInvoices(null, {
                project: PJQ.app.session.project,
                costCodeId: this.options.costCodeId ? this.options.costCodeId : null,
                costTypeId: this.options.costTypeId ? this.options.costTypeId : null
            });
        }

        if (!this.collection.isFetched) {
            await this.collection.fetch();
        }

        this.customFields = await this.options.project.fetchPayableInvoiceCustomFields();
        this.userSettings = await PJQ.app.session.fetchPayableInvoiceUserSettings();
        this.billingPeriodSettings = await this.options.project.fetchBillingPeriodSettings();
        this.erpIntegration = await PJQ.app.session.fetchERPIntegration();

        this.isFetched = true;
        this.render();
    },
    beforeRender: function () {
        if (!this.isFetched) {
            return;
        }

        this.options.canViewCommitments = this.options.project.hasPermission('commitments.canView');
        this.options.isAdmin = this.options.project.hasPermission('payableInvoices.isAdmin');
    },
    renderData: function () {
        return {
            collection: this.collection,
            isFetched: this.isFetched
        }
    },
    afterRender: function () {
        if (!this.isFetched) {
            return;
        }

        this.renderView();

        PJQ.app.session.project.off('payableInvoiceChanged');
        PJQ.app.session.project.on('payableInvoiceChanged', function (invoice) {
            this.collection.add(invoice);
            this.render();
        }, this);

        if (this.options.invoiceId > 0) {
            let initInvoice = this.collection.get(this.options.invoiceId);
            if (initInvoice != null) {
                this.viewInvoice(initInvoice, this.options.inviteResponse);
                this.options.invoiceId = null;
            }
        } else if (this.options.paymentId > 0) {
            let initPayment = new PJQ.models.invoicing.PayableInvoicePayment({
                id: this.options.paymentId
            });

            new PJQ.views.invoicing.InvoicePaymentModal({
                model: initPayment,
                isPayable: true
            });
        }
    },
    renderView: function () {
        if (this.dataTable) {
            this.dataTable.remove();
            this.dataTable = null;
        }

        this.dataTable = this.getDataTableInstance();
    },
    getDataTableInstance: function () {
        return new PJQ.views.invoicing.PayableInvoiceDataTable({
            el: this.$('.invoices-table'),
            rowId: "cid",
            data: this.collection.models,
            onPageSizeChange: function (value) {
                // PJQ.helpers.cookieHelpers.setCookie(PJQ.constants.cookies.RFI_PAGE_LENGTH, value);
            },
            isAdmin: this.options.isAdmin,
            statusIds: this.options.statusIds,
            showAllBillingPeriods: this.options.showAllBillingPeriods,
            headerData: _.bind(function () {
                return {
                    billingPeriods: this.billingPeriodSettings ? this.billingPeriodSettings.billingPeriods : null,
                    project: this.options.project,
                    canAdd: this.options.canAdd,
                    isAdmin: this.options.isAdmin
                };
            }, this),
            groups: this.groups,
            costTypes: this.costTypes,
            unitsOfMeasure: this.unitsOfMeasure,
            userSettings: this.userSettings,
            billingPeriodSettings: this.billingPeriodSettings,
            canViewCommitments: this.options.canViewCommitments,
            settings: this.userSettings.getSettings(PJQ.constants.invoicing.view.PAYABLE_INVOICES),
            order: [[1, 'asc']],
            colReorder: {
                fixedColumnsRight: 1,
                realtime: false
            },
            columnOrderChanged: () => {
                this.userSettings.save();
            },
            onViewInvoice: (invoice) => {
                this.viewInvoice(invoice);
            },
            onRowDoubleClick: (row) => {
                this.viewInvoice(row.data());
            },
            contextMenuOptions: {
                actions: [
                    {
                        name: 'View',
                        onClick: _.bind(function (row) {
                            this.viewInvoice(row.data());
                        }, this)
                    }
                ]
            }
        });
    },
    newInvoice: function () {
        this.viewInvoice();
    },
    viewInvoice: function (invoice, inviteResponse) {
        let isNew = invoice == null;
        new PJQ.views.invoicing.EditPayableInvoiceModal({
            model: invoice,
            inviteResponse: inviteResponse,
            commitment: this.model,
            onSave: (invoice) => {
                if (isNew) {
                    this.collection.add(invoice);
                }
                this.renderView();
            },
            onDelete: (invoice) => {
                this.collection.remove(invoice);
                this.renderView();
            }
        });
    },
    deleteInvoiceClicked: function (e) {
        let target = $(e.currentTarget),
            row = this.dataTable.getRow(target.closest('tr'));
        this.deleteInvoice(row);
    },
    deleteInvoice: function (row) {
        if (row != null) {
            let invoice = row.data();
            if (invoice != null) {
                new PJQ.views.modals.DeleteCancel({
                    header: "Delete Invoice",
                    body: "Are you sure you want to delete this Invoice?",
                    onDelete: _.bind(function () {
                        invoice.destroy({
                            success: _.bind(function () {
                                this.dataTable.removeRow(row);
                                if (typeof this.options.onDelete === 'function') {
                                    this.options.onDelete(invoice);
                                }
                            }, this)
                        });
                    }, this)
                });
            }
        }
    },
    editSettings: function () {
        new PJQ.views.invoicing.PayableInvoiceSettingsModal({
            invoicesView: this,
            onSave: _.bind(function () {
                this.renderView();
                PJQ.notifications.notify.successNotify({
                    message: 'Settings updated successfully'
                });
            }, this)
        });
    },
    exportList: function () {
        PJQ.files.downloadFile(PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'projects',
                value: PJQ.app.session.project.id
            },
            {
                endpoint: 'payableinvoices'
            },
            {
                endpoint: 'export'
            }
        ], [
            {
                parameter: 'timeZoneOffset',
                value: new Date().getTimezoneOffset()
            }
        ]), {isAPIv2: true});
    }
});

PJQ.views.invoicing.ModalViewPayableInvoices = PJQ.views.BaseModal.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.INVOICING, 'modal-view-payable-invoices'),
        maxWidth: 1000,
        isShowCloseButton: true,
        onSave: _.noop,
        isAdmin: true
    },
    events: {},
    beforeModalCreated: function () {

    },
    renderData: function () {
        return {
            model: this.model
        }
    },
    afterRender: function () {
        if (this.model != null) {
            new PJQ.views.invoicing.PayableInvoicesList({
                el: this.$('.modal-body'),
                model: this.model,
                costCodeId: this.model.get('costCodeId'),
                costTypeId: this.model.get('costTypeId'),
                statusIds: this.options.statusIds,
                showAllBillingPeriods: this.options.showAllBillingPeriods,
                project: this.options.project
            })
        }
    },
});
//Models
PJQ.models.invoicing.PayableInvoice = PJQ.models.invoicing.Invoice.extend({
    endpoint: function () {
        let arr = [];
        if (this.isNew()) {
            arr.push({
                endpoint: 'projects',
                value: this.get('projectId')
            });
        }
        return PJQ.helpers.urlHelpers.generateEndpoint([...arr, {
            endpoint: 'payableinvoices',
            value: this.id
        }]);
    },
    beforeSave: function () {
        this.set({
            lineItems: this.lineItems.toJSON(),
            attachments: this.attachments.toJSON(),
            w9Attachments: this.w9Attachments.toJSON(),
            coiAttachments: this.coiAttachments.toJSON(),
            lienWaiverAttachments: this.lienWaiverAttachments.toJSON(),
        });
    },
    parse: function (model) {
        if (!model)
            return model;

        this.lineItems = new PJQ.collections.invoicing.PayableInvoiceLineItems(model.lineItems);
        this.attachments = new PJQ.collections.invoicing.PayableInvoiceAttachments(model.attachments);
        this.w9Attachments = new PJQ.collections.commitments.CommitmentAttachments(model.w9Attachments);
        this.coiAttachments = new PJQ.collections.commitments.CommitmentAttachments(model.coiAttachments);
        this.lienWaiverAttachments = new PJQ.collections.commitments.CommitmentAttachments(model.lienWaiverAttachments);
        this.payments = new PJQ.collections.invoicing.PayableInvoicePayments(model.payments);

        if (model.contractedContact) {
            if (model.contractedContact instanceof PJQ.models.BaseModel) {
                this.contractedContact = model.contractedContact;
            } else {
                this.contractedContact = new PJQ.models.contacts.Contact(model.contractedContact);
            }
        }

        if (model.invoiceContact) {
            if (model.invoiceContact instanceof PJQ.models.BaseModel) {
                this.invoiceContact = model.invoiceContact;
            } else {
                this.invoiceContact = new PJQ.models.contacts.Contact(model.invoiceContact);
            }
        }

        return model;
    },
    syncERP: function (callback) {
        new PJQ.ajax.Request({
            endpoint: this.endpoint() + '/syncerp',
            isAPIv2: true,
        }).post().done(_.bind(function (res) {
            if (res && _.size(res.externalId) > 0) {
                this.set('externalObject', res);
            }
            if (typeof callback === 'function') {
                callback(res);
            }
        }, this)).fail(_.bind(function (xhr, err, result) {
            if (typeof callback === 'function') {
                callback(null);
            }
        }, this));
    },
    unlinkERP: function (callback) {
        new PJQ.ajax.Request({
            endpoint: this.endpoint() + '/unlinkerp',
            isAPIv2: true,
        }).post().done(_.bind(function () {
            this.set('externalObject', null);
            if (typeof callback === 'function') {
                callback(true);
            }
        }, this)).fail(_.bind(function (xhr) {
            if (typeof callback === 'function') {
                let err;
                if (xhr.responseJSON != null) {
                    err = xhr.responseJSON.type;
                } else {
                    err = null;
                }
                callback(false, err);
            }
        }, this));
    },
    makeERPUrl: function (integration) {
        let externalId = this.externalId();
        if (_.size(externalId) === 0) {
            return '';
        }

        switch (integration.get('name')) {
            case PJQ.constants.integrations.providers.QBO.name:
                return 'https://app.sandbox.qbo.intuit.com/app/bill?txnId=' + externalId;
            default:
                return '';
        }
    },
    submit: function (signature, callback) {
        this.beforeSave();
        new PJQ.ajax.Request({
            endpoint: this.endpoint() + '/submit',
            isAPIv2: true,
            data: this.toJSON()
        }).post().done(_.bind(function (response) {
            if (typeof callback === 'function') {
                this.set(this.parse(response));
                callback(true);
            }
        }, this)).fail(_.bind(function (response) {
            if (typeof callback === 'function') {
                callback(false);
            }
        }, this));
    },
    share: function (data, callback) {
        new PJQ.ajax.Request({
            endpoint: this.endpoint() + '/email',
            isAPIv2: true,
            data: {
                subject: data != null ? data.subject : null,
                body: data != null ? data.body : null,
                toEmails: data != null ? data.toEmails : null,
                ccEmails: data != null ? data.ccEmails : null,
            }
        }).post().done(_.bind(function (response) {
            callback();
        }, this)).fail(_.bind(function (xhr, err, result) {
            //todo: error
        }, this));
    },
    updateInviteStatus: async function (response, callback) {
        new PJQ.ajax.Request({
            endpoint: this.endpoint() + '/invitestatus?response=' + response,
            isAPIv2: true,
            data: this.toJSON()
        }).post().done(_.bind(function (res) {
            callback(res);
        }, this)).fail(_.bind(function (xhr, err, result) {
            PJQ.notifications.notify.errorNotify({
                message: err && err.message ? err.message : "Something went wrong"
            });
        }, this));
    }
});

PJQ.models.invoicing.PayableInvoiceHistoryItem = PJQ.models.BaseModel.extend({
    defaults: {
        isAPIv2: true
    },
    actionNames: {
        'status': 'Status Changed',
        'email': 'Email Sent',
        'invtobill': 'Sent Invite to Bill'
    },
    getActionName: function () {
        return this.actionNames[this.get('action')] ?? this.get('action');
    },
    getDescription: function () {
        switch (this.get('action')) {
            case 'status':
                let fromStatus = this.get('data').from,
                    toStatus = this.get('data').to;
                if (fromStatus == null || toStatus == null) {
                    return '';
                }

                return '' + PJQ.constants.invoicing.payableInvoiceStatusNames[fromStatus] + '<i class="fal fa-arrow-right ml-1 mr-1 fs-14"></i>' + PJQ.constants.invoicing.payableInvoiceStatusNames[toStatus];
            case 'email':
            case 'invtobill':
                let to = this.get('data').to;
                if (_.size(to) === 0) {
                    return '';
                }

                return 'To: ' + to.join(', ');
            default:
                return '';
        }
    }
});

PJQ.models.invoicing.PayableInvoiceLineItem = PJQ.models.invoicing.InvoiceLineItem.extend({});

PJQ.models.invoicing.PayableInvoiceAttachment = PJQ.models.files.File.extend({
    defaults: {
        isAPIv2: true
    },
    idAttribute: 'id'
});

PJQ.models.invoicing.PayableInvoiceCustomField = PJQ.models.customFields.CustomField.extend({
    defaults: {
        isAPIv2: true
    },
    idAttribute: 'id',
    endpoint: function () {
        return PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'payableinvoices'
            },
            {
                endpoint: 'customfields',
                value: this.get('id')
            }
        ]);
    }
});

PJQ.models.invoicing.PayableInvoiceSettings = PJQ.models.budget.Settings.extend({
    defaults: {
        isAPIv2: true
    },
    idAttribute: 'settingId',
    endpoint: function () {
        if (this.options.projectId > 0) {
            return PJQ.helpers.urlHelpers.generateEndpoint([
                {
                    endpoint: 'projects',
                    value: this.options.projectId
                },
                {
                    endpoint: 'payableinvoices'
                },
                {
                    endpoint: 'settings'
                }
            ]);
        }

        return PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'payableinvoices'
            },
            {
                endpoint: 'settings'
            }
        ]);
    }
});

PJQ.models.invoicing.PayableInvoiceUserSettings = PJQ.models.BaseModel.extend({
    defaults: {
        isAPIv2: true
    },
    idAttribute: 'settingId',
    endpoint: function () {
        return PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'payableinvoices'
            },
            {
                endpoint: 'settings'
            },
            {
                endpoint: 'user'
            }
        ]);
    },
    getSettings: function (view) {
        return _.find(this.attributes.viewSettings, _.bind(function (setting) {
            return setting.view === view;
        }, this));
    }
});

PJQ.models.invoicing.PayableInvoiceFieldSetting = PJQ.models.BaseModel.extend({
    defaults: {
        isAPIv2: true
    },
    idAttribute: 'settingId',
    endpoint: function () {
        return PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'settings'
            },
            {
                endpoint: 'fields',
                value: this.id ? this.id : 'payableinvoices'
            }
        ]);
    }
});

PJQ.models.invoicing.PayableInvoicePayment = PJQ.models.BaseModel.extend({
    defaults: {
        isAPIv2: true
    },
    endpoint: function () {
        let arr = [];
        if (this.isNew()) {
            arr.push({
                endpoint: 'projects',
                value: this.get('projectId')
            });
        }
        return PJQ.helpers.urlHelpers.generateEndpoint([...arr, {
            endpoint: 'payableinvoicepayments',
            value: this.id
        }]);
    },
    parse: function (model) {
        if (!model)
            return model;

        this.attachments = new PJQ.collections.invoicing.PayableInvoiceAttachments(model.attachments);

        if (model.contractedContact) {
            if (model.contractedContact instanceof PJQ.models.BaseModel) {
                this.contractedContact = model.contractedContact;
            } else {
                this.contractedContact = new PJQ.models.contacts.Contact(model.contractedContact);
            }
        } else {
            this.contractedContact = null;
        }

        return model;
    },
    beforeSave: function () {
        this.set({
            attachments: this.attachments.toJSON()
        });
    },
    syncERP: function (callback) {
        new PJQ.ajax.Request({
            endpoint: this.endpoint() + '/syncerp',
            isAPIv2: true,
        }).post().done(_.bind(function (res) {
            if (res && _.size(res.externalId) > 0) {
                this.set('externalObject', res);
            }
            if (typeof callback === 'function') {
                callback(res);
            }
        }, this)).fail(_.bind(function (xhr, err, result) {
            if (typeof callback === 'function') {
                callback(null);
            }
        }, this));
    },
    unlinkERP: function (callback) {
        new PJQ.ajax.Request({
            endpoint: this.endpoint() + '/unlinkerp',
            isAPIv2: true,
        }).post().done(_.bind(function () {
            this.set('externalObject', null);
            if (typeof callback === 'function') {
                callback(true);
            }
        }, this)).fail(_.bind(function (xhr) {
            if (typeof callback === 'function') {
                let err;
                if (xhr.responseJSON != null) {
                    err = xhr.responseJSON.type;
                } else {
                    err = null;
                }
                callback(false, err);
            }
        }, this));
    },
    makeERPUrl: function (integration) {
        let externalId = this.externalId();
        if (_.size(externalId) === 0) {
            return '';
        }

        switch (integration.get('name')) {
            case PJQ.constants.integrations.providers.QBO.name:
                return 'https://app.sandbox.qbo.intuit.com/app/invoice?txnId=' + externalId;
            default:
                return '';
        }
    }
});

PJQ.models.invoicing.PayableInvoicePaymentAttachment = PJQ.models.files.File.extend({
    defaults: {
        isAPIv2: true
    },
    idAttribute: 'id'
});

//Collections
PJQ.collections.invoicing.PayableInvoices = PJQ.collections.invoicing.Invoices.extend({
    defaults: {
        isAPIv2: true
    },
    model: PJQ.models.invoicing.PayableInvoice,
    endpoint: function () {
        let params = [];
        if (this.options.costCodeId && this.options.costTypeId) {
            params.push({
                parameter: 'costCodeId',
                value: this.options.costCodeId
            }, {
                parameter: 'costTypeId',
                value: this.options.costTypeId
            });
        }

        if (this.options.commitment != null) {
            return PJQ.helpers.urlHelpers.generateEndpoint([
                {
                    endpoint: 'payableinvoices',
                    value: this.options.commitment.id
                }
            ]);
        } else {
            return PJQ.helpers.urlHelpers.generateEndpoint([
                {
                    endpoint: 'projects',
                    value: this.options.project.get('projectId')
                },
                {
                    endpoint: 'payableinvoices',
                    value: this.options.commitment ? this.options.commitment.id : null
                }
            ], params);
        }
    },
    getTotalAmountsByStatus: function () {
        let result = {};
        result[PJQ.constants.invoicing.payableInvoiceStatus.DRAFT] = 0;
        result[PJQ.constants.invoicing.payableInvoiceStatus.REVIEWING] = 0;
        result[PJQ.constants.invoicing.payableInvoiceStatus.APPROVED] = 0;
        result[PJQ.constants.invoicing.payableInvoiceStatus.COMPLETE] = 0;
        result[PJQ.constants.invoicing.payableInvoiceStatus.REVISE] = 0;
        _.each(this.models, function (invoice) {
            result[invoice.get('statusId')] += invoice.get('totalAmount');
        });
        return result;
    },
    getPayments: function () {
        let result = [];
        _.each(this.models, function (invoice) {
            result.push(...invoice.payments.models);
        })
        return result;
    }
});

PJQ.collections.invoicing.PayableInvoiceHistory = PJQ.collections.BaseCollection.extend({
    defaults: {
        isAPIv2: true
    },
    model: PJQ.models.invoicing.PayableInvoiceHistoryItem,
    endpoint: function () {
        return PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'payableinvoices',
                value: this.options.invoiceId
            },
            {
                endpoint: 'history'
            }
        ]);
    }
});

PJQ.collections.invoicing.PayableInvoiceLineItems = PJQ.collections.invoicing.InvoiceLineItems.extend({
    defaults: {
        isAPIv2: true
    },
    model: PJQ.models.invoicing.PayableInvoiceLineItem
});

PJQ.collections.invoicing.PayableInvoiceAttachments = PJQ.collections.files.Files.extend({
    defaults: {
        isAPIv2: true
    },
    model: PJQ.models.invoicing.PayableInvoiceAttachment,
    endpoint: function () {
        return PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'payableinvoices',
                value: this.options.invoiceId
            },
            {
                endpoint: 'attachments'
            }
        ]);
    }
});

PJQ.collections.invoicing.PayableInvoiceCustomFields = PJQ.collections.BaseCollection.extend({
    defaults: {
        isAPIv2: true
    },
    model: PJQ.models.invoicing.PayableInvoiceCustomField,
    endpoint: function () {
        let arr = [];
        if (this.options.projectId > 0) {
            arr.push({
                endpoint: 'projects',
                value: this.options.projectId
            });
        }
        arr.push(...[
            {
                endpoint: 'payableinvoices'
            },
            {
                endpoint: 'customfields'
            }
        ]);
        return PJQ.helpers.urlHelpers.generateEndpoint(arr);
    }
});

PJQ.collections.invoicing.PayableInvoiceCustomFieldChoices = PJQ.collections.BaseCollection.extend({
    defaults: {
        isAPIv2: true
    },
    model: PJQ.models.invoicing.PayableInvoiceCustomFieldChoice
});

PJQ.collections.invoicing.PayableInvoiceFieldSettings = PJQ.collections.BaseCollection.extend({
    defaults: {
        isAPIv2: true
    },
    model: PJQ.models.invoicing.PayableInvoiceFieldSetting,
    endpoint: function () {
        if (this.options.projectId > 0) {
            return PJQ.helpers.urlHelpers.generateEndpoint([
                {
                    endpoint: 'projects',
                    value: this.options.projectId
                },
                {
                    endpoint: 'settings'
                },
                {
                    endpoint: 'fields',
                    value: 'payableinvoices'
                }
            ]);
        }

        return PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'settings'
            },
            {
                endpoint: 'fields',
                value: 'payableinvoices'
            }
        ]);
    }
});

PJQ.collections.invoicing.PayableInvoicePayments = PJQ.collections.BaseCollection.extend({
    defaults: {
        isAPIv2: true
    },
    model: PJQ.models.invoicing.PayableInvoicePayment,
    endpoint: function () {
        if (this.options.invoiceId > 0) {
            return PJQ.helpers.urlHelpers.generateEndpoint([
                {
                    endpoint: 'payableinvoices',
                    value: this.options.invoiceId
                },
                {
                    endpoint: 'payments'
                }
            ]);
        } else {
            return PJQ.helpers.urlHelpers.generateEndpoint([
                {
                    endpoint: 'projects',
                    value: this.options.project.get('projectId')
                },
                {
                    endpoint: 'payableinvoicepayments'
                }
            ]);
        }
    },
});

PJQ.collections.invoicing.PayableInvoicePaymentAttachments = PJQ.collections.files.Files.extend({
    defaults: {
        isAPIv2: true
    },
    model: PJQ.models.invoicing.PayableInvoicePaymentAttachment,
    endpoint: function () {
        return PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'payableinvoicepayments',
                value: this.options.paymentId
            },
            {
                endpoint: 'attachments'
            }
        ]);
    }
});
PJQ.views.invoicing.PayableInvoiceSettingsModal = PJQ.views.BaseModal.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.INVOICING, 'modal-payable-invoice-settings'),
        minWidth: '600px',
    },
    events: {
        'change .select-column': 'columnSelected',
        'click .btn-edit-company-default': 'editCompanySettings',
        'click button.settings-save': 'onSave'
    },
    beforeModalCreated: function () {
        this.userSettings = this.options.invoicesView.userSettings;
    },
    beforeRender: function () {
        // copy userSettings for our UI; we only update global userSettings object on save.
        this.options.userSettings = [];

        this.options.defaultStatusFilter = this.userSettings.get('defaultStatusFilter');
        _.each(this.userSettings.attributes.viewSettings, _.bind(function (setting) {
            let columns = this.options.invoicesView.dataTable.getColumns(true),
                selectedColumns = (_.size(setting.columns) > 0) ? setting.columns : setting.columnsDefault;
            _.each(columns, _.bind(function (column) {
                column.visible = selectedColumns.indexOf(column.columnData) !== -1
            }, this));

            this.options.userSettings.push({
                view: setting.view,
                rowsPerPage: setting.rowsPerPage,
                columns: columns
            });
        }, this));
    },
    renderData: function () {
        return {
            userSettings: this.userSettings
        }
    },
    afterRender: function () {
        this.defaultFilterSelectPicker = new PJQ.inputs.Selectpicker({
            el: this.$('.select-filter-default'),
            isIntChoices: true,
            isMultiple: true,
            defaultValue: this.userSettings.get('defaultStatusFilter'),
            onChange: _.bind(function (value) {
                this.options.defaultStatusFilter = value
            }, this)
        });

        this.rowsPerPage = new PJQ.inputs.Selectpicker({
            el: this.$('select.rows-per-page'),
            isIntChoices: true,
            onChange: _.bind(function (value) {
                this.currentView.rowsPerPage = value;
            }, this)
        });

        this.selectView(PJQ.constants.invoicing.view.PAYABLE_INVOICES);
    },
    editCompanySettings: function () {
        this.userSettings = new PJQ.models.invoicing.PayableInvoiceUserSettings(null, {
            forCompany: true
        });
        this.userSettings.fetch({
            success: _.bind(function () {
                this.render();
            }, this)
        });
    },
    selectView: function (view) {
        this.currentView = _.find(this.options.userSettings, _.bind(function (setting) {
            return setting.view === view;
        }, this));

        if (view.indexOf('-') === -1) {
            this.rowsPerPage.setValue(this.currentView.rowsPerPage);
            this.$('div.rows-per-page').show();
        }
        else
            this.$('div.rows-per-page').hide();

        if (this.dataTable) {
            this.dataTable.undelegateEvents();
            $(this.dataTable.el).empty();
        }

        this.dataTable = new PJQ.views.dataTables.DataTable({
            el: this.$('div.select-columns-datatable'),
            data: this.currentView.columns,
            isHideSearch: true,
            pageLength: 6,
            order: [],
            columns: [
                {"data": "title", "title": "Column", "orderable": false},
                {
                    "data": "visible",
                    "title": "Show",
                    "orderable": false,
                    "searchable": false,
                    "render": _.bind(function (data) {
                        return ('<div class="text-align-center"><div class="pretty p-default p-smooth fs-18 m-0"><input type="checkbox"' + (data ? ' checked ' : '') + 'class="select-column"/><div class="state p-primary"><label class="wd-0">&nbsp;</label></div></div></div>');
                    }, this),
                    "width": '10%'
                }
            ],
            dom: '<"top"<"clear">>rt<"bottom"p<"clear">>'
        });

    },
    columnSelected: function (sender) {
        this.dataTable.dataTable.row($(sender.currentTarget).closest('tr')).data().visible = $(sender.currentTarget).prop('checked');
    },
    onSave: function () {
        let fnOnSave = _.bind(function () {
            if (typeof this.options.onSave === 'function')
                this.options.onSave();
            this.removeModal();
        }, this);

        this.userSettings.set('defaultStatusFilter', this.options.defaultStatusFilter);

        _.each(this.options.userSettings, _.bind(function (settingTemp) {
            _.each(this.userSettings.get('viewSettings'), _.bind(function (setting) {
                if (settingTemp.view === setting.view) {
                    setting.rowsPerPage = settingTemp.rowsPerPage;

                    let columns = _.size(setting.columns) > 0 ? setting.columns.slice() : setting.columnsDefault.slice();

                    // update columns
                    _.each(settingTemp.columns, _.bind(function (column) {
                        if (column.visible) {
                            if (columns.indexOf(column.columnData) === -1)
                                columns.push(column.columnData);
                        }
                        else {
                            if (columns.indexOf(column.columnData) !== -1)
                                columns = _.filter(columns, _.bind(function (columnTemp) {
                                    return columnTemp != column.columnData;
                                }, this));
                        }
                    }, this));

                    setting.columns = columns;
                }
            }, this));
        }, this));

        this.userSettings.save(null, {
            success: _.bind(function () {
                fnOnSave();
            }, this)
        });
    },
});
PJQ.views.invoicing.ReceivableInvoiceDataTable = PJQ.views.dataTables.DataTable.extend({
    defaults: {
        language: {
            emptyTable: 'No Receivable Invoices have been created yet',
            zeroRecords: "No Receivable Invoices matched the search criteria"
        },
        subTemplates: {
            header: new PJQ.templating.Template(PJQ.constants.modules.INVOICING, 'data-table-header-receivable-invoices')
        },
        toggleRowClass: '.change-order-toggle-row',
        onViewInvoice: null
    },
    events: {
        'click .btn-view-invoice': 'viewInvoiceClicked',
        'click .view-contract': 'viewPrimeContractClicked'
    },
    beforeDataTableRender: function () {
        this.options.pageLength = this.options.settings ? this.options.settings.rowsPerPage : 10;
    },
    getDefaultFilter: function () {
        return _.size(this.options.statusIds) > 0 ? this.options.statusIds : this.options.userSettings.get('defaultStatusFilter');
    },
    afterHeaderRender: function () {
        new PJQ.inputs.Selectpicker({
            el: this.$('.receivable-invoice-status-filter'),
            defaultValue: this.getDefaultFilter(),
            isIntChoices: true,
            isMultiple: true,
            noneSelectedText: 'No Filters',
            onChange: _.bind(function (value) {
                this.setFilter(PJQ.constants.invoicing.filterType.STATUS_FILTER, value);
            }, this)
        });
        this.setFilter(PJQ.constants.invoicing.filterType.STATUS_FILTER, this.getDefaultFilter());

        let currentBillingPeriod = _.find(this.options.billingPeriodSettings.billingPeriods.models, function (period) {
                return period.get('isCurrent');
            }),
            bpId = currentBillingPeriod && !this.options.showAllBillingPeriods ? currentBillingPeriod.id : null;
        this.setFilter('billingPeriodId', bpId);
        new PJQ.inputs.Selectpicker({
            el: this.$('.select-billing-period'),
            defaultValue: bpId,
            isMultiple: false,
            isIntChoices: true,
            onChange: _.bind(function (value) {
                this.setFilter('billingPeriodId', value);
            }, this)
        });
    },
    getFilterData: function () {
        let statusFilter = this.getFilter(PJQ.constants.invoicing.filterType.STATUS_FILTER),
            billingPeriodFilter = this.getFilter('billingPeriodId'),
            data = this.options.data;
        if (_.size(statusFilter) === 0 && billingPeriodFilter == null) {
            return data;
        }

        if (billingPeriodFilter != null) {
            let fnBPFilter = _.bind(function (data) {
                let billingPeriod = this.options.billingPeriodSettings.billingPeriods.get(billingPeriodFilter),
                    startA = billingPeriod.get('startDate'),
                    endA = billingPeriod.get('endDate');
                return _.filter(data, function (row) {
                    let startB = row.get('startDate'),
                        endB = row.get('endDate');
                    return billingPeriodFilter === row.get('billingPeriodId') || PJQ.helpers.dateHelpers.checkDateRangesOverlap(startA, endA, startB, endB);
                });
            }, this);
            return fnBPFilter(_.filter(data, function (row) {
                return _.size(statusFilter) === 0 || _.contains(statusFilter, row.get('statusId'));
            }));
        } else {
            return _.filter(data, function (row) {
                return _.contains(statusFilter, row.get('statusId'));
            });
        }
    },
    getColumns: function (includeAllColumns = false) {
        this.options.canViewPrimeContracts = PJQ.app.session.project.hasPermission('primeContracts.canView');

        let columns = [],
            includeColumns = ['number', 'contract', 'billingDate', 'startDate', 'endDate', 'status', 'amount', 'taxAmount', 'grandTotal', 'paymentAmount', 'retainage', 'retainageReleased', 'paid'];

        if (this.options.customFields) {
            _.each(this.options.customFields.models, _.bind(function (customField) {
                includeColumns.push('fieldValue' + customField.get('fieldNumber'));
            }, this));
        }

        if (!includeAllColumns) {
            if (this.options.settings && _.size(this.options.settings.columns) > 0)
                includeColumns = this.options.settings.columns;
            else
                includeColumns = this.options.settings && this.options.settings.columnsDefault ? this.options.settings.columnsDefault : includeColumns;

            columns.push({
                "columnData": "",
                "data": null,
                "title": "",
                "width": "20px",
                "orderable": false,
                "searchable": false,
                "defaultContent": '',
                "render": (data, type, row) => {
                    if (!this.options.isAdmin) {
                        return "";
                    }

                    let exObj = row.get('externalObject');
                    if (exObj == null) {
                        return '';
                    }

                    return PJQ.helpers.erp.getERPBadge(exObj.status, exObj);
                }
            });
        }

        _.each(includeColumns, _.bind(function (columnName) {
            switch (columnName) {
                case 'status':
                    columns.push({
                        "columnData": "status",
                        "data": "attributes.statusId",
                        "title": "Status",
                        "width": "100px",
                        "render": _.bind(function (data, type, row) {
                            return PJQ.constants.invoicing.receivableInvoiceStatusNames[row.get('statusId')]
                        }, this)
                    });
                    break;
                case 'number':
                    columns.push({
                        "columnData": "number",
                        "data": "attributes.number",
                        "title": "Number",
                        "render": _.bind(function (data, type, row) {
                            if (type === 'sort' || type === 'type') {
                                return row.get('number');
                            }

                            return '<a class="btn-view-invoice" href="javascript:void(0)" data-id="' + row.id + '">' + row.get('number') + '</a>';
                        }, this)
                    });
                    break;
                case 'contract':
                    columns.push({
                        "columnData": "contract",
                        "title": "Contract",
                        "data": "attributes.primeContractNumber",
                        "orderable": true,
                        "render": _.bind(function (data, type, row) {
                            if (type === 'sort' || type === 'type') {
                                return row.get('primeContractNumber');
                            }

                            if (this.options.canViewPrimeContracts) {
                                return '<a class="view-contract" href="javascript:void(0)" data-id="' + row.get('primeContractId') + '">' + row.get('primeContractNumber') + '</a>';
                            }
                            return data;
                        }, this)
                    },);
                    break;
                case 'notes':
                    columns.push({
                        "columnData": "notes",
                        "data": "attributes.notes",
                        "title": "Notes"
                    });
                    break;
                case 'billingDate':
                    columns.push({
                        "columnData": "billingDate",
                        "data": "attributes.billingDate",
                        "title": 'Due Date',
                        "width": '90px',
                        "render": _.bind(function (data, type, row) {
                            if (_.size(data) === 0) {
                                return '';
                            } else if (type === 'sort' || type === 'type') {
                                return data ? new Date(data) : null;
                            }
                            return PJQ.helpers.dateHelpers.getDateString(new Date(data), PJQ.helpers.dateHelpers.dateFormats.DATE, true);
                        }, this)
                    });
                    break;
                case 'startDate':
                    columns.push({
                        "columnData": "startDate",
                        "data": "attributes.startDate",
                        "title": 'Start Date',
                        "width": '90px',
                        "render": _.bind(function (data, type, row) {
                            if (_.size(data) === 0) {
                                return '';
                            } else if (type === 'sort' || type === 'type') {
                                return data ? new Date(data) : null;
                            }
                            return PJQ.helpers.dateHelpers.getDateString(new Date(data), PJQ.helpers.dateHelpers.dateFormats.DATE, true);
                        }, this)
                    });
                    break;
                case 'endDate':
                    columns.push({
                        "columnData": "endDate",
                        "data": "attributes.endDate",
                        "title": 'End Date',
                        "width": '90px',
                        "render": _.bind(function (data, type, row) {
                            if (_.size(data) === 0) {
                                return '';
                            } else if (type === 'sort' || type === 'type') {
                                return data ? new Date(data) : null;
                            }
                            return PJQ.helpers.dateHelpers.getDateString(new Date(row.get('endDate')), PJQ.helpers.dateHelpers.dateFormats.DATE, true);
                        }, this)
                    });
                    break;
                case 'createdOn':
                    columns.push({
                        "columnData": "createdOn",
                        "data": "attributes.createdOn",
                        "title": 'Created Date',
                        "width": '90px',
                        "render": _.bind(function (data, type, row) {
                            if (_.size(data) === 0) {
                                return '';
                            } else if (type === 'sort' || type === 'type') {
                                return data ? new Date(data) : null;
                            }
                            return PJQ.helpers.dateHelpers.getDateString(new Date(data), PJQ.helpers.dateHelpers.dateFormats.DATE_TIME);
                        }, this)
                    });
                    break;
                case 'amount':
                    columns.push({
                        "columnData": "amount",
                        "data": "attributes.amount",
                        "width": "10%",
                        "title": "Amount",
                        "className": "text-align-right",
                        "render": _.bind(function (data, type, row) {
                            return PJQ.helpers.formatHelpers.formatCurrency(row.get('amount'));
                        }, this)
                    });
                    break;
                case 'taxAmount':
                    columns.push({
                        "columnData": "taxAmount",
                        "data": "attributes.taxAmount",
                        "title": "Tax",
                        "width": "100px",
                        "render": _.bind(function (data, type, row) {
                            return PJQ.helpers.formatHelpers.formatCurrency(data);
                        }, this)
                    });
                    break;
                case 'retainageReleased':
                    columns.push({
                        "columnData": "retainageReleased",
                        "data": "attributes.retainageReleased",
                        "title": "Retainage Released",
                        "width": "100px",
                        "render": _.bind(function (data, type, row) {
                            return PJQ.helpers.formatHelpers.formatCurrency(row.getRetainageReleased());
                        }, this)
                    });
                    break;
                case 'retainage':
                    columns.push({
                        "columnData": "retainage",
                        "data": "attributes.retainage",
                        "title": "Retainage",
                        "width": "100px",
                        "render": _.bind(function (data, type, row) {
                            return PJQ.helpers.formatHelpers.formatCurrency(row.getRetainage());
                        }, this)
                    });
                    break;
                case 'grandTotal':
                    columns.push({
                        "columnData": "grandTotal",
                        "data": "attributes.amount",
                        "title": "Grand Total",
                        "width": "100px",
                        "render": _.bind(function (data, type, row) {
                            return PJQ.helpers.formatHelpers.formatCurrency(row.getGrandTotal());
                        }, this)
                    });
                    break;
                case 'paymentAmount':
                    columns.push({
                        "columnData": "paymentAmount",
                        "data": "attributes.paymentAmount",
                        "title": "Payments",
                        "width": "100px",
                        "render": _.bind(function (data, type, row) {
                            return PJQ.helpers.formatHelpers.formatCurrency(data);
                        }, this)
                    });
                    break;
                case 'paid':
                    columns.push({
                        "columnData": "paid",
                        "data": "attributes.paid",
                        "title": "Paid",
                        "width": "100px",
                        "render": _.bind(function (data, type, row) {
                            return data ? 'Yes' : 'No';
                        }, this)
                    });
                    break;
                default:
                    if (columnName.startsWith('fieldValue')) {
                        _.each(this.options.customFields.models, function (customField) {
                            if (columnName === 'fieldValue' + customField.get('fieldNumber')) {
                                columns.push({
                                    "columnData": 'fieldValue' + customField.get('fieldNumber'),
                                    "title": customField.get('name'),
                                    "render": function (data, type, row) {
                                        let fieldValue = row.getCustomFieldValue(customField.get('id'));
                                        fieldValue = (fieldValue !== null) ? fieldValue : '';
                                        switch (customField.get('fieldTypeId')) {
                                            case PJQ.constants.commitments.customFieldType.BOOLEAN:
                                                if (fieldValue != null)
                                                    fieldValue = fieldValue ? 'Yes' : 'No';
                                                break;
                                            case PJQ.constants.commitments.customFieldType.CHOICE:
                                                let choices = [];
                                                // convert single choice value into array so that the logic below can work for both types.
                                                if (typeof fieldValue === 'number')
                                                    fieldValue = [fieldValue];

                                                _.each(customField.choices.models, _.bind(function (choice) {
                                                    if (_.find(fieldValue, function (value) {
                                                        return value === choice.get('id');
                                                    }))
                                                        choices.push(choice.get('name'));
                                                }, this));

                                                fieldValue = choices.join((', '));
                                                break;
                                            case PJQ.constants.commitments.customFieldType.DATE:
                                                if (fieldValue) {
                                                    if (type !== 'sort' && type !== 'type')
                                                        fieldValue = PJQ.helpers.dateHelpers.getDateString(new Date(fieldValue), PJQ.helpers.dateHelpers.dateFormats.DATE, true);
                                                }
                                                if (fieldValue === undefined)
                                                    fieldValue = '';

                                                break;
                                            case PJQ.constants.commitments.customFieldType.DATETIME:
                                                if (fieldValue) {
                                                    if (type !== 'sort' && type !== 'type')
                                                        fieldValue = PJQ.helpers.dateHelpers.getDateString(new Date(fieldValue), PJQ.helpers.dateHelpers.dateFormats.DATE_TIME);
                                                }
                                                if (fieldValue === undefined)
                                                    fieldValue = '';

                                                break;
                                            case PJQ.constants.commitments.customFieldType.INTEGER:
                                                if (type !== 'sort' && type !== 'type' && fieldValue) {
                                                    fieldValue = parseInt(fieldValue).toLocaleString();
                                                }
                                                break;
                                            case PJQ.constants.commitments.customFieldType.MONEY:
                                                if (type === 'sort' || type === 'type') {
                                                    if (fieldValue && fieldValue !== '$')
                                                        fieldValue = parseFloat(PJQ.helpers.formatHelpers.numbersOnly(fieldValue, true));
                                                    else
                                                        fieldValue = 0;
                                                } else {
                                                    fieldValue = PJQ.helpers.formatHelpers.formatCurrency(parseInt(PJQ.helpers.formatHelpers.numbersOnly(fieldValue)));
                                                }
                                                break;
                                            case PJQ.constants.commitments.customFieldType.PERCENT:
                                                if (type === 'sort' || type === 'type') {
                                                    if (fieldValue && fieldValue !== '$')
                                                        fieldValue = parseFloat(PJQ.helpers.formatHelpers.numbersOnly(fieldValue, true)).toFixed(2);
                                                    else
                                                        fieldValue = 0;
                                                } else {
                                                    fieldValue = fieldValue ? fieldValue.toString() + '%' : '';
                                                }

                                                break;
                                        }

                                        return fieldValue;
                                    }
                                });
                            }
                        });
                    }
                    break;
            }
        }, this));

        if (!includeAllColumns) {
            columns.push({
                "title": '',
                "render": _.bind(function (data, type, row) {
                    return '<div class="show-on-row-hover"><button type="button" class="btn btn-info btn-view-invoice ml-1" title="View invoice"><i class="fal fa-arrow-alt-from-left"></i></button></div>';
                }, this),
                "orderable": false,
                "searchable": false,
                "width": "90px",
                "className": "text-center",
                "visible": true
            });
        }

        return columns;
    },
    getRowChildTable: function (childOpts) {
        childOpts.costTypes = this.options.costTypes;
        childOpts.unitsOfMeasure = this.options.unitsOfMeasure;
        childOpts.groups = this.options.groups;
        childOpts.parentDataTable = this;
        childOpts.dom = 't';
        return new PJQ.views.commitments.LineItemDataTable(childOpts);
    },
    getRowChildData: function (row) {
        return new PJQ.collections.commitments.ChangeOrderLineItems(null, {
            changeOrderId: row.data().id
        });
    },
    viewInvoiceClicked: function (e) {
        if (typeof (this.options.onViewInvoice) === 'function') {
            let row = this.getRow((e.currentTarget).closest('tr')),
                invoice = row.data();
            if (invoice != null) {
                this.options.onViewInvoice(invoice);
            }
        }
    },
    viewPrimeContractClicked: function (e) {
        let row = this.getRow((e.currentTarget).closest('tr'));
        this.viewPrimeContract(row.data().get('primeContractId'));
    },
    viewPrimeContract: function (primeContractId) {
        new PJQ.views.primeContracts.PrimeContractEditModal({
            model: new PJQ.models.primeContracts.PrimeContract({
                id: primeContractId
            })
        });
    }
});
PJQ.views.invoicing.EditReceivableInvoiceModal = PJQ.views.BaseModal.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.INVOICING, 'modal-receivable-invoice-edit'),
        width: '95%',
        maxWidth: 1500,
        model: null,
        isShowCloseButton: true,
        onSave: _.noop(),
        onDelete: _.noop()
    },
    events: {
        'click .btn-view-prime-contract': 'viewPrimeContract',
        'click .btn-view-payment': 'viewPaymentClicked',
        'click .btn-new-payment': 'newPayment',
        'click .btn-add-line-item': 'addLineItem',
        'click .btn-delete': 'delete',
        'click .btn-close': 'close',
        'click .btn-save-email': 'saveEmail',
        'click .btn-save': 'saveInvoice',
        'click .btn-push-erp': 'pushERP',
        'click .erp-sync-payments .btn-pull-erp': 'pullERPPayments',
        'click .btn-undo-push-erp': 'undoPushERP',
        'click .btn-unlink-erp': 'unlinkERP',
        'click .btn-export': 'exportInvoice',
        'click .btn-email': 'email',
        'click .nav-link': 'activeViewChanged',
        'change .cb-paid': 'updatePaid',
        'click .btn-view-history': 'viewHistory'
    },
    beforeModalCreated: async function () {
        this.options.project = PJQ.app.session.project;
        this.isFetched = false;

        this.coreFieldSettings = await PJQ.app.session.fetchReceivableInvoiceFieldSettings();
        this.settings = await this.options.project.fetchReceivableInvoiceSettings();
        this.customFields = await this.options.project.fetchReceivableInvoiceCustomFields();
        this.billingPeriodSettings = await this.options.project.fetchBillingPeriodSettings();
        this.costCodes = await this.options.project.fetchCostCodes();
        this.costTypes = await this.options.project.fetchCostTypes();
        this.unitsOfMeasure = await this.options.project.fetchUnitsOfMeasure();

        if (this.model == null) {
            let customFieldValues = [];
            _.each(this.customFields.models, function (model, index) {
                let value = model.get('defaultValue') ? model.get('defaultValue') : '';
                if (model.get('fieldType') === 'CHOICE') {
                    value = parseInt(value);
                }
                customFieldValues.push({
                    fieldNumber: model.get('fieldNumber'),
                    fieldTypeId: model.get('fieldTypeId'),
                    fieldType: model.get('fieldType'),
                    isMultiple: model.get('isMultiple'),
                    value: value,
                    id: model.get('id')
                })
            }, this);

            this.model = new PJQ.models.invoicing.ReceivableInvoice({
                notes: '',
                number: '',
                primeContractId: this.options.primeContract.id,
                primeContractNumber: this.options.primeContract.get('number'),
                projectId: this.options.primeContract.get('projectId'),
                companyId: this.options.primeContract.get('companyId'),
                client: this.options.primeContract.client,
                statusId: PJQ.constants.invoicing.receivableInvoiceStatus.DRAFT,
                customFieldValues: customFieldValues
            });

            let billingPeriod = _.find(this.billingPeriodSettings.billingPeriods.models, function (billingPeriod) {
                return billingPeriod.get('isCurrent');
            })
            if (billingPeriod != null) {
                this.model.set({
                    billingPeriodId: billingPeriod.id,
                    startDate: PJQ.helpers.dateHelpers.parseDateString(billingPeriod.get('startDate'), false),
                    endDate: PJQ.helpers.dateHelpers.parseDateString(billingPeriod.get('endDate'), false),
                    billingDate: PJQ.helpers.dateHelpers.parseDateString(billingPeriod.get('dueDate'), false)
                });
            }
        }

        if (!this.model.isNew()) {
            await this.model.fetch();
        }

        this.erpIntegration = await PJQ.app.session.fetchERPIntegration();
        if (this.erpIntegration != null && this.erpIntegration.getSetting('syncProjects')) {
            await this.options.project.fetchERPObject();

            if (this.options.primeContract == null) {
                this.options.primeContract = new PJQ.models.primeContracts.PrimeContract({
                    id: this.model.get('primeContractId')
                });
                await this.options.primeContract.fetch();
            }
        }

        this.isFetched = true;
        this.render();
    },
    beforeRender: function () {
        if (this.model == null) {
            return;
        }

        this.options.disabledStatuses = null;
        this.options.canEdit = PJQ.app.session.project.hasPermission('receivableInvoices.canEdit');
        this.options.canEditLineItems = this.options.canEdit;
        this.options.canEditBillingDates = PJQ.app.session.project.hasPermission('receivableInvoices.canEdit');
        this.options.canViewPrimeContracts = PJQ.app.session.project.hasPermission('primeContracts.canView');
        this.options.isAdmin = PJQ.app.session.project.hasPermission('receivableInvoices.isAdmin');
        this.options.canAddPayments = this.options.canEdit;
        this.options.canDelete = this.options.isAdmin;
        this.options.canEditStatus = this.options.isAdmin;

        let status = this.model.get('statusId');
        if (this.model.isNew() || status === PJQ.constants.invoicing.receivableInvoiceStatus.DRAFT) {
            this.options.canEdit = true;
            this.options.canEditStatus = !this.model.isNew();
            this.options.canEditBillingDates = true;
            this.options.canEditLineItems = true;
            this.options.canDelete = !this.model.isNew();
        } else if (status === PJQ.constants.invoicing.receivableInvoiceStatus.APPROVED || status === PJQ.constants.invoicing.receivableInvoiceStatus.COMPLETE) {
            this.options.canEdit = PJQ.app.session.project.hasPermission('receivableInvoices.canEdit');
            this.options.canEditBillingDates = false
            this.options.canEditLineItems = false;
            this.options.canDelete = false;
        } else {
            this.options.canEdit = PJQ.app.session.project.hasPermission('receivableInvoices.canEdit');
            this.options.canEditBillingDates = PJQ.app.session.project.hasPermission('receivableInvoices.canEdit');
            this.options.canEditLineItems = true;
            this.options.canDelete = this.options.isAdmin;
        }

        if (status !== PJQ.constants.invoicing.receivableInvoiceStatus.APPROVED && status !== PJQ.constants.invoicing.receivableInvoiceStatus.COMPLETE) {
            this.options.canAddPayments = false;
        }

        this.options.disabledStatuses = null;
        let fnGetGreaterStatuses = (statusId) => {
            return _.filter(PJQ.constants.invoicing.receivableInvoiceStatus, (st) => {
                return st < statusId;
            });
        };

        let syncStatus = this.model.erpSyncStatus(),
            isERPSynced = syncStatus === PJQ.constants.integrations.erp.syncStatuses.REVIEWING
                || syncStatus === PJQ.constants.integrations.erp.syncStatuses.APPROVED
                || syncStatus === PJQ.constants.integrations.erp.syncStatuses.SYNCED;
        if ((status === PJQ.constants.invoicing.receivableInvoiceStatus.APPROVED || status === PJQ.constants.invoicing.receivableInvoiceStatus.COMPLETE)
            && (this.model.payments.models.length > 0 || this.model.get('isLatest') === false || isERPSynced)) {
            this.options.canEditLineItems = false;
            this.options.disabledStatuses = _.union(fnGetGreaterStatuses(PJQ.constants.invoicing.receivableInvoiceStatus.APPROVED), [PJQ.constants.invoicing.receivableInvoiceStatus.VOID]);
        }

        if (this.model.isNew()) {
            this.options.canEditStatus = false;
        }

        if (this.erpIntegration != null && isERPSynced) {
            this.options.canEdit = false;
            this.options.canEditLineItems = false;
            this.options.canDelete = false;
            this.options.isSubmitting = false;
        }
    },
    renderData: function () {
        return {
            model: this.model,
            erpIntegration: this.erpIntegration,
            customFields: this.customFields,
            billingPeriods: this.billingPeriodSettings != null ? this.billingPeriodSettings.billingPeriods : null,
            canEdit: this.options.canEdit,
            canDelete: this.options.canDelete,
            isAdmin: this.options.isAdmin,
            canViewPrimeContracts: this.options.canViewPrimeContracts,
            canAddPayments: this.options.canAddPayments,
            isFetched: this.isFetched,
            canEditBillingDates: this.options.canEditBillingDates,
            settings: this.settings,
            invoiceSettings: this.invoiceSettings,
            activeView: this.options.activeView,
            views: this.views,
            checkFieldVisible: _.bind(this.checkFieldVisible, this),
            checkFieldRequired: _.bind(this.checkFieldRequired, this)
        }
    },
    afterRender: function () {
        if (!this.isFetched)
            return;

        this.activateView(this.options.activeView);

        this.stopListening(this.model);
        this.listenTo(this.model, 'change:statusId', () => {
            this.renderERP();
        });
        this.stopListening(this.model.lineItems);
        this.listenTo(this.model.lineItems, 'update', () => {
            this.renderERP();
        });
        this.renderERP();

        this.renderGeneral();

        if (!this.model.isNew()) {
            this.renderLineItems();
            this.renderPayments();
        }

        this.updateCounts();
    },
    updateCounts: function () {
        this.$('.count-line-items').text(_.size(this.model.lineItems.models));
        this.$('.count-payments').text(_.size(this.model.payments.models));
    },
    views: {
        GENERAL: 'RI_General',
        LINEITEMS: 'RI_LineItems',
        PAYMENTS: 'RI_Payments',
        SUMMARY: 'RI_Summary'
    },
    activeViewChanged: function (e) {
        let view = e.target.hash ? e.target.hash.replace('#', '') : null;
        this.activateView(view);
    },
    activateView: function (view) {
        if (view == null) {
            view = this.views.GENERAL;
        }

        this.$('.nav-link[href="#' + view + '"]').tab('show');
        this.options.activeView = view;

        if (view === this.views.LINEITEMS) {
            // this.lineItemsView.adjustColumns();
        } else if (view === this.views.SUMMARY) {
            this.renderSummary();
        }
    },
    renderERP: function () {
        let $erp = this.$('.erp-sync');
        if (!this.options.isAdmin || this.erpIntegration == null || !this.options.project.isERPSynced() || this.model.isNew()) {
            $erp.remove();
            return;
        }

        this.$('.erp-badge').html(PJQ.helpers.erp.getERPBadge(this.model.erpSyncStatus(), this.model.get('externalObject')));

        let canPush = true,
            disablePushReason = "";

        if (_.size(this.model.lineItems) === 0
            || (this.model.get('statusId') !== PJQ.constants.invoicing.receivableInvoiceStatus.APPROVED && this.model.get('statusId') !== PJQ.constants.invoicing.receivableInvoiceStatus.COMPLETE)) {
            canPush = false;
            disablePushReason = "Invoice must be approved or complete and have line items";
        }

        if (!this.options.primeContract.isERPSynced() && !this.erpIntegration.hasAvailableAction(PJQ.constants.integrations.actions.PUSH_RECEIVABLE_INVOICES_WO_SYNCED_CONTRACT)) {
            canPush = false;
            disablePushReason = "The contract for this invoice is not synced";
        }

        PJQ.helpers.erp.renderERPButtons($erp, {
            pushSupported: this.erpIntegration.hasAvailableAction(PJQ.constants.integrations.actions.PUSH_RECEIVABLE_INVOICES),
            canPush: canPush,
            disablePushReason: disablePushReason,
            status: this.model.erpSyncStatus(),
            unlinkSupported: this.erpIntegration.hasAvailableAction(PJQ.constants.integrations.actions.UNLINK_RECEIVABLE_INVOICES),
            canPushChanges: false
        });

        let $erpPayments = this.$('.erp-sync-payments');
        PJQ.helpers.erp.renderERPButtons($erpPayments, {
            pushSupported: false,
            pullSupported: this.erpIntegration.hasAvailableAction(PJQ.constants.integrations.actions.PULL_RECEIVABLE_PAYMENTS)
        });
    },
    pushERP: function (callback) {
        if (!this.erpIntegration.hasAvailableAction(PJQ.constants.integrations.actions.PUSH_RECEIVABLE_INVOICES)) {
            return;
        }

        this.save((success) => {
            if (success) {
                this.erpIntegration.pushReceivableInvoice(this.model, _.bind(function () {
                    PJQ.notifications.notify.successNotify({
                        message: 'Invoice pushed to ERP'
                    });

                    if (typeof this.options.onSave === 'function') {
                        this.options.onSave(this.model);
                    }

                    if (typeof callback === 'function') {
                        callback();
                    } else {
                        this.render();
                    }
                }, this));
            }
        });
    },
    undoPushERP: function () {
        if (this.model.erpSyncStatus() === PJQ.constants.integrations.erp.syncStatuses.REVIEWING) {
            this.erpIntegration.undoPush(this.model, _.bind(function () {
                PJQ.notifications.notify.successNotify({
                    message: 'Invoice removed from ERP approval'
                });

                if (typeof this.options.onSave === 'function') {
                    this.options.onSave(this.model);
                }

                this.render();
            }, this));
        }
    },
    unlinkERP: function () {
        new PJQ.views.modals.YesNo({
            header: "Unlink from ERP",
            body: "Are you sure you want to unlink this Receivable Invoice from your ERP system?",
            onYes: () => {
                let loader = new PJQ.Loader(this.$('.modal-content'));
                this.erpIntegration.unlinkReceivableInvoice(this.model, (success) => {
                    if (success) {
                        loader.remove();
                        PJQ.notifications.notify.successNotify({
                            message: 'Receivable Invoice unlinked from ERP'
                        });

                        if (typeof this.options.onSave === 'function') {
                            this.options.onSave(this.model);
                        }

                        this.render();
                    }
                });
            }
        });
    },
    renderSummary: function () {
        this.summaryView = new PJQ.views.invoicing.InvoiceSummary({
            el: this.$('.invoice-summary'),
            model: this.model,
            export: () => {
                this.save(() => {
                    PJQ.files.downloadFile(PJQ.helpers.urlHelpers.generateEndpoint([
                        {
                            endpoint: 'receivableinvoices',
                            value: this.model.get('id')
                        },
                        {
                            endpoint: 'summary'
                        },
                        {
                            endpoint: 'export',
                        }
                    ]), {isAPIv2: true});
                });
            }
        })
    },
    renderGeneral: function () {
        new PJQ.Binder(this.$el, this.model, {
            canEdit: !this.options.canEdit ? false : null,
            useDecimalPercentFields: true,
            watchElements: [
                'input',
                'textarea'
            ]
        });

        new PJQ.views.contacts.ContactsSelectInput({
            el: this.$('.invoice-client'),
            selectedContact: this.model.client,
            canViewContacts: this.options.project.hasPermission('projectContacts.canView'),
            canEdit: false,
            displayContactsBlock: true,
        });

        this.statusPicker = new PJQ.inputs.Selectpicker({
            el: this.$('.select-status'),
            isIntChoices: true,
            defaultValue: this.model.get('statusId'),
            canEdit: this.options.canEditStatus,
            choices: _.map(PJQ.constants.invoicing.receivableInvoiceStatus, (st) => {
                return {
                    id: st,
                    name: PJQ.constants.invoicing.receivableInvoiceStatusNames[st],
                    disabled: this.options.disabledStatuses != null && this.options.disabledStatuses.indexOf(st) > -1
                }
            }),
            onChange: (newStatus) => {
                let oldStatus = this.model.get('statusId');
                if (newStatus === oldStatus) {
                    return;
                }

                this.model.set('statusId', newStatus);
                if (!this.model.isNew()) {
                    this.save((success) => {
                        if (success) {
                            PJQ.notifications.notify.successNotify({
                                message: 'Invoice saved successfully'
                            });
                        } else {
                            this.model.set('statusId', oldStatus);
                            this.statusPicker.setValue(oldStatus);
                        }
                    });
                } else {
                    this.render();
                }
            }
        });

        new PJQ.inputs.Selectpicker({
            el: this.$('.select-billing-period'),
            defaultValue: this.model.get('billingPeriodId') != null ? this.model.get('billingPeriodId') : _.find(this.billingPeriodSettings.billingPeriods.models, function (billingPeriod) {
                return billingPeriod.get('isCurrent');
            }),
            isMultiple: false,
            isIntChoices: true,
            canEdit: this.options.canEdit,
            onChange: _.bind(function (value) {
                let billingPeriod = this.billingPeriodSettings != null && value != null ? this.billingPeriodSettings.billingPeriods.get(value) : null;
                this.model.set('billingPeriodId', value);
                this.$('.period-start').attr('disabled', billingPeriod != null);
                this.$('.period-end').attr('disabled', billingPeriod != null);
                if (billingPeriod != null) {
                    let startDate = PJQ.helpers.dateHelpers.parseDateString(billingPeriod.get('startDate'), false),
                        endDate = PJQ.helpers.dateHelpers.parseDateString(billingPeriod.get('endDate'), false),
                        dueDate = PJQ.helpers.dateHelpers.parseDateString(billingPeriod.get('dueDate'), false);
                    this.periodStartPicker.setValue(startDate);
                    this.model.set('startDate', startDate);

                    this.periodEndPicker.setValue(endDate);
                    this.model.set('endDate', endDate);

                    this.dueDatePicker.setValue(dueDate);
                    this.model.set('billingDate', dueDate);
                }
            }, this)
        });

        this.periodStartPicker = new PJQ.inputs.Datepicker({
            el: this.$('.period-start'),
            canEdit: this.options.canEdit && !(this.model.get('billingPeriodId') > 0),
            datepickerOptions: {
                format: PJQ.helpers.dateHelpers.dateFormats.datePicker.DATE,
                defaultDate: this.model.get('startDate') != null ? PJQ.helpers.dateHelpers.parseDateString(this.model.get('startDate'), false) : null
            },
            onChange: _.bind(function (newDate) {
                this.model.set('startDate', newDate);
            }, this)
        });

        this.periodEndPicker = new PJQ.inputs.Datepicker({
            el: this.$('.period-end'),
            canEdit: this.options.canEdit && !(this.model.get('billingPeriodId') > 0),
            datepickerOptions: {
                format: PJQ.helpers.dateHelpers.dateFormats.datePicker.DATE,
                defaultDate: this.model.get('endDate') != null ? PJQ.helpers.dateHelpers.parseDateString(this.model.get('endDate'), false) : null
            },
            onChange: _.bind(function (newDate) {
                this.model.set('endDate', newDate);
            }, this)
        });

        this.dueDatePicker = new PJQ.inputs.Datepicker({
            el: this.$('.due-date'),
            canEdit: this.options.canEdit,
            datepickerOptions: {
                format: PJQ.helpers.dateHelpers.dateFormats.datePicker.DATE,
                defaultDate: this.model.get('billingDate') != null ? PJQ.helpers.dateHelpers.parseDateString(this.model.get('billingDate'), false) : null
            },
            onChange: _.bind(function (newDate) {
                this.model.set('billingDate', newDate);
            }, this)
        });

        if (this.checkFieldVisible('attachments')) {
            this.fileUploader = new PJQ.views.files.FileUploaderGrid({
                el: this.$('.invoice-file-uploader'),
                collection: this.model.attachments,
                canUpload: this.options.canEdit,
                useApiV2: true,
                canView: false,
                useBlob: true,
                canDelete: this.options.canEdit && this.options.isAdmin,
                previewImageDimension: 150,
                onSuccess: _.bind(function (file) {
                    this.model.isDirty = true;
                }, this),
                onDelete: _.bind(function (attachment, callback) {
                    if (attachment.id > 0) {
                        attachment.set('delete', true);
                    } else {
                        attachment.destroy();
                    }

                    this.model.isDirty = true;
                    callback();
                }, this)
            });
        }

        if (this.customFields && _.size(this.customFields.models) > 0) {
            this.customFieldsForm = new PJQ.views.customFields.CustomFieldsForm({
                el: this.$('.receivable-invoice-custom-fields'),
                collection: this.customFields,
                fieldValues: this.model.get('customFieldValues'),
                isEdit: this.options.canEdit,
                isAdmin: this.options.isAdmin,
            });
        }
    },
    renderLineItems() {
        if (this.lineItemsView) {
            this.lineItemsView.remove();
        }

        this.lineItemsView = new PJQ.views.budget.LineItemsView({
            el: this.$('.invoice-line-items'),
            model: this.model,
            collection: this.model.lineItems,
            lineItemModel: PJQ.models.invoicing.ReceivableInvoiceLineItem,
            canEdit: this.options.canEdit && this.options.canEditLineItems,
            canDelete: this.options.canEdit && this.options.canEditLineItems,
            canImportBudget: false,
            enableStoredMaterials: this.settings.get('enableStoredMaterials'),
            enableRetainage: this.settings.get('enableRetainage'),
            enableSelection: this.options.canEdit && this.options.canEditLineItems,
            enableTax: true,
            showSubTotal: true,
            showGrandTotal: true,
            onLineItemChange: _.bind(function () {
                this.model.isDirty = true;
            }, this),
            onLineItemAdd: _.bind(function () {
                this.model.isDirty = true;
                this.updateCounts();
            }, this),
            onLineItemDelete: _.bind(function () {
                this.model.isDirty = true;
                this.updateCounts();
            }, this),
            onPrimeContractView: _.bind(function () {
                this.removeModal();
            }, this),
            onChangeOrderView: _.bind(function () {
                this.removeModal();
            }, this),
        });
    },
    pullERPPayments: function () {
        if (this.model.isERPSynced() && this.erpIntegration.hasAvailableAction(PJQ.constants.integrations.actions.PULL_RECEIVABLE_PAYMENTS)) {
            this.erpIntegration.pullReceivableInvoicePayments(this.model, (res) => {
                PJQ.notifications.notify.successNotify({
                    message: 'Payments successfully pulled from ERP'
                });

                this.model.payments.reset(res);
                this.renderPayments();
            });
        }
    },
    renderPayments: function () {
        if (this.model.isNew()) {
            return;
        }

        this.paymentsDataTable = new PJQ.views.dataTables.DataTable({
            el: this.$('.invoice-payments'),
            data: this.model.payments.models,
            isHideSearch: true,
            language: {
                emptyTable: 'No Payments have been created yet',
                zeroRecords: "No Payments matched the search criteria"
            },
            paging: false,
            order: [],
            columns: [{
                "columnData": "",
                "data": null,
                "title": "",
                "width": "20px",
                "orderable": false,
                "searchable": false,
                "defaultContent": '',
                "render": function (data, type, row) {
                    let exObj = row.get('externalObject');
                    if (exObj == null) {
                        return '';
                    }

                    return PJQ.helpers.erp.getERPBadge(exObj.status, exObj);
                }
            }, {
                "title": "#",
                "data": "attributes.number",
                "render": _.bind(function (data, type, row) {
                    return '<a href="javascript:void(0)" class="btn-view-payment">' + data + '</a>'
                }, this)
            },
                {
                    "title": 'Received',
                    "data": "",
                    "render": _.bind(function (data, type, row) {
                        let dateReceived = row.get('dateReceived');
                        if (_.size(dateReceived) === 0) {
                            return '';
                        }

                        return PJQ.helpers.dateHelpers.getDateString(new Date(dateReceived), PJQ.helpers.dateHelpers.dateFormats.DATE, true);
                    }, this)
                },
                {
                    "data": "attributes.amount",
                    "title": "Amount",
                    "render": _.bind(function (data, type, row) {
                        return PJQ.helpers.formatHelpers.formatCurrency(row.get('amount'));
                    }, this)
                },
                {
                    "data": "",
                    "title": "",
                    "orderable": false,
                    "searchable": false,
                    "width": "80px",
                    "render": _.bind(function (data, type, row) {
                        let html = '<div class="text-align-right show-on-row-hover">'
                        if (this.options.canViewInvoices) {
                            html += '<button type="button" class="btn btn-info btn-view-payment ht-30p wd-35p ml-1 fs-14"><span class="fal fa-pencil"></span></button>'
                        }
                        return html + '</div>';
                    }, this)
                }],
            dom: '<"top"<"clear">>rt<"bottom"p<"clear">>',
            contextMenuOptions: {
                actions: [
                    {
                        name: 'View',
                        onClick: _.bind(function (row) {
                            this.viewPayment(row.data());
                        }, this),
                        isShown: _.bind(function (row) {
                            return this.options.canViewInvoices;
                        }, this)
                    }
                ]
            },
            onRowDoubleClick: _.bind(function (row) {
                this.viewPayment(row.data());
            }, this)
        });
    },
    newPayment: function () {
        this.viewPayment();
    },
    viewPaymentClicked: function (e) {
        let target = $(e.currentTarget),
            row = this.paymentsDataTable.getRow(target.closest('tr'));
        this.viewPayment(row.data());
    },
    viewPayment: function (payment) {
        this.removeModal();
        new PJQ.views.invoicing.InvoicePaymentModal({
            model: payment,
            invoice: this.model,
            onSave: _.bind(function (payment, isNew) {
                if (isNew) {
                    this.model.payments.add(payment);
                    this.paymentsDataTable.addRow(payment);
                }
                this.updateCounts();

                if (typeof this.options.onSave === 'function') {
                    this.options.onSave(this.model);
                }
            }, this),
            onDelete: _.bind(function () {
                this.updateCounts();

                if (typeof this.options.onSave === 'function') {
                    this.options.onSave(this.model);
                }
            }, this)
        });
    },
    viewPrimeContract: function () {
        this.removeModal();
        new PJQ.views.primeContracts.PrimeContractEditModal({
            model: new PJQ.models.primeContracts.PrimeContract({
                id: this.model.get('primeContractId')
            }),
            onSave: () => {
                if (typeof this.options.onSave === 'function') {
                    this.options.onSave(this.model);
                }
            },
            onDelete: () => {
                if (typeof this.options.onDelete === 'function') {
                    this.options.onDelete(this.model);
                }
            }
        });
    },
    checkFieldVisible: function (fieldName) {
        if (this.coreFieldSettings) {
            let fieldSettings = this.coreFieldSettings.findWhere({fieldName: fieldName});
            if (fieldSettings != null) {
                return fieldSettings.get('isVisible');
            }
        }
        return true;
    },
    checkFieldRequired: function (fieldName) {
        if (this.coreFieldSettings) {
            let fieldSettings = this.coreFieldSettings.findWhere({fieldName: fieldName});
            if (fieldSettings != null) {
                return fieldSettings.get('isRequired');
            }
        }
        return false;
    },
    viewHistory: async function () {
        let historyItems = [{
            date: this.model.get('createdOn'),
            person: this.model.get('createdBy'),
            action: 'Invoice Created'
        }];

        let history = new PJQ.collections.invoicing.ReceivableInvoiceHistory({}, {
            invoiceId: this.model.id
        });
        new PJQ.views.history.HistoryTimelineModal({
            collection: history,
            subTitle: 'Receivable Invoice #' + this.model.get('number'),
            items: historyItems
        });
    },
    exportInvoice: function () {
        let callback = () => {
            PJQ.files.downloadFile(PJQ.helpers.urlHelpers.generateEndpoint([
                {
                    endpoint: 'receivableinvoices',
                    value: this.model.get('id')
                },
                {
                    endpoint: 'export',
                }
            ]), {isAPIv2: true});
        };
        if (this.options.canEdit && this.model.hasChanged()) {
            this.save(callback);
        } else {
            callback();
        }
    },
    delete: function () {
        new PJQ.views.modals.DeleteCancel({
            header: "Delete Invoice",
            body: "Are you sure you want to delete this Invoice?",
            onDelete: _.bind(function () {
                if (typeof this.options.onDelete === 'function') {
                    this.options.onDelete(this.model);
                }
                this.model.destroy({
                    success: _.bind(function () {
                        PJQ.notifications.notify.successNotify({
                            message: 'Invoice successfully deleted'
                        });
                        this.removeModal();
                    }, this)
                });
            }, this)
        });
    },
    validate: function () {
        let isValid = true;
        this.periodStartPicker.hideError();
        this.periodEndPicker.hideError();
        this.dueDatePicker.hideError();

        if (this.model.get('startDate') == null) {
            isValid = false;
            this.periodStartPicker.showError();
        }
        if (this.model.get('endDate') == null) {
            isValid = false;
            this.periodEndPicker.showError();
        }
        if (this.model.get('billingDate') == null) {
            isValid = false;
            this.dueDatePicker.showError();
        }
        if (this.customFieldsForm != null && !this.customFieldsForm.validate()) {
            isValid = false;
        }

        if (this.checkFieldRequired('number')) {
            let $number = this.$('.invoice-number');
            PJQ.helpers.inputHelpers.setInputError($number, true);
            if (_.size(this.model.get('number')) === 0) {
                PJQ.helpers.inputHelpers.setInputError($number, false);
                isValid = false;
            }
        }

        if (this.checkFieldRequired('notes')) {
            let $notes = this.$('.invoice-notes');
            PJQ.helpers.inputHelpers.setInputError($notes, true);
            if (_.size(this.model.get('notes')) === 0) {
                PJQ.helpers.inputHelpers.setInputError($notes, false);
                isValid = false;
            }
        }

        if (this.checkFieldRequired('attachments')) {
            this.fileUploader.clearError();
            let hasValidAttachment = _.find(this.model.attachments.models, function (model) {
                return !model.get('delete')
            }, this) != null;

            if (!hasValidAttachment) {
                this.fileUploader.showError('Missing attachment', 100000);
                isValid = false;
            }
        }

        if (!isValid && this.options.activeView !== 'general') {
            this.options.activeView = 'general';
            this.$('.nav-tabs a[href="#I_General"]').tab('show');
        }

        return isValid;
    },
    saveEmail: function () {
        let isNew = this.model.isNew();
        this.save((success) => {
            if (success) {
                let notifyText = isNew ? 'Invoice created successfully' : 'Invoice saved successfully';
                PJQ.notifications.notify.successNotify({
                    message: notifyText
                });

                this.email();
            }
        });
    },
    saveInvoice: function () {
        let isNew = this.model.isNew();
        this.save((success) => {
            if (success) {
                let notifyText = isNew ? 'Invoice created successfully' : 'Invoice saved successfully';
                PJQ.notifications.notify.successNotify({
                    message: notifyText
                });

                if (!isNew) {
                    this.removeModal()
                }
            }
        });
    },
    save: function (callback) {
        if (!this.validate()) {
            this.$('.modal').prevObject.scrollTop(0);
            if (typeof callback === 'function') {
                callback(false);
            }
            return;
        }

        this.model.save({
            customFields: this.customFieldsForm != null ? this.customFieldsForm.getChanged() : null,
            lineItems: this.model.lineItems.toJSON()
        }, {
            success: () => {
                this.render();
                if (typeof this.options.onSave === 'function') {
                    this.options.onSave(this.model);
                }

                PJQ.app.session.project.trigger('receivableInvoiceChanged', this.model);
                if (typeof callback === 'function') {
                    callback(true);
                }
            },
            error: () => {
                if (typeof callback === 'function') {
                    callback(false);
                }
                PJQ.notifications.notify.errorNotify({
                    message: "Encountered an error while saving this Invoice. Please contact customer service."
                });
            }
        });
    },
    email: function () {
        let projectName = this.options.project?.get('projectName')?.trim();
        let subject = `An invoice has been shared with you ${projectName && _.size(projectName) > 0 ? `for ${projectName}` : ''}`;
        new PJQ.views.email.ComposeEmailModal({
            header: "Email Invoice",
            project: PJQ.app.session.project,
            subject: subject,
            onSave: _.bind(function (data) {
                this.model.share(data, _.bind(function () {
                    PJQ.notifications.notify.successNotify({
                        message: 'Invoice email sent'
                    });
                }, this));
            }, this)
        });
    },
    updatePaid: function (e) {
        this.model.set('paid', $(e.currentTarget).prop('checked'));
        if (!this.options.canEdit && this.options.isAdmin) {
            this.save(() => {
                PJQ.notifications.notify.successNotify({
                    message: 'Invoice saved successfully'
                });
            });
        }
    },
    close: function () {
        if (this.model.hasChanged() && this.options.canEdit) {
            new PJQ.views.modals.SaveDontSave({
                header: "Unsaved Changes",
                body: "Do you want to save changes?",
                onSave: _.bind(function () {
                    this.saveInvoice();
                    this.removeModal();
                }, this),
                onDontSave: _.bind(function () {
                    this.removeModal();
                }, this)
            });
        } else {
            this.removeModal();
        }
    }
});
PJQ.views.invoicing.ReceivableInvoicesList = PJQ.views.BaseView.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.INVOICING, 'receivable-invoices-list'),
        invoiceId: null
    },
    events: {
        'click .btn-settings': 'editSettings',
        'click .btn-create-invoice': 'createInvoice',
        'click .btn-delete-invoice': 'deleteInvoiceClicked',
        'click .btn-export': 'exportList'
    },
    beforeFirstRender: async function () {
        this.isFetched = false;
        this.options.canViewCommitments = PJQ.app.session.project.hasPermission('commitments.canView');
        this.options.isAdmin = PJQ.app.session.project.hasPermission('receivableInvoices.isAdmin');

        if (this.collection == null) {
            this.collection = new PJQ.collections.invoicing.ReceivableInvoices(null, {
                project: PJQ.app.session.project,
                costCodeId: this.options.costCodeId ? this.options.costCodeId : null,
                costTypeId: this.options.costTypeId ? this.options.costTypeId : null
            });
        }

        if (!this.collection.isFetched) {
            await this.collection.fetch();
        }

        this.customFields = await this.options.project.fetchReceivableInvoiceCustomFields();
        this.userSettings = await PJQ.app.session.fetchReceivableInvoiceUserSettings();
        this.billingPeriodSettings = await this.options.project.fetchBillingPeriodSettings();
        this.erpIntegration = await PJQ.app.session.fetchERPIntegration();

        this.isFetched = true;
        this.render();
    },
    renderData: function () {
        return {
            collection: this.collection,
            isFetched: this.isFetched
        }
    },
    afterRender: function () {
        if (!this.isFetched) {
            return;
        }

        this.renderView();

        PJQ.app.session.project.off('receivableInvoiceChanged');
        PJQ.app.session.project.on('receivableInvoiceChanged', function (invoice) {
            this.collection.add(invoice);
            this.render();
        }, this);

        if (this.options.invoiceId > 0) {
            let initInvoice = this.collection.get(this.options.invoiceId);
            if (initInvoice != null) {
                this.viewInvoice(initInvoice);
                this.options.invoiceId = null;
            }
        } else if (this.options.paymentId > 0) {
            let initPayment = new PJQ.models.invoicing.ReceivableInvoicePayment({
                id: this.options.paymentId
            });

            new PJQ.views.invoicing.InvoicePaymentModal({
                model: initPayment
            });
        }
    },
    renderView: function () {
        if (this.dataTable) {
            this.dataTable.remove();
            this.dataTable = null;
        }

        this.dataTable = this.getDataTableInstance();
    },
    getDataTableInstance: function () {
        return new PJQ.views.invoicing.ReceivableInvoiceDataTable({
            el: this.$('.invoices-table'),
            rowId: "cid",
            data: this.collection.models,
            onPageSizeChange: function (value) {
                // PJQ.helpers.cookieHelpers.setCookie(PJQ.constants.cookies.RFI_PAGE_LENGTH, value);
            },
            isAdmin: this.options.isAdmin,
            statusIds: this.options.statusIds,
            showAllBillingPeriods: this.options.showAllBillingPeriods,
            headerData: _.bind(function () {
                return {
                    billingPeriods: this.billingPeriodSettings ? this.billingPeriodSettings.billingPeriods : null,
                    project: this.options.project,
                    canAdd: this.options.canAdd,
                    isAdmin: this.options.isAdmin
                };
            }, this),
            groups: this.groups,
            costTypes: this.costTypes,
            unitsOfMeasure: this.unitsOfMeasure,
            userSettings: this.userSettings,
            billingPeriodSettings: this.billingPeriodSettings,
            canViewCommitments: this.options.canViewCommitments,
            settings: this.userSettings.getSettings(PJQ.constants.invoicing.view.RECEIVABLE_INVOICES),
            order: [[1, 'asc']],
            colReorder: {
                fixedColumnsRight: 1,
                realtime: false
            },
            columnOrderChanged: () => {
                this.userSettings.save();
            },
            onViewInvoice: (invoice) => {
                this.viewInvoice(invoice);
            },
            onRowDoubleClick: (row) => {
                this.viewInvoice(row.data());
            },
            contextMenuOptions: {
                actions: [
                    {
                        name: 'View',
                        onClick: _.bind(function (row) {
                            this.viewInvoice(row.data());
                        }, this)
                    }
                ]
            }
        });
    },
    createInvoice: function () {
        this.viewInvoice();
    },
    viewInvoice: function (invoice) {
        let isNew = invoice == null
        this.invoiceEditor = new PJQ.views.invoicing.EditReceivableInvoiceModal({
            model: invoice,
            primeContract: this.model,
            onSave: (invoice) => {
                if (isNew) {
                    this.collection.add(invoice);
                }
                this.renderView();
            },
            onDelete: (invoice) => {
                this.collection.remove(invoice);
                this.renderView();
            }
        });
    },
    deleteInvoiceClicked: function (e) {
        let target = $(e.currentTarget),
            row = this.dataTable.getRow(target.closest('tr'));
        this.deleteInvoice(row);
    },
    deleteInvoice: function (row) {
        if (row != null) {
            let invoice = row.data();
            if (invoice != null) {
                new PJQ.views.modals.DeleteCancel({
                    header: "Delete Invoice",
                    body: "Are you sure you want to delete this Invoice?",
                    onDelete: _.bind(function () {
                        invoice.destroy({
                            success: _.bind(function () {
                                this.dataTable.removeRow(row);
                                if (typeof this.options.onDelete === 'function') {
                                    this.options.onDelete(invoice);
                                }
                            }, this)
                        });
                    }, this)
                });
            }
        }
    },
    editSettings: function () {
        new PJQ.views.invoicing.ReceivableInvoiceSettingsModal({
            invoicesView: this,
            onSave: _.bind(function () {
                this.renderView();
                PJQ.notifications.notify.successNotify({
                    message: 'Settings updated successfully'
                });
            }, this)
        });
    },
    exportList: function () {
        PJQ.files.downloadFile(PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'projects',
                value: PJQ.app.session.project.id
            },
            {
                endpoint: 'receivableinvoices'
            },
            {
                endpoint: 'export'
            }
        ], [
            {
                parameter: 'timeZoneOffset',
                value: new Date().getTimezoneOffset()
            }
        ]), {isAPIv2: true});
    }
});

PJQ.views.invoicing.ModalViewReceivableInvoices = PJQ.views.BaseModal.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.INVOICING, 'modal-view-receivable-invoices'),
        maxWidth: 1000,
        isShowCloseButton: true,
        onSave: _.noop,
        isAdmin: true
    },
    events: {},
    beforeModalCreated: function () {

    },
    renderData: function () {
        return {
            model: this.model
        }
    },
    afterRender: function () {
        if (this.model != null) {
            new PJQ.views.invoicing.ReceivableInvoicesList({
                el: this.$('.modal-body'),
                model: this.model,
                costCodeId: this.model.get('costCodeId'),
                costTypeId: this.model.get('costTypeId'),
                statusIds: this.options.statusIds,
                showAllBillingPeriods: this.options.showAllBillingPeriods,
                project: this.options.project
            })
        }
    },
});
//Models
PJQ.models.invoicing.ReceivableInvoice = PJQ.models.invoicing.Invoice.extend({
    endpoint: function () {
        let arr = [];
        if (this.isNew()) {
            arr.push({
                endpoint: 'projects',
                value: this.get('projectId')
            });
        }
        return PJQ.helpers.urlHelpers.generateEndpoint([...arr, {
            endpoint: 'receivableinvoices',
            value: this.id
        }]);
    },
    parse: function (model) {
        if (!model)
            return model;

        this.lineItems = new PJQ.collections.invoicing.ReceivableInvoiceLineItems(model.lineItems);
        this.attachments = new PJQ.collections.invoicing.ReceivableInvoiceAttachments(model.attachments);
        this.payments = new PJQ.collections.invoicing.ReceivableInvoicePayments(model.payments);

        if (model.client) {
            if (model.client instanceof PJQ.models.BaseModel) {
                this.client = model.client;
            } else {
                this.client = new PJQ.models.contacts.Contact(model.client);
            }
        }

        return model;
    },
    syncERP: function(callback) {
        new PJQ.ajax.Request({
            endpoint: this.endpoint() + '/syncerp',
            isAPIv2: true,
        }).post().done(_.bind(function (res) {
            if(res && _.size(res.externalId) > 0){
                this.set('externalObject', res);
            }
            if(typeof callback === 'function'){
                callback(res);
            }
        }, this)).fail(_.bind(function (xhr, err, result) {
            if(typeof callback === 'function'){
                callback(null);
            }
        }, this));
    },
    unlinkERP: function (callback) {
        new PJQ.ajax.Request({
            endpoint: this.endpoint() + '/unlinkerp',
            isAPIv2: true,
        }).post().done(_.bind(function () {
            this.set('externalObject', null);
            if (typeof callback === 'function') {
                callback(true);
            }
        }, this)).fail(_.bind(function (xhr) {
            if (typeof callback === 'function') {
                let err;
                if (xhr.responseJSON != null) {
                    err = xhr.responseJSON.type;
                } else {
                    err = null;
                }
                callback(false, err);
            }
        }, this));
    },
    makeERPUrl: function(integration){
        let externalId = this.externalId();
        if(_.size(externalId) === 0){
            return '';
        }

        switch(integration.get('name')){
            case PJQ.constants.integrations.providers.QBO.name:
                return 'https://app.sandbox.qbo.intuit.com/app/invoice?txnId=' + externalId;
            default:
                return '';
        }
    },
    getAutofillAmounts: function(callback) {
        let fnCallback = _.bind(function () {
            if (typeof callback === 'function') {
                callback(this.autofillLineItems);
            }
        }, this)
        if (this.autofillLineItems != null) {
            fnCallback();
        } else {
            new PJQ.ajax.Request({
                endpoint: this.endpoint() + '/lineitems/autofill',
                isAPIv2: true
            }).get().done(_.bind(function (response) {
                this.autofillLineItems = new PJQ.collections.invoicing.InvoiceLineItems(response);
                fnCallback();
            }, this)).fail(_.bind(function () {
                fnCallback();
            }, this));
        }
    },
    share: function (data, callback) {
        new PJQ.ajax.Request({
            endpoint: this.endpoint() + '/email',
            isAPIv2: true,
            data: {
                subject: data != null ? data.subject : null,
                body: data != null ? data.body : null,
                toEmails: data != null ? data.toEmails : null,
                ccEmails: data != null ? data.ccEmails : null,
            }
        }).post().done(_.bind(function (response) {
            callback();
        }, this)).fail(_.bind(function (xhr, err, result) {
            //todo: error
        }, this));
    }
});

PJQ.models.invoicing.ReceivableInvoiceHistoryItem = PJQ.models.BaseModel.extend({
    defaults: {
        isAPIv2: true
    },
    actionNames: {
        'status': 'Status Changed',
        'email': 'Email Sent'
    },
    getActionName: function () {
        return this.actionNames[this.get('action')] ?? this.get('action');
    },
    getDescription: function () {
        switch (this.get('action')) {
            case 'status':
                let fromStatus = this.get('data').from,
                    toStatus = this.get('data').to;
                if (fromStatus == null || toStatus == null) {
                    return '';
                }

                return '' + PJQ.constants.invoicing.receivableInvoiceStatusNames[fromStatus] + '<i class="fal fa-arrow-right ml-1 mr-1 fs-14"></i>' + PJQ.constants.invoicing.receivableInvoiceStatusNames[toStatus];
            case 'email':
                let to = this.get('data').to;
                if (_.size(to) === 0) {
                    return '';
                }

                return 'To: ' + to.join(', ');
            default:
                return '';
        }
    }
});

PJQ.models.invoicing.ReceivableInvoiceLineItem = PJQ.models.invoicing.InvoiceLineItem.extend();

PJQ.models.invoicing.ReceivableInvoiceAttachment = PJQ.models.files.File.extend({
    defaults: {
        isAPIv2: true
    },
    idAttribute: 'id'
});

PJQ.models.invoicing.ReceivableInvoiceCustomField = PJQ.models.customFields.CustomField.extend({
    defaults: {
        isAPIv2: true
    },
    idAttribute: 'id',
    endpoint: function () {
        return PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'receivableinvoices'
            },
            {
                endpoint: 'customfields',
                value: this.get('id')
            }
        ]);
    }
});

PJQ.models.invoicing.ReceivableInvoiceSettings = PJQ.models.budget.Settings.extend({
    defaults: {
        isAPIv2: true
    },
    idAttribute: 'settingId',
    endpoint: function () {
        return PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'receivableinvoices'
            },
            {
                endpoint: 'settings'
            }
        ]);
    }
});

PJQ.models.invoicing.ReceivableInvoiceUserSettings = PJQ.models.BaseModel.extend({
    defaults: {
        isAPIv2: true
    },
    idAttribute: 'settingId',
    endpoint: function () {
        return PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'receivableinvoices'
            },
            {
                endpoint: 'settings'
            },
            {
                endpoint: 'user'
            }
        ]);
    },
    getSettings: function (view) {
        return _.find(this.attributes.viewSettings, _.bind(function (setting) {
            return setting.view === view;
        }, this));
    }
});

PJQ.models.invoicing.ReceivableInvoiceFieldSetting = PJQ.models.BaseModel.extend({
    defaults: {
        isAPIv2: true
    },
    idAttribute: 'settingId',
    endpoint: function () {
        return PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'settings'
            },
            {
                endpoint: 'fields',
                value: this.id ? this.id : 'receivableinvoices'
            }
        ]);
    }
});

PJQ.models.invoicing.ReceivableInvoicePayment = PJQ.models.BaseModel.extend({
    defaults: {
        isAPIv2: true
    },
    endpoint: function () {
        let arr = [];
        if (this.isNew()) {
            arr.push({
                endpoint: 'projects',
                value: this.get('projectId')
            });
        }
        return PJQ.helpers.urlHelpers.generateEndpoint([...arr, {
            endpoint: 'receivableinvoicepayments',
            value: this.id
        }]);
    },
    parse: function (model) {
        if (!model)
            return model;

        this.attachments = new PJQ.collections.invoicing.ReceivableInvoiceAttachments(model.attachments);

        if (model.client) {
            if (model.client instanceof PJQ.models.BaseModel) {
                this.client = model.client;
            } else {
                this.client = new PJQ.models.contacts.Contact(model.client);
            }
        } else {
            this.client = null;
        }

        return model;
    },
    beforeSave: function () {
        this.set({
            attachments: this.attachments.toJSON()
        });
    },
    syncERP: function(callback) {
        new PJQ.ajax.Request({
            endpoint: this.endpoint() + '/syncerp',
            isAPIv2: true,
        }).post().done(_.bind(function (res) {
            if(res && _.size(res.externalId) > 0){
                this.set('externalObject', res);
            }
            if(typeof callback === 'function'){
                callback(res);
            }
        }, this)).fail(_.bind(function (xhr, err, result) {
            if(typeof callback === 'function'){
                callback(null);
            }
        }, this));
    },
    unlinkERP: function (callback) {
        new PJQ.ajax.Request({
            endpoint: this.endpoint() + '/unlinkerp',
            isAPIv2: true,
        }).post().done(_.bind(function () {
            this.set('externalObject', null);
            if (typeof callback === 'function') {
                callback(true);
            }
        }, this)).fail(_.bind(function (xhr) {
            if (typeof callback === 'function') {
                let err;
                if (xhr.responseJSON != null) {
                    err = xhr.responseJSON.type;
                } else {
                    err = null;
                }
                callback(false, err);
            }
        }, this));
    }
});

PJQ.models.invoicing.ReceivableInvoicePaymentAttachment = PJQ.models.files.File.extend({
    defaults: {
        isAPIv2: true
    },
    idAttribute: 'id'
});

//Collections
PJQ.collections.invoicing.ReceivableInvoices = PJQ.collections.invoicing.Invoices.extend({
    defaults: {
        isAPIv2: true
    },
    model: PJQ.models.invoicing.ReceivableInvoice,
    endpoint: function () {
        let params = [];
        if (this.options.costCodeId && this.options.costTypeId) {
            params.push({
                parameter: 'costCodeId',
                value: this.options.costCodeId
            }, {
                parameter: 'costTypeId',
                value: this.options.costTypeId
            });
        }

        if (this.options.primeContract != null) {
            return PJQ.helpers.urlHelpers.generateEndpoint([
                {
                    endpoint: 'receivableinvoices',
                    value: this.options.primeContract.id
                }
            ]);
        } else {
            return PJQ.helpers.urlHelpers.generateEndpoint([
                {
                    endpoint: 'projects',
                    value: this.options.project.get('projectId')
                },
                {
                    endpoint: 'receivableinvoices'
                }
            ], params);
        }
    },
    getTotalAmountsByStatus: function () {
        let result = {};
        result[PJQ.constants.invoicing.receivableInvoiceStatus.DRAFT] = 0;
        result[PJQ.constants.invoicing.receivableInvoiceStatus.REVIEWING] = 0;
        result[PJQ.constants.invoicing.receivableInvoiceStatus.APPROVED] = 0;
        result[PJQ.constants.invoicing.receivableInvoiceStatus.COMPLETE] = 0;
        result[PJQ.constants.invoicing.receivableInvoiceStatus.REVISE] = 0;
        _.each(this.models, function (invoice) {
            result[invoice.get('statusId')] += invoice.get('totalAmount');
        });
        return result;
    },
    getPayments: function(){
        let result = [];
        _.each(this.models, function(invoice){
            result.push(...invoice.payments.models);
        })
        return result;
    }
});

PJQ.collections.invoicing.ReceivableInvoiceHistory = PJQ.collections.BaseCollection.extend({
    defaults: {
        isAPIv2: true
    },
    model: PJQ.models.invoicing.ReceivableInvoiceHistoryItem,
    endpoint: function () {
        return PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'receivableinvoices',
                value: this.options.invoiceId
            },
            {
                endpoint: 'history'
            }
        ]);
    }
});

PJQ.collections.invoicing.ReceivableInvoiceLineItems = PJQ.collections.invoicing.InvoiceLineItems.extend({
    defaults: {
        isAPIv2: true
    },
    model: PJQ.models.invoicing.ReceivableInvoiceLineItem
});

PJQ.collections.invoicing.ReceivableInvoiceAttachments = PJQ.collections.files.Files.extend({
    defaults: {
        isAPIv2: true
    },
    model: PJQ.models.invoicing.ReceivableInvoiceAttachment,
    endpoint: function () {
        return PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'receivableinvoices',
                value: this.options.invoiceId
            },
            {
                endpoint: 'attachments'
            }
        ]);
    }
});

PJQ.collections.invoicing.ReceivableInvoiceCustomFields = PJQ.collections.BaseCollection.extend({
    defaults: {
        isAPIv2: true
    },
    model: PJQ.models.invoicing.ReceivableInvoiceCustomField,
    endpoint: function () {
        let arr = [];
        if (this.options.projectId > 0) {
            arr.push({
                endpoint: 'projects',
                value: this.options.projectId
            });
        }
        arr.push(...[
            {
                endpoint: 'receivableinvoices'
            },
            {
                endpoint: 'customfields'
            }
        ]);
        return PJQ.helpers.urlHelpers.generateEndpoint(arr);
    }
});

PJQ.collections.invoicing.ReceivableInvoiceCustomFieldChoices = PJQ.collections.BaseCollection.extend({
    defaults: {
        isAPIv2: true
    },
    model: PJQ.models.invoicing.ReceivableInvoiceCustomFieldChoice
});

PJQ.collections.invoicing.ReceivableInvoiceFieldSettings = PJQ.collections.BaseCollection.extend({
    defaults: {
        isAPIv2: true
    },
    model: PJQ.models.invoicing.ReceivableInvoiceFieldSetting,
    endpoint: function () {
        return PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'settings'
            },
            {
                endpoint: 'fields',
                value: 'receivableinvoices'
            }
        ]);
    }
});

PJQ.collections.invoicing.ReceivableInvoicePayments = PJQ.collections.BaseCollection.extend({
    defaults: {
        isAPIv2: true
    },
    model: PJQ.models.invoicing.ReceivableInvoicePayment,
    endpoint: function () {
        if (this.options.invoiceId > 0) {
            return PJQ.helpers.urlHelpers.generateEndpoint([
                {
                    endpoint: 'receivableinvoices',
                    value: this.options.invoiceId
                },
                {
                    endpoint: 'payments'
                }
            ]);
        } else {
            return PJQ.helpers.urlHelpers.generateEndpoint([
                {
                    endpoint: 'projects',
                    value: this.options.project.get('projectId')
                },
                {
                    endpoint: 'receivableinvoicepayments'
                }
            ]);
        }
    },
});

PJQ.collections.invoicing.ReceivableInvoicePaymentAttachments = PJQ.collections.files.Files.extend({
    defaults: {
        isAPIv2: true
    },
    model: PJQ.models.invoicing.ReceivableInvoicePaymentAttachment,
    endpoint: function () {
        return PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'receivableinvoicepayments',
                value: this.options.paymentId
            },
            {
                endpoint: 'attachments'
            }
        ]);
    }
});
PJQ.views.invoicing.ReceivableInvoiceSettingsModal = PJQ.views.BaseModal.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.INVOICING, 'modal-receivable-invoice-settings'),
        minWidth: '600px',
    },
    events: {
        'change .select-column': 'columnSelected',
        'click .btn-edit-company-default': 'editCompanySettings',
        'click button.settings-save': 'onSave'
    },
    beforeModalCreated: function () {
        this.userSettings = this.options.invoicesView.userSettings;
    },
    beforeRender: function () {
        // copy userSettings for our UI; we only update global userSettings object on save.
        this.options.userSettings = [];

        this.options.defaultStatusFilter = this.userSettings.get('defaultStatusFilter');
        _.each(this.userSettings.attributes.viewSettings, _.bind(function (setting) {
            let columns = this.options.invoicesView.dataTable.getColumns(true),
                selectedColumns = (_.size(setting.columns) > 0) ? setting.columns : setting.columnsDefault;
            _.each(columns, _.bind(function (column) {
                column.visible = selectedColumns.indexOf(column.columnData) !== -1
            }, this));

            this.options.userSettings.push({
                view: setting.view,
                rowsPerPage: setting.rowsPerPage,
                columns: columns
            });
        }, this));
    },
    renderData: function () {
        return {
            userSettings: this.userSettings
        }
    },
    afterRender: function () {
        this.defaultFilterSelectPicker = new PJQ.inputs.Selectpicker({
            el: this.$('.select-filter-default'),
            isIntChoices: true,
            isMultiple: true,
            defaultValue: this.userSettings.get('defaultStatusFilter'),
            onChange: _.bind(function (value) {
                this.options.defaultStatusFilter = value
            }, this)
        });

        this.rowsPerPage = new PJQ.inputs.Selectpicker({
            el: this.$('select.rows-per-page'),
            isIntChoices: true,
            onChange: _.bind(function (value) {
                this.currentView.rowsPerPage = value;
            }, this)
        });

        this.selectView(PJQ.constants.invoicing.view.RECEIVABLE_INVOICES);
    },
    editCompanySettings: function () {
        this.userSettings = new PJQ.models.invoicing.ReceivableInvoiceUserSettings(null, {
            forCompany: true
        });
        this.userSettings.fetch({
            success: _.bind(function () {
                this.render();
            }, this)
        });
    },
    selectView: function (view) {
        this.currentView = _.find(this.options.userSettings, _.bind(function (setting) {
            return setting.view === view;
        }, this));

        if (view.indexOf('-') === -1) {
            this.rowsPerPage.setValue(this.currentView.rowsPerPage);
            this.$('div.rows-per-page').show();
        }
        else
            this.$('div.rows-per-page').hide();

        if (this.dataTable) {
            this.dataTable.undelegateEvents();
            $(this.dataTable.el).empty();
        }

        this.dataTable = new PJQ.views.dataTables.DataTable({
            el: this.$('div.select-columns-datatable'),
            data: this.currentView.columns,
            isHideSearch: true,
            pageLength: 6,
            order: [],
            columns: [
                {"data": "title", "title": "Column", "orderable": false},
                {
                    "data": "visible",
                    "title": "Show",
                    "orderable": false,
                    "searchable": false,
                    "render": _.bind(function (data) {
                        return ('<div class="text-align-center"><div class="pretty p-default p-smooth fs-18 m-0"><input type="checkbox"' + (data ? ' checked ' : '') + 'class="select-column"/><div class="state p-primary"><label class="wd-0">&nbsp;</label></div></div></div>');
                    }, this),
                    "width": '10%'
                }
            ],
            dom: '<"top"<"clear">>rt<"bottom"p<"clear">>'
        });

    },
    columnSelected: function (sender) {
        this.dataTable.dataTable.row($(sender.currentTarget).closest('tr')).data().visible = $(sender.currentTarget).prop('checked');
    },
    onSave: function () {
        let fnOnSave = _.bind(function () {
            if (typeof this.options.onSave === 'function')
                this.options.onSave();
            this.removeModal();
        }, this);

        this.userSettings.set('defaultStatusFilter', this.options.defaultStatusFilter);

        _.each(this.options.userSettings, _.bind(function (settingTemp) {
            _.each(this.userSettings.get('viewSettings'), _.bind(function (setting) {
                if (settingTemp.view === setting.view) {
                    setting.rowsPerPage = settingTemp.rowsPerPage;

                    let columns = _.size(setting.columns) > 0 ? setting.columns.slice() : setting.columnsDefault.slice();

                    // update columns
                    _.each(settingTemp.columns, _.bind(function (column) {
                        if (column.visible) {
                            if (columns.indexOf(column.columnData) === -1)
                                columns.push(column.columnData);
                        }
                        else {
                            if (columns.indexOf(column.columnData) !== -1)
                                columns = _.filter(columns, _.bind(function (columnTemp) {
                                    return columnTemp != column.columnData;
                                }, this));
                        }
                    }, this));

                    setting.columns = columns;
                }
            }, this));
        }, this));

        this.userSettings.save(null, {
            success: _.bind(function () {
                fnOnSave();
            }, this)
        });
    },
});